import React, { useState, useMemo } from "react";
import { StepUpSpinner } from "../../Components/Loader";
import {
  Box, Typography, Avatar, Chip, Button, CircularProgress,
  alpha, useTheme, Divider, IconButton, useMediaQuery,
  Select, MenuItem, FormControl, LinearProgress, Checkbox,
  Stack, Drawer,
  Menu, Popover, Badge, ListItemIcon, ListItemText, Tooltip,
  Tabs, Tab,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Routes, Route, useNavigate, useLocation, Navigate } from "react-router-dom";
import { to12Hour, formatTimeRange } from "../../utils/time";
import {
  useGetParentDashboardQuery, useGetChildClassesQuery, useGetChildAttendanceSummaryQuery,
  useGetChildAttendanceDetailQuery, useGetChildSubjectsQuery,
  useGetChildAssessmentsQuery, useGetChildPerformanceQuery,
  useGetChildAssignmentsQuery, useGetChildAssignmentDetailQuery,
  useGetChildReportCardsQuery,
  useGetChildDashboardQuery,
  useChangeUserPasswordSystemMutation,
  useGetNotificationQuery,
  useGetUnreadNotificationCountQuery,
  useMarkNotificationAsReadMutation,
  useGetFamilyInvoicesQuery, usePayFamilyInvoicesMutation,
  useGetParentMessagesQuery,
  useLazyGetParentMessageRecipientsQuery,
  useSendParentMessageMutation,
  useMarkParentMessageReadMutation,
} from "../../Api/attoDeskApi";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import CircleIcon from "@mui/icons-material/Circle";
import SearchIcon from "@mui/icons-material/Search";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { useNotifier } from "../../Core/Notifier";
import useUser from "../../Core/hook/useUser";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import ParentClassDetail from "../ClassDetail/ParentClassDetail";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ChildCareIcon from "@mui/icons-material/ChildCare";
import MenuIcon from "@mui/icons-material/Menu";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import AddIcon from "@mui/icons-material/Add";
import SendIcon from "@mui/icons-material/Send";
import CloseIcon from "@mui/icons-material/Close";
import EventNoteIcon from "@mui/icons-material/EventNote";
import ViewListIcon from "@mui/icons-material/ViewList";
import CalendarViewMonthIcon from "@mui/icons-material/CalendarViewMonth";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import PlaceIcon from "@mui/icons-material/Place";
import LaptopIcon from "@mui/icons-material/Laptop";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ReplayIcon from "@mui/icons-material/Replay";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import ParentHelpDrawer from "./ParentHelpDrawer";
import useCompany from "../../Core/hook/useCompany";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { TrendCard } from "../../Components/ChartPrimitives";
import { pp, greetingForHour, PP_C } from "./theme";
import BankSetupComplete from "./BankSetupComplete";
import {
  PortalCard, PortalKpi, PortalSectionHeader, PortalEmptyState,
  PortalStatusChip, ChildIdentityCard,
} from "./PortalPrimitives";

// Enable dayjs `.fromNow()` for notification timestamps. Extension must
// live below the import block so `import/first` stays happy.
dayjs.extend(relativeTime);

// ════════════════════════════════════════
// Shared State — selected child
// ════════════════════════════════════════

const ChildContext = React.createContext<{
  selectedChild: number | null;
  setSelectedChild: (id: number) => void;
  children: any[];
  activeChild: any;
}>({ selectedChild: null, setSelectedChild: () => {}, children: [], activeChild: null });

const useChild = () => React.useContext(ChildContext);

// ════════════════════════════════════════
// Nav
// ════════════════════════════════════════

const navItems = [
  { path: "/parent-portal", label: "Dashboard", icon: <DashboardOutlinedIcon />, exact: true },
  // Time Table = the existing calendar/list surface at /parent-portal/classes.
  // Route path unchanged to keep bookmarks + deep-links working; only the
  // visible label changes so parents see the client-preferred "Time Table"
  // wording in the hamburger drawer.
  { path: "/parent-portal/classes", label: "Time Table", icon: <SchoolOutlinedIcon /> },
  // Report Cards — parent-facing published report cards for the
  // selected child. Backed by /parent-portal/child-report-cards.
  { path: "/parent-portal/report-cards", label: "Report Cards", icon: <ArticleOutlinedIcon /> },
  { path: "/parent-portal/attendance", label: "Attendance", icon: <FactCheckOutlinedIcon /> },
  { path: "/parent-portal/subjects", label: "Subjects", icon: <MenuBookOutlinedIcon /> },
  { path: "/parent-portal/assessments", label: "Assessments", icon: <AssignmentTurnedInOutlinedIcon /> },
  { path: "/parent-portal/performance", label: "Performance", icon: <InsightsOutlinedIcon /> },
  { path: "/parent-portal/assignments", label: "Assignments", icon: <AssignmentOutlinedIcon /> },
  { path: "/parent-portal/payments", label: "Payments & Invoices", icon: <PaymentOutlinedIcon /> },
  { path: "/parent-portal/messages", label: "Messages", icon: <ChatOutlinedIcon /> },
  // Profile — Parent + Student information. Reads existing Parent
  // Portal data only (useUser + ChildContext); no new endpoint.
  { path: "/parent-portal/profile", label: "Profile & Account", icon: <PersonOutlineIcon /> },
];

// ════════════════════════════════════════
// Reusable Card
// ════════════════════════════════════════

const DashCard: React.FC<{ children: React.ReactNode; title: string; icon: React.ReactNode; color: string; action?: React.ReactNode }> = ({ children, title, icon, color, action }) => (
  <Box sx={{
    bgcolor: pp.color.card,
    borderRadius: `${pp.radius.md}px`,
    border: `1px solid ${pp.color.border}`,
    boxShadow: pp.shadow.card,
    overflow: "hidden",
    transition: pp.transition,
    "&:hover": { boxShadow: pp.shadow.cardHover, borderColor: pp.color.borderStrong },
  }}>
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2.5, py: 1.5, borderBottom: `1px solid ${pp.color.border}` }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
        <Box sx={{
          width: 28, height: 28, borderRadius: `${pp.radius.sm}px`,
          bgcolor: alpha(color, 0.1), color,
          display: "flex", alignItems: "center", justifyContent: "center",
          "& svg": { fontSize: 16 },
        }}>{icon}</Box>
        <Typography sx={{ fontSize: 14.5, fontWeight: 700, color: pp.color.text }}>{title}</Typography>
      </Box>
      {action}
    </Box>
    <Box sx={{ px: 2.5, py: 1.75 }}>{children}</Box>
  </Box>
);

// ════════════════════════════════════════
// Parent Portal — Header account controls (Aug 2026)
// Reuses the existing notification API (getNotification / count /
// markAsRead) and the app-wide logout convention
// (localStorage.removeItem("token") + hard nav to /login).
// Rendered inside both the workspace header and the dashboard header
// so the bell + account dropdown are always present in the top-right.
// ════════════════════════════════════════

/** Route a notification to the correct in-portal destination based on
 *  its notificationType. Falls back to opening the notifications
 *  dropdown alone if the type has no matching parent page.        */
const notificationDestination = (notificationType?: string): string | null => {
  const t = String(notificationType || "").toLowerCase();
  if (t.includes("message"))    return "/parent-portal/messages";
  if (t.includes("invoice") || t.includes("payment") || t.includes("billing"))
                                return "/parent-portal/payments";
  if (t.includes("attendance") || t.includes("absence") || t.includes("late"))
                                return "/parent-portal/attendance";
  if (t.includes("assignment")) return "/parent-portal/assignments";
  if (t.includes("assessment")) return "/parent-portal/assessments";
  if (t.includes("report"))     return "/parent-portal/report-cards";
  if (t.includes("class") || t.includes("timetable"))
                                return "/parent-portal/classes";
  return null;
};

const notificationIconFor = (notificationType?: string): React.ReactNode => {
  const t = String(notificationType || "").toLowerCase();
  if (t.includes("message"))    return <ChatOutlinedIcon />;
  if (t.includes("invoice") || t.includes("payment") || t.includes("billing"))
                                return <ReceiptLongOutlinedIcon />;
  if (t.includes("attendance") || t.includes("absence") || t.includes("late"))
                                return <FactCheckOutlinedIcon />;
  if (t.includes("assignment")) return <AssignmentOutlinedIcon />;
  if (t.includes("assessment")) return <AssignmentTurnedInOutlinedIcon />;
  if (t.includes("report"))     return <ArticleOutlinedIcon />;
  return <NotificationsNoneOutlinedIcon />;
};

/** Compact relative-time label — same tone as the rest of the portal. */
const relTime = (iso?: string | null): string => {
  if (!iso) return "";
  try { return dayjs(iso).fromNow(); } catch { return ""; }
};

type ParentHeaderRightProps = {
  parentName: string;
  onOpenNav?: () => void; // mobile hamburger, only shown by workspace header
  variant?: "workspace" | "dashboard";
};

const ParentHeaderRight: React.FC<ParentHeaderRightProps> = ({
  parentName, onOpenNav, variant = "workspace",
}) => {
  const navigate = useNavigate();
  const [bellAnchor, setBellAnchor]     = useState<null | HTMLElement>(null);
  const [accountAnchor, setAccountAnchor] = useState<null | HTMLElement>(null);
  const [helpOpen, setHelpOpen] = useState(false);

  // Live queries. Backend `notifications.userId` scopes to the auth
  // user (parent), so no extra client-side filter is needed. Skipped
  // for anonymous users so the header never fires 401s at logout.
  const hasSession = !!(typeof localStorage !== "undefined" && localStorage.getItem("token"));
  const { data: countData } = useGetUnreadNotificationCountQuery({}, {
    skip: !hasSession,
    // Refresh unread count periodically so the badge feels live
    // without a websocket. 60s is a compromise between freshness
    // and server load; tune down if the client asks.
    pollingInterval: 60000,
  });
  const { data: listData, isFetching: notifsFetching } = useGetNotificationQuery(
    { limit: 20 },
    { skip: !hasSession || !bellAnchor },
  );
  const [markRead] = useMarkNotificationAsReadMutation();

  const unreadCount = Number((countData?.data as any)?.count ?? (countData as any)?.count ?? 0) || 0;
  const notifs: any[] = Array.isArray(listData?.data) ? (listData!.data as any[]) : [];

  const openBell = (e: React.MouseEvent<HTMLElement>) => { setAccountAnchor(null); setBellAnchor(e.currentTarget); };
  const openAccount = (e: React.MouseEvent<HTMLElement>) => { setBellAnchor(null); setAccountAnchor(e.currentTarget); };
  const closeAll = () => { setBellAnchor(null); setAccountAnchor(null); };

  const handleNotifClick = async (n: any) => {
    // Best-effort mark-read; ignore failure so the nav still happens.
    if (n && n.isRead === false) {
      try { await markRead({ id: n.id }).unwrap(); } catch { /* non-fatal */ }
    }
    const dest = notificationDestination(n?.notificationType);
    setBellAnchor(null);
    if (dest) navigate(dest);
  };

  const handleMarkAllRead = async () => {
    if (unreadCount === 0) return;
    try { await markRead({ markAll: true }).unwrap(); } catch { /* non-fatal */ }
  };

  const handleLogout = () => {
    // Same mechanism as the shared /Components/Popup/profile.tsx logout —
    // clears the bearer token; the route guard bounces to /login. Hard
    // nav (rather than reload) guarantees Redux cache is dropped so no
    // stale parent data survives into the next session.
    try { localStorage.removeItem("token"); } catch { /* private-mode: swallow */ }
    window.location.assign("/login");
  };

  const initial = (parentName || "P").charAt(0).toUpperCase();
  const bellSize = variant === "workspace" ? 34 : 38;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      {/* Help — opens the Parent Portal Help drawer (parent-visible articles
          + Add to Home Screen instructions + Install button when supported). */}
      <IconButton
        aria-label="Help & Guides"
        onClick={() => setHelpOpen(true)}
        sx={{
          width: bellSize, height: bellSize, borderRadius: "10px",
          bgcolor: helpOpen ? pp.surface.blue : "transparent",
          color: pp.color.text,
          "&:hover": { bgcolor: pp.surface.blue },
        }}
      >
        <HelpOutlineOutlinedIcon fontSize="small" />
      </IconButton>
      <ParentHelpDrawer open={helpOpen} onClose={() => setHelpOpen(false)} />
      {/* Bell */}
      <IconButton
        aria-label="Notifications"
        onClick={openBell}
        sx={{
          width: bellSize, height: bellSize, borderRadius: "10px",
          bgcolor: bellAnchor ? pp.surface.blue : "transparent",
          color: pp.color.text,
          "&:hover": { bgcolor: pp.surface.blue },
        }}
      >
        <Badge
          badgeContent={unreadCount > 99 ? "99+" : (unreadCount || null)}
          color="error"
          overlap="circular"
          sx={{ "& .MuiBadge-badge": { fontSize: 10, minWidth: 16, height: 16, px: 0.5, fontWeight: 800 } }}
        >
          <NotificationsNoneOutlinedIcon fontSize="small" />
        </Badge>
      </IconButton>

      {/* Account button */}
      <Box
        role="button"
        tabIndex={0}
        aria-label="Open account menu"
        onClick={openAccount}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openAccount(e as any); } }}
        sx={{
          display: "flex", alignItems: "center", gap: 1,
          pl: 0.5, pr: { xs: 0.5, sm: 1 }, py: 0.5,
          borderRadius: "12px",
          cursor: "pointer",
          transition: pp.transition,
          bgcolor: accountAnchor ? pp.surface.blue : "transparent",
          "&:hover": { bgcolor: pp.surface.blue },
        }}
      >
        <Avatar sx={{
          width: variant === "workspace" ? 34 : 38,
          height: variant === "workspace" ? 34 : 38,
          fontSize: variant === "workspace" ? 13 : 14, fontWeight: 800,
          bgcolor: pp.color.blue, color: "#fff",
        }}>{initial}</Avatar>
        <Box sx={{ display: { xs: "none", sm: "block" }, minWidth: 0 }}>
          <Typography sx={{ fontSize: 12.5, fontWeight: 800, color: pp.color.text, lineHeight: 1, maxWidth: 160, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {parentName || "Parent"}
          </Typography>
          <Typography sx={{ fontSize: 10.5, color: pp.color.muted, mt: 0.25 }}>Parent</Typography>
        </Box>
        <KeyboardArrowDownIcon sx={{ fontSize: 18, color: pp.color.muted, display: { xs: "none", sm: "inline-block" } }} />
      </Box>

      {onOpenNav && (
        <IconButton
          aria-label="Open menu" size="small"
          onClick={onOpenNav}
          sx={{ display: { xs: "inline-flex", md: "none" }, ml: 0.5 }}
        >
          <MenuIcon />
        </IconButton>
      )}

      {/* Notifications popover */}
      <Popover
        open={Boolean(bellAnchor)}
        anchorEl={bellAnchor}
        onClose={closeAll}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              mt: 1, width: 380, maxWidth: "94vw",
              borderRadius: `${pp.radius.md}px`,
              border: `1px solid ${pp.color.border}`,
              boxShadow: pp.shadow.cardHover,
              overflow: "hidden",
            },
          },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2, py: 1.25, borderBottom: `1px solid ${pp.color.border}` }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <NotificationsNoneOutlinedIcon fontSize="small" sx={{ color: pp.color.blue }} />
            <Typography sx={{ fontSize: 13.5, fontWeight: 800, color: pp.color.text }}>Notifications</Typography>
          </Box>
          {unreadCount > 0 && (
            <Button size="small" onClick={handleMarkAllRead} sx={{ textTransform: "none", fontSize: 11.5, fontWeight: 700 }}>
              Mark all as read
            </Button>
          )}
        </Box>

        <Box sx={{ maxHeight: 440, overflowY: "auto" }}>
          {notifsFetching && notifs.length === 0 ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress size={22} />
            </Box>
          ) : notifs.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 4, px: 3 }}>
              <Box sx={{
                width: 48, height: 48, borderRadius: `${pp.radius.md}px`,
                bgcolor: pp.surface.mint, color: pp.color.green,
                display: "flex", alignItems: "center", justifyContent: "center",
                mx: "auto", mb: 1.25,
                "& svg": { fontSize: 24 },
              }}>
                <CheckCircleRoundedIcon />
              </Box>
              <Typography sx={{ fontSize: 13.5, fontWeight: 700, color: pp.color.text }}>You're all caught up</Typography>
              <Typography sx={{ fontSize: 12, color: pp.color.muted, mt: 0.5 }}>No new notifications right now.</Typography>
            </Box>
          ) : (
            notifs.map((n: any) => {
              const isUnread = n.isRead === false || n.isRead === 0;
              return (
                <Box
                  key={n.id}
                  role="button"
                  tabIndex={0}
                  onClick={() => handleNotifClick(n)}
                  onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleNotifClick(n); } }}
                  sx={{
                    display: "flex", gap: 1.25, alignItems: "flex-start",
                    px: 2, py: 1.25,
                    borderBottom: `1px solid ${pp.color.border}`,
                    "&:last-child": { borderBottom: "none" },
                    bgcolor: isUnread ? alpha(pp.color.blue, 0.05) : "transparent",
                    cursor: "pointer",
                    transition: pp.transition,
                    "&:hover": { bgcolor: alpha(pp.color.blue, 0.08) },
                  }}
                >
                  <Box sx={{
                    width: 34, height: 34, borderRadius: `${pp.radius.sm}px`,
                    bgcolor: isUnread ? pp.surface.blue : pp.surface.grey,
                    color: isUnread ? pp.color.blue : pp.color.muted,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    flexShrink: 0,
                    "& svg": { fontSize: 18 },
                  }}>
                    {notificationIconFor(n.notificationType)}
                  </Box>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                      <Typography sx={{ fontSize: 13, fontWeight: isUnread ? 800 : 600, color: pp.color.text, lineHeight: 1.3, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {n.title || n.notificationType || "Notification"}
                      </Typography>
                      {isUnread && <Box sx={{ width: 7, height: 7, borderRadius: "50%", bgcolor: pp.color.blue, flexShrink: 0 }} />}
                    </Box>
                    {n.message && (
                      <Typography sx={{ fontSize: 12, color: pp.color.muted, mt: 0.25, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                        {n.message}
                      </Typography>
                    )}
                    <Typography sx={{ fontSize: 10.5, color: pp.color.disabled, mt: 0.5 }}>
                      {relTime(n.created_at)}
                    </Typography>
                  </Box>
                </Box>
              );
            })
          )}
        </Box>
      </Popover>

      {/* Account menu */}
      <Menu
        anchorEl={accountAnchor}
        open={Boolean(accountAnchor)}
        onClose={closeAll}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              mt: 1, minWidth: 240,
              borderRadius: `${pp.radius.md}px`,
              border: `1px solid ${pp.color.border}`,
              boxShadow: pp.shadow.cardHover,
              overflow: "hidden",
            },
          },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, px: 2, py: 1.5, borderBottom: `1px solid ${pp.color.border}` }}>
          <Avatar sx={{ width: 36, height: 36, fontSize: 14, fontWeight: 800, bgcolor: pp.color.blue, color: "#fff" }}>{initial}</Avatar>
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 800, color: pp.color.text, maxWidth: 160, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {parentName || "Parent"}
            </Typography>
            <Typography sx={{ fontSize: 11, color: pp.color.muted }}>Parent</Typography>
          </Box>
        </Box>
        <MenuItem onClick={() => { closeAll(); navigate("/parent-portal/profile"); }}>
          <ListItemIcon><PersonOutlineIcon fontSize="small" /></ListItemIcon>
          <ListItemText primaryTypographyProps={{ fontSize: 13, fontWeight: 600 }}>Profile</ListItemText>
        </MenuItem>
        <MenuItem onClick={(e) => { setAccountAnchor(null); openBell(e); }}>
          <ListItemIcon><NotificationsNoneOutlinedIcon fontSize="small" /></ListItemIcon>
          <ListItemText primaryTypographyProps={{ fontSize: 13, fontWeight: 600 }}>Notifications</ListItemText>
          {unreadCount > 0 && (
            <Typography sx={{ fontSize: 11, fontWeight: 800, color: pp.color.blue, ml: 1 }}>
              {unreadCount > 99 ? "99+" : unreadCount}
            </Typography>
          )}
        </MenuItem>
        <Divider sx={{ my: 0.5 }} />
        <MenuItem onClick={handleLogout} sx={{ color: pp.color.red }}>
          <ListItemIcon><LogoutOutlinedIcon fontSize="small" sx={{ color: pp.color.red }} /></ListItemIcon>
          <ListItemText primaryTypographyProps={{ fontSize: 13, fontWeight: 700 }}>Logout</ListItemText>
        </MenuItem>
      </Menu>
    </Box>
  );
};

// ════════════════════════════════════════
// Child Selector Bar
// ════════════════════════════════════════

const ChildSelectorBar = () => {
  const theme = useTheme();
  const { children, selectedChild, setSelectedChild, activeChild } = useChild();
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  if (!activeChild) return null;

  // Single-child: identity card with no picker chevron.
  if (children.length <= 1) {
    return (
      <Box sx={{ mb: 2 }}>
        <ChildIdentityCard
          studentName={activeChild.studentName}
          gradeName={activeChild.gradeLabel || null}
          status="Active"
        />
      </Box>
    );
  }

  // Multi-child: identity card is the click target; hidden Select
  // supplies the picker menu so keyboard/screen-reader users keep the
  // full native combobox behaviour they already had.
  return (
    <Box sx={{ mb: 2, position: "relative" }}>
      <Box onClick={(e) => setMenuAnchor(e.currentTarget as HTMLElement)}>
        <ChildIdentityCard
          studentName={activeChild.studentName}
          gradeName={activeChild.gradeLabel || null}
          status="Active"
          multiple
          onClick={() => { /* click bubbles through the wrapper */ }}
        />
      </Box>
      <FormControl size="small" sx={{ position: "absolute", inset: 0, opacity: 0, pointerEvents: "auto" }}>
        <Select
          value={selectedChild || ""}
          onChange={(e) => setSelectedChild(Number(e.target.value))}
          open={Boolean(menuAnchor)}
          onOpen={(e) => setMenuAnchor(e.currentTarget as HTMLElement)}
          onClose={() => setMenuAnchor(null)}
          MenuProps={{ PaperProps: { sx: { maxHeight: 360, borderRadius: `${pp.radius.md}px`, mt: 0.5, boxShadow: pp.shadow.cardHover } } }}
          sx={{ height: "100%" }}
        >
          {children.map((c: any) => (
            <MenuItem key={c.studentId} value={c.studentId} sx={{ fontSize: 13, py: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, width: "100%" }}>
                <Avatar sx={{
                  width: 30, height: 30, fontSize: 12, fontWeight: 700, color: "#fff",
                  bgcolor: PP_C.indigo.accent,
                }}>
                  {(c.studentName || "S").charAt(0).toUpperCase()}
                </Avatar>
                <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1.2, minWidth: 0, flex: 1 }}>
                  <Typography sx={{ fontSize: 13.5, fontWeight: 700 }}>{c.studentName}</Typography>
                  {c.gradeLabel && <Typography sx={{ fontSize: 11, color: pp.color.muted }}>{c.gradeLabel}</Typography>}
                </Box>
                {c.studentId === selectedChild && (
                  <PortalStatusChip label="Selected" tone="green" size="sm" />
                )}
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

// ════════════════════════════════════════
// Layout — Phase 1 URL + localStorage persistence, fallback validation
// ════════════════════════════════════════

// URL query key + localStorage key for the persisted selected child.
const SELECTED_CHILD_QUERY_KEY = "student_id";
const SELECTED_CHILD_STORAGE_KEY = "stepup:parent-portal:selectedChild";

const readInitialSelectedChild = (search: string): number | null => {
  try {
    const fromUrl = new URLSearchParams(search).get(SELECTED_CHILD_QUERY_KEY);
    const n = fromUrl ? Number(fromUrl) : NaN;
    if (Number.isFinite(n) && n > 0) return n;
    const fromStorage = window.localStorage.getItem(SELECTED_CHILD_STORAGE_KEY);
    const m = fromStorage ? Number(fromStorage) : NaN;
    return Number.isFinite(m) && m > 0 ? m : null;
  } catch {
    return null;
  }
};

const ParentPortalLayout = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  // isMobile no longer used in this layout — top header + right drawer
  // are the same across breakpoints; drawer width adapts via PaperProps.
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const { userData } = useUser();
  const [selectedChild, setSelectedChildState] = useState<number | null>(
    () => readInitialSelectedChild(window.location.search),
  );

  const { data: dashData, isLoading: dashLoading } = useGetParentDashboardQuery({});
  const dashboard = useMemo(() => (dashData?.data as any) || null, [dashData]);
  const children: any[] = useMemo(() => dashboard?.children || [], [dashboard]);

  // Fallback: snap to first authorised child when the stored id isn't valid.
  React.useEffect(() => {
    if (children.length === 0) return;
    const ids = new Set(children.map((c: any) => c.studentId));
    if (selectedChild == null || !ids.has(selectedChild)) {
      setSelectedChildState(children[0].studentId);
    }
  }, [children, selectedChild]);

  const setSelectedChild = React.useCallback((id: number) => {
    setSelectedChildState(id);
    try { window.localStorage.setItem(SELECTED_CHILD_STORAGE_KEY, String(id)); } catch { /* private mode / quota */ }
    const params = new URLSearchParams(window.location.search);
    params.set(SELECTED_CHILD_QUERY_KEY, String(id));
    navigate({ pathname: window.location.pathname, search: `?${params.toString()}` }, { replace: true });
  }, [navigate]);

  // Keep URL in sync after auto-selection so copied links carry ?student_id=.
  React.useEffect(() => {
    if (selectedChild == null) return;
    const params = new URLSearchParams(location.search);
    if (params.get(SELECTED_CHILD_QUERY_KEY) === String(selectedChild)) return;
    params.set(SELECTED_CHILD_QUERY_KEY, String(selectedChild));
    navigate({ pathname: location.pathname, search: `?${params.toString()}` }, { replace: true });
    try { window.localStorage.setItem(SELECTED_CHILD_STORAGE_KEY, String(selectedChild)); } catch { /* ignore */ }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedChild, location.pathname]);

  const activeChild = children.find((c: any) => c.studentId === selectedChild) || children[0] || null;
  const parentName = userData?.staff || userData?.username || "Parent";

  // ── Parent Portal browser tab title ─────────────────────────────────────
  // useCompany() sets document.title to the raw company name on every
  // branding refresh. While the visitor is inside /parent-portal we want
  // the tab to read "{Short Name} Parent Portal" so it's obvious which
  // window they're looking at (helpful when parents have the school and
  // their own workspaces open side by side). Snapshotting the previous
  // title on mount + restoring on unmount guarantees we don't leave a
  // stale "Parent Portal" suffix hanging around after the parent leaves
  // the portal (e.g. staff impersonation flows returning to admin).
  const { company } = useCompany();
  const brandBase =
    (company?.shortName?.trim() || company?.companyName?.trim() || "").trim();
  React.useEffect(() => {
    const previous = document.title;
    document.title = brandBase ? `${brandBase} Parent Portal` : "Parent Portal";
    return () => {
      // Restore whatever was set before the portal mounted. useCompany
      // will re-assert the plain company name on its next refresh cycle
      // regardless — this just avoids a visible "… Parent Portal" tab
      // title lingering during the navigation transition.
      document.title = brandBase || previous;
    };
  }, [brandBase]);

  // Right-side hamburger drawer (Aug 2026 redesign per the reference
  // portal screenshots). The old permanent left sidebar has been
  // replaced with a top header + right drawer that opens on the
  // hamburger button. The drawer keeps the same navItems list so
  // every existing Parent Portal route is still reachable — only the
  // navigation chrome changed. Admin/Staff sidebars are untouched
  // because Parent Portal has its own layout (ParentPortalLayout)
  // and never mounts the shared app Drawer.
  const currentPageLabel = React.useMemo(() => {
    const match = [...navItems].reverse().find((it) => it.exact
      ? location.pathname === it.path
      : location.pathname.startsWith(it.path));
    return match?.label ?? "Parent Portal";
  }, [location.pathname]);

  const openNav = () => setMobileNavOpen(true);
  const closeNav = () => setMobileNavOpen(false);

  // Aug 2026 — dual-layout architecture:
  //   Dashboard route (`/parent-portal` exactly) keeps the top-header +
  //   right-drawer "landing" chrome.
  //   Every other Parent Portal subpage uses a PERMANENT left sidebar
  //   workspace layout (per the client Record Book reference).
  const isDashboardRoute = location.pathname === "/parent-portal";

  // Nav helper — preserves `?student_id=` when moving between pages
  // so switching from Dashboard → Time Table → Record Book never
  // drops the selected child.
  const navWithChild = React.useCallback((path: string) => {
    const params = new URLSearchParams(window.location.search);
    if (selectedChild != null && !params.get(SELECTED_CHILD_QUERY_KEY)) {
      params.set(SELECTED_CHILD_QUERY_KEY, String(selectedChild));
    }
    const qs = params.toString();
    navigate({ pathname: path, search: qs ? `?${qs}` : "" });
  }, [navigate, selectedChild]);

  const routesEl = (
    <Routes>
      <Route path="/" element={<ParentDashboard />} />
      <Route path="/classes" element={<ParentClassesPage />} />
      <Route path="/report-cards" element={<ParentReportCardsPage />} />
      <Route path="/classes/:id" element={<ParentClassDetail />} />
      <Route path="/attendance" element={<ParentAttendancePage />} />
      <Route path="/subjects" element={<ParentSubjectsPage />} />
      <Route path="/assessments" element={<ParentAssessmentsPage />} />
      <Route path="/performance" element={<ParentPerformancePage />} />
      <Route path="/assignments" element={<ParentAssignmentsPage />} />
      <Route path="/payments" element={<ParentPaymentsPage />} />
      <Route path="/bank-setup/complete" element={<BankSetupComplete />} />
      <Route path="/messages" element={<ParentMessagesPage />} />
      <Route path="/profile" element={<ParentProfilePage />} />
      <Route path="/settings" element={<Navigate to="/parent-portal/dashboard" replace />} />
    </Routes>
  );

  // ── WORKSPACE LAYOUT (subpages) ─────────────────────────────
  // Persistent left sidebar + page content. Matches the Step Up
  // Live client screenshot's Record Book layout structure.
  if (!isDashboardRoute) {
    return (
      <ChildContext.Provider value={{ selectedChild, setSelectedChild, children, activeChild }}>
        <Box sx={{ minHeight: "100vh", bgcolor: pp.color.pageBg, display: "flex", flexDirection: "column" }}>
          {/* Premium workspace top bar — thin brand accent stripe on
              top + white surface + right-aligned parent avatar. */}
          <Box sx={{
            position: "sticky", top: 0, zIndex: 1100,
            bgcolor: pp.color.card,
            borderBottom: `1px solid ${pp.color.border}`,
            px: { xs: 2, md: 3 }, py: 1.25,
            display: "flex", alignItems: "center", gap: 2,
            boxShadow: "0 1px 0 rgba(15,23,42,0.02)",
            "&::before": {
              content: '""', position: "absolute", top: 0, left: 0, right: 0, height: 2,
              bgcolor: PP_C.blue.accent,
            },
          }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{
                width: 30, height: 30, borderRadius: "8px",
                bgcolor: PP_C.indigo.accent,
                display: "flex", alignItems: "center", justifyContent: "center",
                color: "#fff", fontWeight: 800, fontSize: 14,
                boxShadow: "0 4px 12px rgba(60,90,130,0.18)",
              }}>
                S
              </Box>
              <Box sx={{ minWidth: 0 }}>
                {/* Company name is read from useCompanyBoot's Redux state at
                    the app-shell level; here we render only the section label
                    to keep this shell org-neutral. */}
                <Typography sx={{ fontSize: 11.5, fontWeight: 800, color: "#0F2747", letterSpacing: "0.06em", textTransform: "uppercase", lineHeight: 1 }}>
                  Parent Portal
                </Typography>
                <Typography sx={{ fontSize: 10, color: pp.color.muted, mt: 0.25 }}>Family Home</Typography>
              </Box>
            </Box>
            <Box sx={{ flex: 1 }} />
            <ParentHeaderRight parentName={parentName} onOpenNav={openNav} variant="workspace" />
          </Box>

          {/* Sidebar + content */}
          <Box sx={{ display: "flex", flex: 1, minHeight: 0 }}>
            {/* Persistent Parent sidebar — desktop only.
                Premium redesign: subtle blue-tinted background, mini
                student profile card at top with avatar + grade + up to
                two subject chips, gradient active state with left
                accent, subtle right border. Same navItems, same routes. */}
            <Box sx={{
              display: { xs: "none", md: "flex" },
              width: 244, flexShrink: 0, flexDirection: "column",
              bgcolor: PP_C.blue.bg,
              borderRight: "1px solid #E2EAF3",
            }}>
              {activeChild && (
                <Box sx={{ p: 1.75, borderBottom: "1px solid #E2EAF3" }}>
                  <Box sx={{
                    p: 1.25, borderRadius: "10px",
                    bgcolor: "#fff",
                    border: "1px solid #E2EAF3",
                    boxShadow: "0 4px 12px rgba(15,23,42,0.04)",
                  }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                      <Avatar sx={{
                        width: 36, height: 36, fontSize: 13, fontWeight: 800,
                        bgcolor: pp.color.blue, color: "#fff",
                      }}>
                        {(activeChild.studentName || "S").charAt(0).toUpperCase()}
                      </Avatar>
                      <Box sx={{ minWidth: 0 }}>
                        <Typography sx={{ fontSize: 13.5, fontWeight: 800, color: pp.color.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {activeChild.studentName || "Your child"}
                        </Typography>
                        {activeChild.gradeLabel && (
                          <Typography sx={{ fontSize: 11, color: pp.color.muted, mt: 0.25 }}>
                            {activeChild.gradeLabel}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                    {(activeChild as any)?.subjectName && (
                      <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        <Chip
                          label={(activeChild as any).subjectName}
                          size="small"
                          sx={{
                            height: 20, fontSize: 10.5, fontWeight: 700,
                            bgcolor: pp.surface.mint, color: pp.color.deepGreen,
                            border: `1px solid ${alpha(pp.color.green, 0.22)}`,
                          }}
                        />
                      </Box>
                    )}
                  </Box>
                </Box>
              )}
              <Box sx={{ py: 1.25, flex: 1, overflowY: "auto" }}>
                {navItems.map((item) => {
                  const isActive = item.exact
                    ? location.pathname === item.path
                    : location.pathname === item.path;
                  return (
                    <Box
                      key={item.path}
                      role="button" tabIndex={0}
                      onClick={() => navWithChild(item.path)}
                      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); navWithChild(item.path); } }}
                      sx={{
                        position: "relative",
                        display: "flex", alignItems: "center", gap: 1.25,
                        px: 2, py: 1.1, mx: 1, mb: 0.25,
                        borderRadius: "8px",
                        cursor: "pointer",
                        bgcolor: isActive
                          ? alpha(PP_C.blue.accent, 0.14)
                          : "transparent",
                        color: isActive ? pp.color.blue : pp.color.text,
                        fontWeight: isActive ? 800 : 600,
                        transition: pp.transition,
                        "&:hover": {
                          bgcolor: isActive
                            ? alpha(PP_C.blue.accent, 0.20)
                            : alpha(pp.color.blue, 0.06),
                        },
                        "&::before": isActive ? {
                          content: '""', position: "absolute", left: 0, top: 8, bottom: 8,
                          width: 3, borderRadius: 3,
                          background: PP_C.blue.accent,
                        } : undefined,
                        "& svg": { fontSize: 18, color: isActive ? pp.color.blue : pp.color.muted },
                        // Only expose the outline for true keyboard focus.
                        // Some browsers show a persistent focus ring after
                        // pointer clicks on role="button" boxes, which
                        // looked like a glitchy heavy border on the
                        // currently-selected sidebar item.
                        outline: "none",
                        "&:focus": { outline: "none" },
                        "&:focus-visible": { outline: `2px solid ${pp.color.blue}`, outlineOffset: 2 },
                      }}
                    >
                      {item.icon}
                      <Typography sx={{ fontSize: 13, fontWeight: "inherit" }}>{item.label}</Typography>
                    </Box>
                  );
                })}
              </Box>
              <Box sx={{ px: 2, py: 1.5, borderTop: "1px solid #E2EAF3" }}>
                <Typography sx={{ fontSize: 10, fontWeight: 800, color: pp.color.deepGreen, letterSpacing: "0.06em" }}>
                  STEP UP ACADEMY
                </Typography>
                <Typography sx={{ fontSize: 10, color: pp.color.muted, mt: 0.25 }}>Learning, together.</Typography>
              </Box>
            </Box>

            {/* Mobile drawer — same nav items */}
            <Drawer
              anchor="left"
              open={mobileNavOpen}
              onClose={closeNav}
              PaperProps={{ sx: { width: "82vw", maxWidth: 300, bgcolor: "#F3F8FC" } }}
              sx={{ display: { xs: "block", md: "none" } }}
            >
              <Box sx={{ px: 2, py: 1.5, display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #DCE7F2" }}>
                <Typography sx={{ fontSize: 12, fontWeight: 800, color: pp.color.deepGreen, letterSpacing: "0.08em" }}>PARENT PORTAL</Typography>
                <IconButton size="small" onClick={closeNav}><CloseIcon fontSize="small" /></IconButton>
              </Box>
              <Box sx={{ py: 1.25 }}>
                {navItems.map((item) => {
                  const isActive = location.pathname === item.path;
                  return (
                    <Box
                      key={item.path}
                      role="button" tabIndex={0}
                      onClick={() => { navWithChild(item.path); closeNav(); }}
                      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); navWithChild(item.path); closeNav(); } }}
                      sx={{
                        display: "flex", alignItems: "center", gap: 1.25,
                        px: 2, py: 1.25, mx: 1, mb: 0.25, borderRadius: 1.5,
                        cursor: "pointer",
                        bgcolor: isActive ? alpha(pp.color.blue, 0.12) : "transparent",
                        color: isActive ? pp.color.blue : pp.color.text,
                        fontWeight: isActive ? 800 : 600,
                      }}
                    >
                      {item.icon}
                      <Typography sx={{ fontSize: 13.5, fontWeight: "inherit" }}>{item.label}</Typography>
                    </Box>
                  );
                })}
              </Box>
            </Drawer>

            {/* Right — page content.
                Wrapper was `maxWidth: 1480, mx: auto`, which produced
                large idle gutters on wide displays because the left
                sidebar was already offsetting the layout — the cap was
                effectively double-counting the sidebar width. Bumped
                the cap to match the dashboard shell (1720) and reduced
                the desktop horizontal padding one step so data-heavy
                pages (Attendance table, Report Cards, Assignments)
                use the available room instead of stretching sparsely. */}
            <Box sx={{ flex: 1, minWidth: 0, bgcolor: pp.color.pageBg }}>
              <Box sx={{ px: { xs: 2, md: 2.5 }, py: { xs: 2, md: 2.5 }, maxWidth: 1720, mx: "auto" }}>
                {dashLoading ? (
                  <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}><StepUpSpinner size="medium" /></Box>
                ) : routesEl}
              </Box>
            </Box>
          </Box>
        </Box>
      </ChildContext.Provider>
    );
  }

  // ── DASHBOARD LAYOUT (existing top-header + right-drawer) ───────
  return (
    <ChildContext.Provider value={{ selectedChild, setSelectedChild, children, activeChild }}>
      <Box sx={{ minHeight: "100vh", bgcolor: pp.color.pageBg }}>
        {/* ── Top header — logo/student context left, page title
              centre-left, hamburger right. Sticky so it stays put
              while the dashboard scrolls. */}
        <Box sx={{
          position: "sticky", top: 0, zIndex: 1100,
          bgcolor: pp.color.card,
          borderBottom: `1px solid ${pp.color.border}`,
          px: { xs: 2, md: 3 }, py: 1.25,
          display: "flex", alignItems: "center", gap: 2,
        }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
            <Avatar sx={{
              width: 38, height: 38, fontSize: 14, fontWeight: 800,
              bgcolor: pp.color.deepGreen, color: "#fff",
            }}>
              {((activeChild?.name || parentName || "P").charAt(0)).toUpperCase()}
            </Avatar>
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{
                fontSize: 10, fontWeight: 700, color: pp.color.muted,
                textTransform: "uppercase", letterSpacing: "0.1em", lineHeight: 1,
              }}>
                Parent Portal
              </Typography>
              <Typography sx={{
                fontSize: 14, fontWeight: 800, color: pp.color.text, mt: 0.25,
                overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                maxWidth: { xs: 180, sm: 320 },
              }}>
                {activeChild?.name || parentName}
              </Typography>
            </Box>
          </Box>
          <Divider orientation="vertical" flexItem sx={{ mx: 1, display: { xs: "none", md: "block" } }} />
          <Typography sx={{
            fontSize: 13, fontWeight: 700, color: pp.color.text,
            display: { xs: "none", md: "block" },
          }}>
            {currentPageLabel}
          </Typography>
          <Box sx={{ flex: 1 }} />
          <ParentHeaderRight parentName={parentName} onOpenNav={openNav} variant="dashboard" />
        </Box>

        {/* Right-side navigation Drawer. anchor="right" pattern is
            already used elsewhere in the app (ClassBackupImport,
            OperationsCommandCenter) so the transition + backdrop
            behaviour are proven. */}
        <Drawer
          anchor="right"
          open={mobileNavOpen}
          onClose={closeNav}
          PaperProps={{ sx: {
            width: { xs: "88vw", sm: 340 },
            bgcolor: pp.color.card,
          } }}
        >
          <Box sx={{
            px: 2.25, py: 2, display: "flex", alignItems: "center",
            justifyContent: "space-between",
            borderBottom: `1px solid ${pp.color.border}`,
            bgcolor: pp.surface.mint,
          }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
              <Avatar sx={{
                width: 40, height: 40, fontSize: 15, fontWeight: 800,
                bgcolor: pp.color.deepGreen, color: "#fff",
              }}>
                {(parentName || "P").charAt(0).toUpperCase()}
              </Avatar>
              <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontSize: 13.5, fontWeight: 700, color: pp.color.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {parentName}
                </Typography>
                <Typography sx={{ fontSize: 11, color: pp.color.muted }}>Signed in</Typography>
              </Box>
            </Box>
            <IconButton aria-label="Close menu" size="small" onClick={closeNav}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <Box sx={{ flex: 1, py: 1.25, overflowY: "auto" }}>
            {navItems.map((item) => {
              const isActive = item.exact
                ? location.pathname === item.path
                : location.pathname.startsWith(item.path);
              return (
                <Box
                  key={item.path}
                  role="button"
                  tabIndex={0}
                  onClick={() => { navWithChild(item.path); closeNav(); }}
                  onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); navWithChild(item.path); closeNav(); } }}
                  sx={{
                    position: "relative",
                    display: "flex", alignItems: "center", gap: 1.5,
                    px: 2, py: 1.25, mx: 1, mb: 0.25,
                    borderRadius: 2,
                    cursor: "pointer",
                    bgcolor: isActive ? pp.surface.mint : "transparent",
                    color: isActive ? pp.color.deepGreen : pp.color.muted,
                    fontWeight: isActive ? 700 : 500,
                    transition: pp.transition,
                    "&:hover": { bgcolor: isActive ? pp.surface.mint : pp.surface.grey, color: isActive ? pp.color.deepGreen : pp.color.text },
                    "&::before": isActive ? {
                      content: '""', position: "absolute", left: -1, top: 10, bottom: 10,
                      width: 3, borderRadius: 3, bgcolor: pp.color.green,
                    } : undefined,
                    "& svg": { fontSize: 20 },
                    "&:focus-visible": { outline: `2px solid ${pp.color.deepGreen}`, outlineOffset: 2 },
                  }}
                >
                  {item.icon}
                  <Typography sx={{ fontSize: 14, fontWeight: "inherit" }}>{item.label}</Typography>
                </Box>
              );
            })}
          </Box>
          <Box sx={{ px: 2.25, py: 1.75, borderTop: `1px solid ${pp.color.border}` }}>
            <Typography sx={{
              fontSize: 10.5, fontWeight: 700, color: pp.color.deepGreen,
              letterSpacing: "0.06em",
            }}>
              STEP UP ACADEMY
            </Typography>
            <Typography sx={{ fontSize: 10, color: pp.color.muted, mt: 0.25 }}>
              Learning, together.
            </Typography>
          </Box>
        </Drawer>

        {/* Main content — full-width now that the permanent left
            sidebar is gone. maxWidth cap keeps ultra-wide displays
            comfortable while still letting the calendar breathe. */}
        <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1720, mx: "auto" }}>
          {dashLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}><StepUpSpinner size="medium" /></Box>
          ) : routesEl}
        </Box>
      </Box>
    </ChildContext.Provider>
  );
};

// ════════════════════════════════════════
// PortalPageIntro — polished eyebrow + greeting + title used by every
// redesigned Parent Portal page. Kept local so the primitive file
// stays purely presentational (no user/date coupling).
// ════════════════════════════════════════

const PortalPageIntro: React.FC<{
  title: string;
  subtitle?: string;
  showGreeting?: boolean;
  parentName?: string;
  icon?: React.ReactNode;
  /** Accent tone for the icon tile + subtle title strip. */
  tone?: "blue" | "cyan" | "mint" | "amber" | "violet" | "rose" | "navy";
  /** Right-aligned actions (buttons, toggles, filters). */
  actions?: React.ReactNode;
}> = ({ title, subtitle, showGreeting = true, parentName, icon, tone = "blue", actions }) => {
  // 2026-09 Bright Rainbow pass: `grad` is now a SOLID hex (field
  // name kept for backwards compat with downstream consumers), and
  // `bg` values are the medium-fill card backgrounds from PP_C.
  // Nothing else in the tone consumer signatures changes.
  const toneMap: Record<string, { bg: string; fg: string; grad: string }> = {
    blue:   { bg: PP_C.blue.bg,    fg: PP_C.blue.accent,    grad: PP_C.blue.accent },
    cyan:   { bg: PP_C.sky.bg,     fg: PP_C.sky.accent,     grad: PP_C.sky.accent },
    mint:   { bg: PP_C.teal.bg,    fg: PP_C.teal.accent,    grad: PP_C.teal.accent },
    amber:  { bg: PP_C.amber.bg,   fg: PP_C.amber.accent,   grad: PP_C.amber.accent },
    violet: { bg: PP_C.purple.bg,  fg: PP_C.purple.accent,  grad: PP_C.purple.accent },
    rose:   { bg: PP_C.coral.bg,   fg: PP_C.coral.accent,   grad: PP_C.coral.accent },
    navy:   { bg: PP_C.navy.bg,    fg: PP_C.navy.accent,    grad: PP_C.navy.accent },
  };
  const t = toneMap[tone];
  return (
    <Box sx={{
      mb: 2.5, display: "flex", alignItems: { xs: "flex-start", md: "center" },
      gap: 2, flexWrap: "wrap",
    }}>
      {icon && (
        <Box sx={{
          width: 46, height: 46, borderRadius: "10px",
          display: "flex", alignItems: "center", justifyContent: "center",
          background: t.grad, color: "#fff",
          boxShadow: `0 8px 20px ${alpha(t.fg, 0.28)}`,
          flexShrink: 0,
          "& svg": { fontSize: 22 },
        }}>
          {icon}
        </Box>
      )}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{
          fontSize: 11, fontWeight: 800, color: t.fg,
          textTransform: "uppercase", letterSpacing: "0.1em", mb: 0.4,
        }}>
          Parent Portal
        </Typography>
        <Typography sx={{
          fontSize: { xs: 24, md: 28 }, fontWeight: 800,
          letterSpacing: "-0.02em", color: pp.color.text, lineHeight: 1.15,
        }}>
          {showGreeting && parentName
            ? `${greetingForHour()}, ${parentName}`
            : title}
        </Typography>
        {(showGreeting && parentName) ? (
          <Typography sx={{ fontSize: 14, color: pp.color.muted, mt: 0.5 }}>
            {subtitle || title}
          </Typography>
        ) : subtitle ? (
          <Typography sx={{ fontSize: 13.5, color: pp.color.muted, mt: 0.5 }}>
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {actions && (
        <Box sx={{ ml: { xs: 0, md: "auto" }, display: "flex", alignItems: "center", gap: 1 }}>
          {actions}
        </Box>
      )}
    </Box>
  );
};

// ════════════════════════════════════════
// AttendanceRadial — pure-CSS conic-gradient ring used in the
// dashboard Attendance card. No chart library — just a stacked
// conic gradient with a knock-out inner circle for the center.
// ════════════════════════════════════════

const AttendanceRadial: React.FC<{ rate: number | null; size?: number }> = ({ rate, size = 120 }) => {
  const pct = rate == null ? 0 : Math.max(0, Math.min(100, rate));
  const color = rate == null ? pp.color.disabled
    : pct >= 80 ? pp.color.green
    : pct >= 50 ? pp.color.amber
    : pp.color.red;
  return (
    <Box sx={{
      width: size, height: size, position: "relative", flexShrink: 0,
      borderRadius: "50%",
      background: `conic-gradient(${color} ${pct * 3.6}deg, ${pp.surface.grey} 0deg)`,
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <Box sx={{
        width: size - 20, height: size - 20, borderRadius: "50%",
        bgcolor: pp.color.card,
        display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
        boxShadow: `inset 0 0 0 1px ${pp.color.border}`,
      }}>
        <Typography sx={{ fontSize: 22, fontWeight: 800, color, lineHeight: 1 }}>
          {rate == null ? "—" : `${Math.round(pct)}%`}
        </Typography>
        <Typography sx={{ fontSize: 10, fontWeight: 700, color: pp.color.muted, textTransform: "uppercase", letterSpacing: "0.06em", mt: 0.25 }}>
          Rate
        </Typography>
      </Box>
    </Box>
  );
};

// ════════════════════════════════════════
// Dashboard hero "More" quick-access menu
// ════════════════════════════════════════
//
// Colorful 3-dot button rendered next to Dashboard / Time Table. Opens
// a premium popover with icon-tile shortcuts to every other Parent
// Portal page, preserving the currently-selected child via the
// `student_id` query param (matches the canonical URL+localStorage
// selection layer at the top of this file).
const ParentPortalMoreMenu: React.FC = () => {
  const navigate = useNavigate();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const open = Boolean(anchor);

  const items: Array<{ path: string; label: string; icon: React.ReactNode; tint: string }> = [
    { path: "/parent-portal/report-cards", label: "Report Cards",  icon: <ArticleOutlinedIcon />,             tint: "#3D6FA6" }, // muted royal
    { path: "/parent-portal/attendance",   label: "Attendance",    icon: <FactCheckOutlinedIcon />,           tint: "#5BAA83" }, // muted mint
    { path: "/parent-portal/subjects",     label: "Subjects",      icon: <MenuBookOutlinedIcon />,            tint: "#73A3B3" }, // muted teal
    { path: "/parent-portal/assessments",  label: "Assessments",   icon: <AssignmentTurnedInOutlinedIcon />,  tint: "#5D7FB0" }, // steel blue
    { path: "/parent-portal/performance",  label: "Performance",   icon: <InsightsOutlinedIcon />,            tint: "#6F96BE" }, // soft steel
    { path: "/parent-portal/assignments",  label: "Assignments",   icon: <AssignmentOutlinedIcon />,          tint: "#C49A42" }, // muted gold
    { path: "/parent-portal/payments",     label: "Payments",      icon: <PaymentOutlinedIcon />,             tint: "#7B82AD" }, // soft indigo
    { path: "/parent-portal/messages",     label: "Messages",      icon: <ChatOutlinedIcon />,                tint: "#5577A8" }, // muted blue
    { path: "/parent-portal/profile",      label: "Profile & Account", icon: <PersonOutlineIcon />,           tint: pp.color.navy },
  ];

  const goto = (path: string) => {
    // Preserve `student_id` (and any other existing query params) so the
    // active child stays selected across navigations. Multi-child parents
    // don't get bounced back to their default child.
    const qs = window.location.search || "";
    navigate({ pathname: path, search: qs });
    setAnchor(null);
  };

  return (
    <>
      <Tooltip title="More">
        <IconButton
          onClick={(e) => setAnchor(e.currentTarget)}
          aria-label="More"
          sx={{
            width: 42, height: 42, borderRadius: 2,
            bgcolor: PP_C.indigo.accent,
            color: "#fff", boxShadow: "0 6px 16px rgba(60,90,130,0.20)",
            "&:hover": {
              bgcolor: "#5747BE",
              boxShadow: "0 10px 22px rgba(60,90,130,0.24)",
              transform: "translateY(-2px) scale(1.03)",
            },
            transition: "transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease",
          }}
        >
          <MoreHorizIcon sx={{ fontSize: 22 }} />
        </IconButton>
      </Tooltip>
      <Popover
        open={open}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            mt: 0.75, borderRadius: "16px", overflow: "hidden",
            border: "1px solid rgba(15,23,42,0.08)",
            boxShadow: "0 18px 44px rgba(15,23,42,0.14)",
            width: { xs: "92vw", sm: 360 }, maxWidth: 400,
          },
        }}
      >
        <Box sx={{ px: 2, pt: 1.75, pb: 1 }}>
          <Typography sx={{
            fontSize: 10.5, fontWeight: 800, letterSpacing: "0.8px",
            textTransform: "uppercase", color: pp.color.navy,
          }}>
            More
          </Typography>
          <Typography sx={{ fontSize: 12, color: "text.secondary", mt: 0.25 }}>
            Jump to any Parent Portal page.
          </Typography>
        </Box>
        <Divider />
        <Box sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
          gap: 0.75, p: 1.25,
        }}>
          {items.map((it) => (
            <Box
              key={it.path}
              onClick={() => goto(it.path)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); goto(it.path); } }}
              sx={{
                display: "flex", alignItems: "center", gap: 1.25,
                p: 1.25, borderRadius: "12px", cursor: "pointer",
                border: "1px solid transparent",
                "&:hover": { bgcolor: alpha(it.tint, 0.06), borderColor: alpha(it.tint, 0.2) },
                "&:focus-visible": { outline: `2px solid ${it.tint}`, outlineOffset: 2 },
              }}
            >
              <Box sx={{
                width: 34, height: 34, borderRadius: "9px", flexShrink: 0,
                bgcolor: alpha(it.tint, 0.14), color: it.tint,
                display: "flex", alignItems: "center", justifyContent: "center",
                "& svg": { fontSize: 18 },
              }}>
                {it.icon}
              </Box>
              <Typography sx={{ fontSize: 13, fontWeight: 700, color: pp.color.navy, flex: 1, minWidth: 0 }}>
                {it.label}
              </Typography>
              <Box sx={{ color: alpha(pp.color.navy, 0.35), display: "flex" }}>
                <ArrowForwardIosIcon sx={{ fontSize: 12 }} />
              </Box>
            </Box>
          ))}
        </Box>
      </Popover>
    </>
  );
};

// ════════════════════════════════════════
// Phase-5 Dashboard — single aggregate query per selected child
// ════════════════════════════════════════

const ParentDashboard = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { activeChild, selectedChild } = useChild();

  const { data, isLoading, isFetching } = useGetChildDashboardQuery(
    { studentId: selectedChild },
    { skip: !selectedChild },
  );
  const d: any = data?.data || null;
  const att = d?.attendance_summary || null;
  const asgn = d?.assignment_summary || null;
  const subj = d?.subject_summary || null;
  const bill = d?.billing_summary || null;
  const upcoming: any[] = d?.upcoming_classes || [];
  const recentMessages: any[] = d?.recent_messages || [];

  // Activity Calendar — fetch the currently-viewed month's classes
  // from the same child-scoped endpoint the Classes page uses. Kept
  // separate from the dashboard summary hook so the calendar can
  // paginate months without refetching the whole dashboard.
  const [calMonth, setCalMonth] = React.useState<string>(dayjs().format("YYYY-MM"));
  const calStart = dayjs(calMonth).startOf("month").format("YYYY-MM-DD");
  const calEnd = dayjs(calMonth).endOf("month").format("YYYY-MM-DD");
  const { data: calData, isLoading: calLoading } = useGetChildClassesQuery(
    { studentId: selectedChild, startDate: calStart, endDate: calEnd },
    { skip: !selectedChild },
  );
  const calClasses: any[] = React.useMemo(
    () => Array.isArray(calData?.data) ? (calData!.data as any[]) : [],
    [calData],
  );

  const isToday = (iso: string) => dayjs(iso).isSame(dayjs(), "day");
  const isTomorrow = (iso: string) => dayjs(iso).isSame(dayjs().add(1, "day"), "day");
  const relDay = (iso: string) => (isToday(iso) ? "Today" : isTomorrow(iso) ? "Tomorrow" : dayjs(iso).format("ddd, MMM D"));
  // This Week window (Mon..Sun of the current week).
  const weekStart = dayjs().startOf("week");
  const weekEnd = dayjs().endOf("week");
  const thisWeekClasses = React.useMemo(
    () => upcoming.filter((c) => {
      const d = dayjs(c.date);
      return d.isValid() && !d.isBefore(weekStart, "day") && !d.isAfter(weekEnd, "day");
    }).slice(0, 5),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [upcoming],
  );
  const inboxMessages = React.useMemo(() => recentMessages.slice(0, 5), [recentMessages]);
  const unreadInbox = React.useMemo(
    () => recentMessages.filter((m: any) => m?.is_read === false || m?.read_at == null).length,
    [recentMessages],
  );

  // Calendar accent by class status (used inside eventContent below).
  // Kept BEFORE the early return so the useMemo below is a stable hook
  // call every render — React's rules-of-hooks.
  // Unified subject palette (2026-08-24) — sky / royal blue / indigo /
  // lavender / aqua only. No forest green, no muddy orange, no random
  // brown. Attendance status accents (mint/gold/coral) are kept
  // separate and rendered as badges, not as full event backgrounds.
  const subjectColor: Record<string, string> = {
    English: "#6296BC",   // muted sky
    Math:    "#6F7FA8",   // muted indigo
    Science: "#73A3B3",   // muted teal
    French:  "#7888B5",   // muted lavender-blue
    ABA:     "#7888B5",
    Therapy: "#7888B5",
    EQAO:    "#6296BC",   // muted sky
  };
  const getSubjectAccent = React.useCallback((subj?: string) => {
    if (!subj) return theme.palette.primary.main;
    for (const [k, v] of Object.entries(subjectColor)) if (subj.toLowerCase().includes(k.toLowerCase())) return v;
    return theme.palette.primary.main;
    // subjectColor is a stable local literal — safe to omit from deps.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme.palette.primary.main]);
  const calEvents = React.useMemo(() => calClasses.map((cls: any) => ({
    id: String(cls.id),
    title: cls.subjectName ? cls.subjectName.replace(/,\s*/g, " + ") : "Class",
    start: dayjs(cls.scheduledDate).format("YYYY-MM-DD"),
    allDay: true,
    backgroundColor: cls.status === "cancelled" ? "#D97882" : getSubjectAccent(cls.subjectName),
    borderColor: "transparent",
    textColor: "#fff",
    display: "block" as const,
    extendedProps: { ...cls },
  })), [calClasses, getSubjectAccent]);

  // Small SVG donut used by Attendance + Homework reports below.
  // Deliberately inline (no new chart dependency) — segments are
  // rendered as arcs with `stroke-dasharray`. Order matters: pass the
  // segments in visual order.
  type DonutSeg = { label: string; value: number; color: string };
  const Donut: React.FC<{ segments: DonutSeg[]; size?: number; thickness?: number; centerLabel?: React.ReactNode; centerHint?: string }> = ({ segments, size = 148, thickness = 18, centerLabel, centerHint }) => {
    const total = segments.reduce((s, x) => s + Math.max(0, x.value), 0);
    const r = (size - thickness) / 2;
    const c = 2 * Math.PI * r;
    let offset = 0;
    return (
      <Box sx={{ position: "relative", width: size, height: size, flexShrink: 0 }}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ transform: "rotate(-90deg)" }}>
          {/* track */}
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#DCE7EF" strokeWidth={thickness} />
          {total > 0 && segments.map((seg, i) => {
            const frac = Math.max(0, seg.value) / total;
            const len = c * frac;
            const dash = `${len} ${c - len}`;
            const el = (
              <circle
                key={i}
                cx={size / 2} cy={size / 2} r={r}
                fill="none" stroke={seg.color} strokeWidth={thickness}
                strokeDasharray={dash}
                strokeDashoffset={-offset}
                strokeLinecap="butt"
              />
            );
            offset += len;
            return el;
          })}
        </svg>
        <Box sx={{
          position: "absolute", inset: 0,
          display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center",
          textAlign: "center", px: 1,
        }}>
          <Typography sx={{ fontSize: 26, fontWeight: 800, color: pp.color.text, lineHeight: 1 }}>{centerLabel}</Typography>
          {centerHint && <Typography sx={{ fontSize: 10.5, fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase", color: pp.color.muted, mt: 0.5 }}>{centerHint}</Typography>}
        </Box>
      </Box>
    );
  };

  // Subject chips: derive from the summary if the parent has an
  // enrolled-subject list, else fall back to `activeChild.subjectName`.
  // Declared BEFORE the early return so the hook call order stays
  // stable across renders (React rules-of-hooks).
  const subjectChips: string[] = React.useMemo(() => {
    const fromSummary = Array.isArray(subj?.preview)
      ? subj.preview.map((s: any) => s.subject_name).filter(Boolean)
      : [];
    if (fromSummary.length > 0) return fromSummary.slice(0, 4);
    const single = (activeChild as any)?.subjectName;
    return single ? [single] : [];
  }, [subj, activeChild]);

  // Empty-state guard AFTER every hook has been called so the hook
  // call order stays identical across renders.
  if (!activeChild) {
    return (
      <Box>
        <PortalPageIntro title="Dashboard" />
        <PortalCard>
          <PortalEmptyState
            icon={<ChildCareIcon />}
            title="No children linked"
            body="Please contact the school to link your children to your account."
          />
        </PortalCard>
      </Box>
    );
  }

  return (
    <Box>
      {/* ═══════════ PREMIUM STUDENT HEADER ═══════════
             Prominent identity strip — avatar, name, grade, subjects,
             plus Dashboard/Classes action pills on the right. Soft
             indigo→cyan wash keeps the surface premium without a
             giant coloured hero. */}
      <Box sx={{
        position: "relative", overflow: "hidden",
        borderRadius: `${pp.radius.lg}px`,
        border: `1px solid ${PP_C.blue.border}`,
        // Solid blue-family fill (was a radial + linear-gradient
        // wash). Spec §"TOP STUDENT HEADER CARD".
        bgcolor: PP_C.blue.bg,
        boxShadow: "0 6px 18px rgba(20,45,70,0.05)",
        px: { xs: 2, md: 3 }, py: { xs: 2, md: 2.25 }, mb: 2.5,
        display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap",
      }}>
        <Avatar sx={{
          width: 60, height: 60, fontSize: 22, fontWeight: 800, color: "#fff",
          bgcolor: PP_C.blue.accent,
          boxShadow: `0 0 0 4px rgba(37,99,235,0.14)`,
          zIndex: 1,
        }}>
          {(activeChild.studentName || "S").charAt(0).toUpperCase()}
        </Avatar>
        <Box sx={{ flex: 1, minWidth: 0, zIndex: 1 }}>
          <Typography sx={{ fontSize: 10.5, fontWeight: 800, letterSpacing: "0.12em", textTransform: "uppercase", color: pp.color.muted }}>
            Parent Portal · Student
          </Typography>
          <Typography sx={{ fontSize: { xs: 22, md: 26 }, fontWeight: 800, color: pp.color.text, lineHeight: 1.15, mt: 0.25, letterSpacing: "-0.01em" }}>
            {activeChild.studentName || "Your child"}
          </Typography>
          <Stack direction="row" spacing={1} sx={{ mt: 1, flexWrap: "wrap", rowGap: 0.75 }}>
            {activeChild.gradeLabel && (
              <Chip
                size="small"
                label={activeChild.gradeLabel}
                sx={{ height: 24, fontSize: 11.5, fontWeight: 800, bgcolor: alpha(pp.color.blue, 0.12), color: pp.color.blue, border: `1px solid ${alpha(pp.color.blue, 0.22)}` }}
              />
            )}
            {subjectChips.map((name) => (
              <Chip
                key={name}
                size="small"
                icon={<MenuBookOutlinedIcon sx={{ fontSize: "14px !important", color: "#557AA1 !important" }} />}
                label={name}
                sx={{
                  height: 24, fontSize: 11.5, fontWeight: 700,
                  bgcolor: "#EFF4F7", color: "#3F5B7A",
                  border: "1px solid #D5E1EA",
                }}
              />
            ))}
            {((activeChild as any)?.status === "active" || (activeChild as any)?.status == null) && (
              <Chip
                size="small"
                icon={<CheckCircleOutlineIcon sx={{ fontSize: "14px !important", color: "#467F66 !important" }} />}
                label="Active"
                sx={{ height: 24, fontSize: 11.5, fontWeight: 700, bgcolor: "#F1F8F4", color: "#467F66", border: "1px solid #CDE6D8" }}
              />
            )}
          </Stack>
        </Box>
        {/* Dashboard / Classes action pills + More quick-access menu */}
        <Stack direction="row" spacing={1} sx={{ zIndex: 1 }}>
          <Button
            variant="contained" size="small"
            startIcon={<DashboardOutlinedIcon sx={{ fontSize: "16px !important" }} />}
            sx={{
              textTransform: "none", fontWeight: 800, borderRadius: 2,
              bgcolor: pp.color.blue, boxShadow: `0 6px 16px ${alpha(pp.color.blue, 0.28)}`,
              "&:hover": { bgcolor: pp.color.blue, boxShadow: `0 8px 20px ${alpha(pp.color.blue, 0.36)}` },
            }}
          >
            Dashboard
          </Button>
          <Button
            variant="contained" size="small"
            startIcon={<SchoolOutlinedIcon sx={{ fontSize: "16px !important" }} />}
            onClick={() => {
              const params = new URLSearchParams(window.location.search);
              const qs = params.toString();
              navigate({ pathname: "/parent-portal/classes", search: qs ? `?${qs}` : "" });
            }}
            sx={{
              // Solid indigo Time Table pill per spec §"TOP STUDENT HEADER".
              textTransform: "none", fontWeight: 800, borderRadius: 2,
              bgcolor: PP_C.indigo.accent, color: "#FFFFFF",
              boxShadow: `0 6px 16px ${alpha(PP_C.indigo.accent, 0.28)}`,
              "&:hover": { bgcolor: PP_C.indigo.accent, boxShadow: `0 8px 20px ${alpha(PP_C.indigo.accent, 0.36)}` },
            }}
          >
            Time Table
          </Button>
          <ParentPortalMoreMenu />
        </Stack>
      </Box>

      {/* Multi-child selector — visible under the identity card for
          parents with more than one linked student. */}
      <ChildSelectorBar />

      {/* ═══════════ TOP 3-CARD ROW ═══════════
             Payments | This Week Classes | Inbox
             Middle column is wider (1.25fr) so the class rows have
             comfortable room. Stacks under md. */}
      <Box sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "1fr 1.25fr 1fr" },
        gap: 2, mt: 2, mb: 2.5,
      }}>
        {/* PAYMENTS — full-fill emerald card (spec §"PAYMENTS CARD") */}
        <PortalCard sx={{
          position: "relative", overflow: "hidden",
          bgcolor: PP_C.emerald.bg,
          border: `1px solid ${PP_C.emerald.border}`,
          boxShadow: "0 6px 18px rgba(20,50,80,0.05)",
        }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{
                width: 30, height: 30, borderRadius: 1,
                display: "flex", alignItems: "center", justifyContent: "center",
                bgcolor: PP_C.emerald.accent, color: "#FFFFFF",
              }}>
                <PaymentOutlinedIcon fontSize="small" />
              </Box>
              <Typography sx={{ fontSize: 11.5, fontWeight: 800, letterSpacing: "0.06em", textTransform: "uppercase", color: pp.color.text }}>Payments</Typography>
            </Box>
          </Box>
          {isLoading ? (
            <Box sx={{ py: 2, display: "flex", justifyContent: "center" }}><StepUpSpinner size="small" /></Box>
          ) : bill && Number(bill.outstanding) > 0 ? (
            <>
              <Typography sx={{ fontSize: 28, fontWeight: 800, color: pp.color.red, lineHeight: 1, mt: 0.5 }}>
                ${Number(bill.outstanding).toFixed(2)}
              </Typography>
              <Typography sx={{ fontSize: 12, color: pp.color.muted, mt: 0.5 }}>Balance due</Typography>
              {bill.last_invoice?.date && (
                <Typography sx={{ fontSize: 11, color: pp.color.disabled, mt: 0.25 }}>
                  Latest invoice {dayjs(bill.last_invoice.date).format("MMM D, YYYY")}
                </Typography>
              )}
            </>
          ) : (
            <>
              <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, mt: 0.5 }}>
                <Typography sx={{ fontSize: 28, fontWeight: 800, color: pp.color.navy, lineHeight: 1 }}>$0.00</Typography>
                <Chip
                  size="small" label="Paid up"
                  sx={{
                    height: 20, fontSize: 10.5, fontWeight: 800, letterSpacing: "0.3px",
                    bgcolor: PP_C.emerald.accent, color: "#FFFFFF", border: `1px solid ${PP_C.emerald.accent}`,
                  }}
                />
              </Box>
              <Typography sx={{ fontSize: 12, color: pp.color.muted, mt: 0.5 }}>No payment due</Typography>
            </>
          )}
          <Box sx={{ mt: 1.5 }}>
            <Button size="small" endIcon={<ArrowForwardIcon sx={{ fontSize: "14px !important" }} />}
              onClick={() => navigate("/parent-portal/payments")}
              sx={{ textTransform: "none", fontSize: 12, fontWeight: 700, color: PP_C.emerald.accent, p: 0, minWidth: 0 }}
            >
              View Payments
            </Button>
          </Box>
        </PortalCard>

        {/* THIS WEEK CLASSES — full-fill blue card (spec §"THIS WEEK CLASSES") */}
        <PortalCard sx={{
          position: "relative", overflow: "hidden",
          bgcolor: PP_C.blue.bg,
          border: `1px solid ${PP_C.blue.border}`,
          boxShadow: "0 6px 18px rgba(20,50,80,0.05)",
        }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{ width: 30, height: 30, borderRadius: 1, display: "flex", alignItems: "center", justifyContent: "center", bgcolor: PP_C.blue.accent, color: "#FFFFFF" }}>
                <CalendarTodayIcon fontSize="small" />
              </Box>
              <Typography sx={{ fontSize: 11.5, fontWeight: 800, letterSpacing: "0.06em", textTransform: "uppercase", color: pp.color.text }}>This Week Classes</Typography>
            </Box>
            <Typography sx={{ fontSize: 11, color: pp.color.muted }}>
              {weekStart.format("MMM D")} – {weekEnd.format("MMM D")}
            </Typography>
          </Box>
          {isLoading ? (
            <Box sx={{ py: 2, display: "flex", justifyContent: "center" }}><StepUpSpinner size="small" /></Box>
          ) : thisWeekClasses.length === 0 ? (
            <Typography sx={{ fontSize: 12.5, color: pp.color.muted, py: 2 }}>No classes scheduled this week.</Typography>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              {thisWeekClasses.map((c: any) => (
                <Box key={c.occurrence_id} sx={{
                  display: "flex", alignItems: "center", gap: 1.25,
                  py: 0.85, borderBottom: `1px solid ${pp.color.border}`,
                  "&:last-child": { borderBottom: "none" },
                }}>
                  <Box sx={{
                    minWidth: 58, textAlign: "center",
                    bgcolor: isToday(c.date) ? pp.surface.mint : pp.surface.blue,
                    borderRadius: 1, px: 0.75, py: 0.5,
                  }}>
                    <Typography sx={{ fontSize: 9.5, fontWeight: 800, color: isToday(c.date) ? pp.color.deepGreen : pp.color.blue, textTransform: "uppercase", letterSpacing: "0.08em" }}>
                      {isToday(c.date) ? "Today" : dayjs(c.date).format("ddd MMM D")}
                    </Typography>
                    <Typography sx={{ fontSize: 10, color: pp.color.muted, mt: 0.15 }}>{to12Hour(c.start_time)}</Typography>
                  </Box>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: pp.color.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {c.subject || "Class"}
                    </Typography>
                    <Typography sx={{ fontSize: 11, color: pp.color.muted, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {[c.staff, c.location, c.mode].filter(Boolean).join(" · ") || "—"}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          )}
          <Box sx={{ mt: 1.25 }}>
            <Button size="small" endIcon={<ArrowForwardIcon sx={{ fontSize: "14px !important" }} />}
              onClick={() => navigate("/parent-portal/classes")}
              sx={{ textTransform: "none", fontSize: 12, fontWeight: 700, color: PP_C.blue.accent, p: 0, minWidth: 0 }}
            >
              View Time Table
            </Button>
          </Box>
        </PortalCard>

        {/* INBOX — full-fill purple card (spec §"INBOX") */}
        <PortalCard sx={{
          position: "relative", overflow: "hidden",
          bgcolor: PP_C.purple.bg,
          border: `1px solid ${PP_C.purple.border}`,
          boxShadow: "0 6px 18px rgba(20,50,80,0.05)",
        }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{ width: 30, height: 30, borderRadius: 1, display: "flex", alignItems: "center", justifyContent: "center", bgcolor: PP_C.purple.accent, color: "#FFFFFF" }}>
                <InboxOutlinedIcon fontSize="small" />
              </Box>
              <Typography sx={{ fontSize: 11.5, fontWeight: 800, letterSpacing: "0.06em", textTransform: "uppercase", color: pp.color.text }}>Inbox</Typography>
            </Box>
            {unreadInbox > 0 && (
              <Chip label={`${unreadInbox} new`} size="small" sx={{ height: 20, fontSize: 10.5, fontWeight: 800, bgcolor: PP_C.purple.accent, color: "#FFFFFF" }} />
            )}
          </Box>
          {isLoading ? (
            <Box sx={{ py: 2, display: "flex", justifyContent: "center" }}><StepUpSpinner size="small" /></Box>
          ) : inboxMessages.length === 0 ? (
            <Box sx={{ py: 2, textAlign: "center" }}>
              <MarkEmailReadOutlinedIcon sx={{ fontSize: 30, color: "#B4B9D2" }} />
              <Typography sx={{ fontSize: 12.5, color: pp.color.muted, mt: 0.5 }}>You're all caught up.</Typography>
            </Box>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              {inboxMessages.map((m: any) => (
                <Box key={m.id} sx={{
                  py: 0.85, borderBottom: `1px solid ${pp.color.border}`,
                  "&:last-child": { borderBottom: "none" },
                }}>
                  <Typography sx={{ fontSize: 12.5, fontWeight: (m?.read_at == null) ? 700 : 500, color: pp.color.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {m.subject || "(No subject)"}
                  </Typography>
                  <Typography sx={{ fontSize: 11, color: pp.color.muted, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {m.is_family ? "Family" : (activeChild?.studentName || "Message")}
                    {m.created_at ? ` · ${dayjs(m.created_at).format("MMM D")}` : ""}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
          <Box sx={{ mt: 1.25 }}>
            <Button size="small" endIcon={<ArrowForwardIcon sx={{ fontSize: "14px !important" }} />}
              onClick={() => navigate("/parent-portal/messages")}
              sx={{ textTransform: "none", fontSize: 12, fontWeight: 700, color: PP_C.purple.accent, p: 0, minWidth: 0 }}
            >
              View Messages
            </Button>
          </Box>
        </PortalCard>
      </Box>

      {/* ═══════════ ANALYTICS ROW ═══════════
             Monthly Attendance Report  |  Homework Report
             Moved ABOVE the Activity Calendar (2026-08-24) so parents
             see academic health before the full calendar. Data sources
             unchanged — the same attendance_summary +
             assignment_summary from useGetChildDashboardQuery. Both
             cards redesigned as premium visualization surfaces. */}
      <Box sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "1.15fr 0.85fr" },
        gap: 2, mb: 2.5,
      }}>
        {/* ── MONTHLY ATTENDANCE ── solid teal card (spec §"MONTHLY ATTENDANCE") */}
        <PortalCard padding={0} sx={{
          position: "relative", overflow: "hidden", minHeight: 260,
          bgcolor: PP_C.teal.bg,
          border: `1px solid ${PP_C.teal.border}`,
          boxShadow: "0 8px 24px rgba(30,55,80,0.06)",
          transition: "transform 0.18s, box-shadow 0.18s",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 10px 26px rgba(30,55,80,0.08)",
          },
        }}>
          {/* Solid teal header band with white text. */}
          <Box sx={{
            position: "relative", overflow: "hidden",
            bgcolor: PP_C.teal.accent,
            color: "#fff",
            px: 2, py: 1.5,
            display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1.25,
          }}>
            <Box sx={{ position: "relative", display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
              <Box sx={{
                width: 36, height: 36, borderRadius: 1.5,
                display: "flex", alignItems: "center", justifyContent: "center",
                bgcolor: "rgba(255,255,255,0.16)", color: "#fff",
                border: "1px solid rgba(255,255,255,0.24)",
                backdropFilter: "blur(6px)",
              }}>
                <FactCheckOutlinedIcon fontSize="small" />
              </Box>
              <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontSize: 12.5, fontWeight: 800, letterSpacing: "0.10em", textTransform: "uppercase", color: "#fff", lineHeight: 1.1 }}>
                  Monthly Attendance
                </Typography>
                <Typography sx={{ fontSize: 11.5, color: "rgba(255,255,255,0.78)", mt: 0.25 }}>
                  {att?.period_label || dayjs().format("MMMM YYYY")}
                </Typography>
              </Box>
            </Box>
            <Box sx={{
              position: "relative",
              px: 1.25, py: 0.45, borderRadius: 999,
              bgcolor: "rgba(255,255,255,0.16)", color: "#fff",
              border: "1px solid rgba(255,255,255,0.30)",
              fontSize: 10.5, fontWeight: 800, letterSpacing: "0.6px", textTransform: "uppercase",
              flexShrink: 0,
            }}>
              This Month
            </Box>
          </Box>

          {/* Body — inner padding restored (card padding=0) */}
          <Box sx={{ p: 2 }}>

          {isLoading ? (
            <Box sx={{ py: 5, display: "flex", justifyContent: "center" }}><StepUpSpinner size="small" /></Box>
          ) : (att?.total ?? 0) === 0 ? (
            <PortalEmptyState icon={<FactCheckOutlinedIcon />} title="No attendance recorded" body="Attendance will appear after classes are recorded." compact />
          ) : (() => {
              const rate = att.attendance_rate;
              const rateNum: number | null = rate != null ? Number(rate) : null;
              // Rate-status pill and insight strip use blue/indigo tones
              // for premium look; semantic green is reserved for the
              // Present metric chip only. Watch/needs-attention keep
              // amber/red because those ARE warning states.
              // Solid-color luxury pill — stronger than a soft tint.
              // Bg is a directional gradient for depth; a small semantic
              // green check is prepended when Excellent so the "success"
              // signal survives even though the pill itself is indigo.
              // Sky → Royal blue Excellent (was indigo/violet) to keep
              // Attendance's fresh BLUE identity intact. Watch stays
              // gold (not orange), Needs Attention stays coral.
              const rateStatus = rateNum == null
                ? { label: "—", fg: "#fff", bg: pp.color.muted, shadow: "rgba(60,90,130,0.12)" }
                : rateNum >= 90 ? { label: "Excellent",       fg: "#fff", bg: "#5D7FA6", shadow: "rgba(60,90,130,0.12)" }
                : rateNum >= 80 ? { label: "Good",            fg: "#fff", bg: "#6F96BE", shadow: "rgba(60,90,130,0.12)" }
                : rateNum >= 60 ? { label: "Watch",           fg: "#fff", bg: "#C49A42", shadow: "rgba(150,110,50,0.18)" }
                : { label: "Needs Attention", fg: "#fff", bg: "#D97882", shadow: "rgba(180,90,100,0.18)" };
              const recordedSessions = Number(att.present ?? 0) + Number(att.late ?? 0) + Number(att.absent ?? 0);
              const insight = rateNum == null
                ? "Attendance history will appear as sessions are recorded."
                : rateNum >= 90 ? `Excellent attendance this month — ${recordedSessions} recorded session${recordedSessions === 1 ? "" : "s"} attended.`
                : rateNum >= 80 ? `Good attendance this month — keep it up.`
                : rateNum >= 60 ? `Attendance could use attention this month.`
                : `Attendance needs attention this month.`;

              // Semantic status colors ONLY on the metric chips.
              // Richer 2-stop tint gradients + real border + tabular
              // number in the deeper shade of the same hue for
              // luxury depth.
              // Semantic-only tinting: mint (Present), soft GOLD not
              // burnt orange (Late), soft coral (Absent), ICY BLUE not
              // slate grey (Not Recorded). Every ugly grey / muddy
              // orange from the previous pass is gone.
              const chips = [
                { key: "present",      label: "Present",      value: Number(att.present ?? 0),
                  iconColor: "#5BAA83", numColor: "#467F66",
                  bg: "#F1F8F4", border: "#CDE6D8", icon: "✓" },
                { key: "late",         label: "Late",         value: Number(att.late ?? 0),
                  iconColor: "#C49A42", numColor: "#9B7A36",
                  bg: "#FBF7ED", border: "#E8D9B1", icon: "⏱" },
                { key: "absent",       label: "Absent",       value: Number(att.absent ?? 0),
                  iconColor: "#D97882", numColor: "#B75F68",
                  bg: "#FCF3F4", border: "#ECCDD1", icon: "✕" },
                { key: "not_recorded", label: "Not Recorded", value: Number(att.not_recorded ?? 0),
                  iconColor: "#7EA3BE", numColor: "#567B95",
                  bg: "#F1F6F9", border: "#D2E0EA", icon: "•" },
              ];

              return (
                <Box sx={{ position: "relative" }}>
                  <Box sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", sm: "auto 1fr" },
                    gap: 2.5, alignItems: "center",
                  }}>
                    {/* Big ring */}
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5, minWidth: 190, mx: { xs: "auto", sm: 0 } }}>
                      <Box sx={{ width: 176, height: 176 }}>
                        <Donut
                          segments={[
                            { label: "Present",      value: Number(att.present ?? 0),      color: "#5BAA83" },
                            { label: "Late",         value: Number(att.late ?? 0),         color: "#D6AE57" },
                            { label: "Absent",       value: Number(att.absent ?? 0),       color: "#D97882" },
                            { label: "Not Recorded", value: Number(att.not_recorded ?? 0), color: "#9DBBD0" },
                          ]}
                          centerLabel={rate != null ? `${rate}%` : "—"}
                          centerHint="Attendance Rate"
                        />
                      </Box>
                      {rateNum != null && (
                        <Box sx={{
                          mt: 0.9, px: 1.5, py: 0.55, borderRadius: 999,
                          background: rateStatus.bg, color: rateStatus.fg,
                          boxShadow: `0 5px 14px ${rateStatus.shadow}`,
                          fontSize: 11.5, fontWeight: 800, letterSpacing: "0.5px", textTransform: "uppercase",
                          display: "inline-flex", alignItems: "center", gap: 0.6,
                        }}>
                          {rateNum >= 90 && <span aria-hidden style={{ color: "#CDE6D8", fontSize: 12, textShadow: "0 1px 1px rgba(0,0,0,0.15)" }}>✓</span>}
                          {rateStatus.label}
                        </Box>
                      )}
                    </Box>

                    {/* 2x2 metric chips */}
                    <Box sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: 1,
                    }}>
                      {chips.map((c) => (
                        <Box key={c.key} sx={{
                          p: 1.25, borderRadius: `${pp.radius.md}px`,
                          background: c.bg,
                          border: `1px solid ${c.border}`,
                          boxShadow: "0 6px 18px rgba(15,23,42,0.06)",
                          transition: "transform 0.15s, box-shadow 0.15s",
                          "&:hover": { transform: "translateY(-1px)", boxShadow: "0 10px 22px rgba(15,23,42,0.08)" },
                        }}>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mb: 0.35 }}>
                            <Box aria-hidden sx={{
                              width: 22, height: 22, borderRadius: "50%",
                              display: "flex", alignItems: "center", justifyContent: "center",
                              bgcolor: c.iconColor, color: "#fff", fontSize: 11.5, fontWeight: 800, lineHeight: 1,
                              boxShadow: `0 4px 10px ${alpha(c.iconColor, 0.35)}`,
                            }}>{c.icon}</Box>
                            <Typography sx={{ fontSize: 10.5, fontWeight: 800, letterSpacing: "0.5px", textTransform: "uppercase", color: c.iconColor }}>
                              {c.label}
                            </Typography>
                          </Box>
                          <Typography sx={{
                            fontSize: 24, fontWeight: 800, color: c.numColor,
                            fontVariantNumeric: "tabular-nums", lineHeight: 1.05,
                          }}>
                            {c.value}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>

                  {/* Insight strip — calm soft-blue surface. */}
                  <Box sx={{
                    mt: 1.75, px: 1.25, py: 1.15, borderRadius: `${pp.radius.md}px`,
                    background: "#F2F6FA",
                    border: "1px solid #D5E1EA",
                    display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1.25,
                  }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
                      <Box aria-hidden sx={{
                        width: 26, height: 26, borderRadius: "8px", flexShrink: 0,
                        background: "#698CAE",
                        color: "#fff", display: "flex", alignItems: "center", justifyContent: "center",
                        boxShadow: "0 3px 8px rgba(60,90,130,0.16)",
                      }}>
                        <TrendingUpIcon sx={{ fontSize: 15 }} />
                      </Box>
                      <Typography sx={{ fontSize: 12.5, color: pp.color.navy, fontWeight: 700 }}>
                        {insight}
                      </Typography>
                    </Box>
                    <Button
                      size="small"
                      endIcon={<ArrowForwardIcon sx={{ fontSize: "14px !important", transition: "transform 0.15s" }} />}
                      onClick={() => navigate("/parent-portal/attendance")}
                      sx={{
                        textTransform: "none", fontSize: 12, fontWeight: 800,
                        color: "#5577A0", p: 0, minWidth: 0, flexShrink: 0,
                        "&:hover": { color: "#17324D" },
                        "&:hover .MuiSvgIcon-root": { transform: "translateX(2px)" },
                      }}
                    >
                      View Attendance
                    </Button>
                  </Box>
                </Box>
              );
            })()}
          </Box>
        </PortalCard>

        {/* ── HOMEWORK REPORT ── solid purple card (spec §"HOMEWORK") */}
        <PortalCard padding={0} sx={{
          position: "relative", overflow: "hidden", minHeight: 260,
          bgcolor: PP_C.purple.bg,
          border: `1px solid ${PP_C.purple.border}`,
          boxShadow: "0 8px 24px rgba(30,55,80,0.06)",
          transition: "transform 0.18s, box-shadow 0.18s",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 10px 26px rgba(30,55,80,0.08)",
          },
        }}>
          {/* Solid purple header band with white text. */}
          <Box sx={{
            position: "relative", overflow: "hidden",
            bgcolor: PP_C.purple.accent,
            color: "#fff",
            px: 2, py: 1.5,
            display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1.25,
          }}>
            <Box sx={{ position: "relative", display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
              <Box sx={{
                width: 36, height: 36, borderRadius: 1.5,
                display: "flex", alignItems: "center", justifyContent: "center",
                bgcolor: "rgba(255,255,255,0.16)", color: "#fff",
                border: "1px solid rgba(255,255,255,0.24)",
                backdropFilter: "blur(6px)",
              }}>
                <AssignmentOutlinedIcon fontSize="small" />
              </Box>
              <Box>
                <Typography sx={{ fontSize: 12.5, fontWeight: 800, letterSpacing: "0.10em", textTransform: "uppercase", color: "#fff", lineHeight: 1.1 }}>
                  Homework
                </Typography>
                <Typography sx={{ fontSize: 11.5, color: "rgba(255,255,255,0.78)", mt: 0.25 }}>
                  Overall
                </Typography>
              </Box>
            </Box>
            <Box sx={{
              position: "relative",
              px: 1.25, py: 0.45, borderRadius: 999,
              bgcolor: "rgba(255,255,255,0.16)", color: "#fff",
              border: "1px solid rgba(255,255,255,0.30)",
              fontSize: 10.5, fontWeight: 800, letterSpacing: "0.6px", textTransform: "uppercase",
              flexShrink: 0,
            }}>
              Current
            </Box>
          </Box>

          {/* Body */}
          <Box sx={{ p: 2 }}>

          {isLoading ? (
            <Box sx={{ py: 5, display: "flex", justifyContent: "center" }}><StepUpSpinner size="small" /></Box>
          ) : (asgn?.total ?? 0) === 0 ? (
            /* Muted empty state — soft indigo orb + floating chips */
            <Box sx={{ position: "relative", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: 3, minHeight: 180 }}>
              <Box sx={{ position: "relative", width: 118, height: 118, mb: 1.5 }}>
                {/* Soft outer ring */}
                <Box aria-hidden sx={{
                  position: "absolute", inset: 0, borderRadius: "50%",
                  bgcolor: "#FFFFFF",
                  border: "1px solid rgba(104,121,168,0.12)",
                }} />
                {/* Muted lavender-blue → indigo orb. */}
                <Box aria-hidden sx={{
                  position: "absolute", inset: 16, borderRadius: "50%",
                  bgcolor: PP_C.purple.accent,
                  boxShadow: "0 8px 20px rgba(104,121,168,0.20), 0 0 0 12px rgba(104,121,168,0.08)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                  <AssignmentTurnedInOutlinedIcon sx={{ color: "#fff", fontSize: 34 }} />
                </Box>
                {/* Floating chip — checkmark */}
                <Box aria-hidden sx={{
                  position: "absolute", top: -4, right: 4, width: 26, height: 26, borderRadius: "50%",
                  bgcolor: "#fff", boxShadow: "0 4px 10px rgba(15,23,42,0.10)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  border: "1px solid #CDE6D8",
                }}>
                  <Typography sx={{ fontSize: 13, color: "#5BAA83", fontWeight: 800, lineHeight: 1 }}>✓</Typography>
                </Box>
                {/* Floating chip — paper */}
                <Box aria-hidden sx={{
                  position: "absolute", bottom: -2, left: -2, width: 26, height: 26, borderRadius: 1.5,
                  bgcolor: "#fff", boxShadow: "0 4px 10px rgba(15,23,42,0.08)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  border: "1px solid #D5E1EA",
                }}>
                  <ArticleOutlinedIcon sx={{ fontSize: 14, color: "#5577A8" }} />
                </Box>
                {/* Sparkle */}
                <Box aria-hidden sx={{
                  position: "absolute", top: 18, left: -6, fontSize: 14, color: "#C49A42", opacity: 0.85,
                }}>✦</Box>
              </Box>
              <Typography sx={{ fontSize: 14, fontWeight: 800, color: pp.color.text }}>
                No homework yet
              </Typography>
              <Typography sx={{ fontSize: 12.5, color: pp.color.muted, mt: 0.25, textAlign: "center", maxWidth: 260 }}>
                Homework will appear here when assignments are posted.
              </Typography>
              <Button
                size="small"
                endIcon={<ArrowForwardIcon sx={{ fontSize: "14px !important", transition: "transform 0.15s" }} />}
                onClick={() => navigate("/parent-portal/assignments")}
                sx={{
                  mt: 1.75, textTransform: "none", fontSize: 12, fontWeight: 800,
                  color: "#5F6FA1",
                  "&:hover .MuiSvgIcon-root": { transform: "translateX(2px)" },
                }}
              >
                View Homework
              </Button>
            </Box>
          ) : (() => {
              const completed = Number(asgn.graded ?? 0);
              const pending   = Number(asgn.pending ?? 0);
              const upcoming  = Number(asgn.upcoming ?? 0);
              const overdue   = Number(asgn.overdue ?? 0);
              const total     = completed + pending + upcoming + overdue;
              const completionPct = total > 0 ? Math.round((completed / total) * 100) : 0;
              const segments = [
                { key: "completed", value: completed, color: "#5BAA83", label: "Completed" },
                { key: "pending",   value: pending,   color: "#C49A42", label: "Pending" },
                { key: "upcoming",  value: upcoming,  color: "#6F96BE", label: "Upcoming" },
                { key: "overdue",   value: overdue,   color: "#D97882", label: "Overdue" },
              ];
              return (
                <Box sx={{ position: "relative" }}>
                  <Box sx={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", mb: 1 }}>
                    <Box>
                      <Typography sx={{
                        fontSize: 34, fontWeight: 800, color: "#17324D",
                        fontVariantNumeric: "tabular-nums", lineHeight: 1,
                      }}>
                        {completionPct}%
                      </Typography>
                      <Typography sx={{ fontSize: 11.5, color: pp.color.muted, fontWeight: 700, mt: 0.25, textTransform: "uppercase", letterSpacing: "0.4px" }}>
                        Completed
                      </Typography>
                    </Box>
                    <Typography sx={{ fontSize: 12.5, color: pp.color.muted }}>
                      {completed} of {total} assignment{total === 1 ? "" : "s"}
                    </Typography>
                  </Box>
                  {/* Segmented progress bar */}
                  <Box sx={{
                    display: "flex", height: 12, borderRadius: 999, overflow: "hidden",
                    bgcolor: "#EEF1F8", border: `1px solid #DCE3ED`, mb: 1.5,
                  }}>
                    {segments.map((s) => s.value > 0 && (
                      <Box key={s.key} title={`${s.label}: ${s.value}`} sx={{
                        flex: s.value,
                        bgcolor: s.color,
                      }} />
                    ))}
                  </Box>
                  {/* Stat chips */}
                  <Box sx={{
                    display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 1,
                  }}>
                    {segments.map((s) => (
                      <Box key={s.key} sx={{
                        p: 1, borderRadius: `${pp.radius.md}px`,
                        bgcolor: alpha(s.color, 0.08), border: `1px solid ${alpha(s.color, 0.20)}`,
                        textAlign: "center",
                      }}>
                        <Typography sx={{
                          fontSize: 18, fontWeight: 800, color: s.color,
                          fontVariantNumeric: "tabular-nums", lineHeight: 1,
                        }}>{s.value}</Typography>
                        <Typography sx={{
                          fontSize: 10, fontWeight: 800, letterSpacing: "0.4px", textTransform: "uppercase",
                          color: pp.color.muted, mt: 0.35,
                        }}>{s.label}</Typography>
                      </Box>
                    ))}
                  </Box>
                  <Box sx={{ mt: 1.75 }}>
                    <Button
                      size="small"
                      endIcon={<ArrowForwardIcon sx={{ fontSize: "14px !important", transition: "transform 0.15s" }} />}
                      onClick={() => navigate("/parent-portal/assignments")}
                      sx={{
                        textTransform: "none", fontSize: 12, fontWeight: 800,
                        color: "#5F6FA1", p: 0, minWidth: 0,
                        "&:hover .MuiSvgIcon-root": { transform: "translateX(2px)" },
                      }}
                    >
                      View Homework
                    </Button>
                  </Box>
                </Box>
              );
            })()}
          </Box>
        </PortalCard>
      </Box>

      {/* ═══════════ ACTIVITY CALENDAR ═══════════
             Moved below the analytics row (2026-08-24) so parents see
             academic health above the full month grid. Calendar logic,
             events, colors, navigation, and click behaviour unchanged. */}
      {/* Activity Calendar shell — solid blue outer identity (spec
          §"ACTIVITY CALENDAR"). Calendar grid inside stays light for
          readability; only the surrounding chrome carries the tone. */}
      <PortalCard padding={0} sx={{
        mb: 2.5, mt: 0.5, overflow: "hidden",
        boxShadow: "0 8px 24px rgba(30,55,80,0.05)",
        border: `1px solid ${PP_C.blue.border}`,
        bgcolor: PP_C.blue.bg,
      }}>
        <Box sx={{
          display: "flex", alignItems: "center", justifyContent: "space-between",
          px: 2, py: 1.25,
          bgcolor: PP_C.blue.accent,
          borderBottom: `1px solid ${PP_C.blue.accent}`,
        }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box sx={{
              width: 32, height: 32, borderRadius: 1.25,
              display: "flex", alignItems: "center", justifyContent: "center",
              bgcolor: "rgba(255,255,255,0.2)", color: "#FFFFFF",
            }}>
              <CalendarViewMonthIcon fontSize="small" />
            </Box>
            <Typography sx={{ fontSize: 13, fontWeight: 800, letterSpacing: "0.08em", textTransform: "uppercase", color: "#FFFFFF" }}>Activity Calendar</Typography>
          </Box>
          {calLoading && <CircularProgress size={14} sx={{ color: "#FFFFFF" }} />}
        </Box>
        {/* Inner calendar body kept on white for readability (spec
            §"ACTIVITY CALENDAR" — calendar body remains light/white). */}
        <Box sx={{ p: 2.5, bgcolor: "#FFFFFF" }}>
        <Box sx={{
          "& .fc": { fontFamily: "inherit" },
          "& .fc-toolbar-title": { fontSize: "16px !important", fontWeight: "800 !important", color: `${pp.color.navy} !important`, letterSpacing: "-0.01em !important" },
          // Toolbar buttons — muted premium look, no bright fills.
          "& .fc-button": {
            fontSize: "12px !important", textTransform: "capitalize !important" as any,
            borderRadius: "10px !important",
            border: "1px solid #DCE5EC !important",
            backgroundColor: "#FFFFFF !important",
            color: `#51687E !important`,
            fontWeight: "700 !important",
            boxShadow: "none !important", padding: "6px 14px !important",
            transition: "background-color 0.15s, border-color 0.15s",
          },
          "& .fc-button:hover": {
            backgroundColor: "#F2F6FA !important",
            borderColor: "#DCE5EC !important",
          },
          "& .fc-button-active, & .fc-button:not(:disabled).fc-button-active": {
            background: `${PP_C.blue.accent} !important`,
            color: "#FFFFFF !important", border: `1px solid ${PP_C.blue.accent} !important`,
            boxShadow: "none !important",
          },
          // Weekday header row — muted navy text on soft steel band.
          "& .fc-col-header": { background: "#F6F8FB !important" },
          "& .fc-col-header-cell": { borderColor: "#E8EDF2 !important" },
          "& .fc-col-header-cell-cushion": {
            fontSize: "11px !important", fontWeight: "800 !important",
            textTransform: "uppercase", letterSpacing: "0.06em",
            color: `#17324D !important`, padding: "10px 6px !important",
          },
          // Day cells — white, hairline steel-grey borders, subtle today tint.
          "& .fc-daygrid-day": { backgroundColor: "#FFFFFF" },
          "& .fc-day-other": { backgroundColor: "#FBFCFD !important" },
          "& .fc-day-today": { backgroundColor: "#F3F7FA !important" },
          "& .fc-day-today .fc-daygrid-day-number": {
            display: "inline-flex !important", alignItems: "center", justifyContent: "center",
            width: 26, height: 26, borderRadius: "50% !important",
            background: `${PP_C.blue.accent} !important`,
            color: "#fff !important", fontWeight: "800 !important",
            boxShadow: "0 3px 8px rgba(37,99,235,0.24) !important",
            margin: "6px !important",
          },
          "& .fc-daygrid-day-number": {
            fontSize: "12.5px !important", fontWeight: "600 !important",
            color: `#17324D !important`, padding: "6px 10px !important",
          },
          "& .fc-day-other .fc-daygrid-day-number": { color: `${pp.color.disabled} !important` },
          "& .fc-scrollgrid": { border: "1px solid #E8EDF2 !important", borderRadius: "12px !important", overflow: "hidden" },
          "& .fc td, & .fc th": { borderColor: "#E8EDF2 !important" },
          "& .fc-daygrid-event-dot": { display: "none !important" },
          "& .fc-daygrid-event": { marginBottom: "3px !important", border: "none !important", background: "transparent !important" },
          "& .fc-daygrid-more-link": { color: `#5577A0 !important`, fontWeight: "700 !important", fontSize: "11px !important" },
        }}>
          <FullCalendar
            plugins={[dayGridPlugin]}
            initialView="dayGridMonth"
            events={calEvents}
            headerToolbar={{ left: "prev,next today", center: "title", right: "" }}
            height="auto"
            dayMaxEvents={3}
            eventDisplay="block"
            datesSet={(info) => setCalMonth(dayjs(info.start).add(15, "day").format("YYYY-MM"))}
            eventClick={(info) => {
              info.jsEvent.preventDefault();
              const ep: any = info.event.extendedProps;
              if (ep?.id) navigate(`/parent-portal/classes/${ep.id}`);
            }}
            eventContent={(eventInfo) => {
              const ep: any = eventInfo.event.extendedProps;
              const base = ep.status === "cancelled" ? "#D97882" : getSubjectAccent(ep.subjectName);
              // Muted solid fill — calm rather than a neon gradient.
              const bgColor = base;
              const subjects = (ep.subjectName || "Class").replace(/,\s*/g, " + ");
              return (
                <div style={{ background: bgColor, color: "#fff", borderRadius: "7px", padding: "4px 7px", overflow: "hidden", cursor: "pointer", fontSize: 0, lineHeight: 1, boxShadow: `0 2px 6px ${alpha(base, 0.28)}` }}>
                  <div style={{ fontSize: "11px", fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {to12Hour(ep.startTime)} {subjects}
                  </div>
                  {ep.staffName && (
                    <div style={{ fontSize: "9.5px", color: "rgba(255,255,255,0.85)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {ep.staffName}
                    </div>
                  )}
                </div>
              );
            }}
          />
        </Box>
        </Box>
      </PortalCard>

      {isFetching && !isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}><CircularProgress size={16} /></Box>
      )}

    </Box>
  );
};

// ════════════════════════════════════════
// Classes Page
// ════════════════════════════════════════

const ParentClassesPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { selectedChild, activeChild } = useChild();
  const [viewMode, setViewMode] = useState<"list" | "calendar">("calendar");
  const [calMonth, setCalMonth] = useState(dayjs().format("YYYY-MM"));
  const [detailCls, setDetailCls] = useState<any>(null);

  const calStart = dayjs(calMonth).startOf("month").format("YYYY-MM-DD");
  const calEnd = dayjs(calMonth).endOf("month").format("YYYY-MM-DD");

  const { data: classData, isLoading: classLoading } = useGetChildClassesQuery(
    { studentId: selectedChild, startDate: calStart, endDate: calEnd },
    { skip: !selectedChild }
  );

  const allClasses: any[] = useMemo(() => Array.isArray(classData?.data) ? classData!.data as any[] : [], [classData]);
  const listClasses = useMemo(() => { const t = dayjs().format("YYYY-MM-DD"); return allClasses.filter((c: any) => c.scheduledDate >= t); }, [allClasses]);
  const calClasses = allClasses;

  const grouped = useMemo(() => {
    const map = new Map<string, any[]>();
    listClasses.forEach((c: any) => { const d = dayjs(c.scheduledDate).format("YYYY-MM-DD"); if (!map.has(d)) map.set(d, []); map.get(d)!.push(c); });
    return Array.from(map.entries());
  }, [listClasses]);

  const fmt12 = to12Hour;

  // Muted subject palette (2026-08-25). Every event chip returns the
  // trio {bg, border, text} so list rows and calendar event blocks
  // share the identical scheme. Falls back to a neutral steel-blue.
  type SubjectStyle = { bg: string; border: string; text: string };
  const subjectStyles: Array<{ match: string; style: SubjectStyle }> = [
    { match: "eqao",    style: { bg: "#EAF4FB", border: "#5E91B8", text: "#315D7C" } },
    { match: "english", style: { bg: "#EAF4FB", border: "#5E91B8", text: "#315D7C" } },
    { match: "aba",     style: { bg: "#EEF0F8", border: "#7485B2", text: "#46577F" } },
    { match: "therapy", style: { bg: "#EEF0F8", border: "#7485B2", text: "#46577F" } },
    { match: "math",    style: { bg: "#EEF3FA", border: "#617FA8", text: "#37527A" } },
    { match: "science", style: { bg: "#ECF6F7", border: "#6F9DA8", text: "#3F6E78" } },
    { match: "french",  style: { bg: "#EEF0F8", border: "#7485B2", text: "#46577F" } },
  ];
  const subjectStyle = (subj: string | undefined): SubjectStyle => {
    const other: SubjectStyle = { bg: "#F2F4F8", border: "#7D8EAA", text: "#3F5674" };
    if (!subj) return other;
    const lower = subj.toLowerCase();
    for (const s of subjectStyles) if (lower.includes(s.match)) return s.style;
    return other;
  };
  // Kept for the class-detail modal accent gradient.
  const getAccent = (subj: string | undefined) => subjectStyle(subj).border;

  const calEvents = useMemo(() => calClasses.map((cls: any) => ({
    id: String(cls.id),
    title: cls.subjectName ? cls.subjectName.replace(/,\s*/g, " + ") : "Class",
    start: dayjs(cls.scheduledDate).format("YYYY-MM-DD"),
    allDay: true,
    // eventContent owns the styling now; keep the raw event transparent
    // so FullCalendar's default fill never bleeds through.
    backgroundColor: "transparent",
    borderColor: "transparent",
    textColor: "inherit",
    display: "block" as const,
    extendedProps: { ...cls },
  })), [calClasses]);

  const formatDayLabel = (d: string) => {
    const dd = dayjs(d);
    if (dd.isSame(dayjs(), "day")) return "Today";
    if (dd.isSame(dayjs().add(1, "day"), "day")) return "Tomorrow";
    return dd.format("dddd, MMMM D");
  };

  const isLoading = classLoading;
  const isEmpty = viewMode === "list" ? listClasses.length === 0 : calClasses.length === 0;

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", mb: 2, flexWrap: "wrap", gap: 1.5 }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: 11, fontWeight: 800, color: "#5F86AC", textTransform: "uppercase", letterSpacing: "0.1em" }}>
            Parent Portal
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, flexWrap: "wrap", mt: 0.25 }}>
            <Typography sx={{ fontSize: { xs: 24, md: 28 }, fontWeight: 700, letterSpacing: "-0.02em", color: "#17324D", lineHeight: 1.15 }}>
              Classes
            </Typography>
            <Chip
              icon={<CalendarTodayIcon sx={{ fontSize: "14px !important", color: "#4E78A6 !important" }} />}
              label={dayjs(calMonth).format("MMMM YYYY")}
              size="small"
              sx={{ height: 26, fontSize: 12, fontWeight: 800, bgcolor: "#EAF2F8", color: "#17324D", border: "1px solid #D6E1EA", "& .MuiChip-label": { pl: 0.5 } }}
            />
          </Box>
          <Typography sx={{ fontSize: 13, color: "#7D8FA1", mt: 0.4 }}>
            View upcoming and completed classes for {activeChild?.studentName || "your child"}.
          </Typography>
        </Box>
        {/* Premium segmented control — pale-blue container, white active pill. */}
        <Box sx={{
          display: "flex",
          bgcolor: "#EAF2F8", borderRadius: "12px", p: "4px",
          border: "1px solid #D6E1EA",
          flexShrink: 0,
        }}>
          {[
            { key: "list" as const,     icon: <ViewListIcon sx={{ fontSize: "16px !important" }} />,           label: "List" },
            { key: "calendar" as const, icon: <CalendarViewMonthIcon sx={{ fontSize: "16px !important" }} />, label: "Calendar" },
          ].map((v) => {
            const active = viewMode === v.key;
            return (
              <Button key={v.key} size="small" onClick={() => setViewMode(v.key)} startIcon={v.icon}
                sx={{
                  textTransform: "none", fontSize: 12.5, fontWeight: active ? 800 : 700,
                  borderRadius: "9px", px: 1.75, py: 0.65, minWidth: 0,
                  bgcolor: active ? "#fff" : "transparent",
                  color: active ? "#17324D" : "#5F86AC",
                  border: active ? "1px solid #D6E1EA" : "1px solid transparent",
                  boxShadow: active ? "0 2px 8px rgba(23,50,77,0.08)" : "none",
                  transition: "all 0.15s",
                  "&:hover": {
                    bgcolor: active ? "#fff" : "rgba(255,255,255,0.55)",
                    color: "#17324D",
                  },
                }}>
                {v.label}
              </Button>
            );
          })}
        </Box>
      </Box>

      <ChildSelectorBar />

      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}><StepUpSpinner size="medium" /></Box>
      ) : viewMode === "calendar" ? (
        <Box sx={{
          // Premium calendar shell — the main focal element on the page.
          bgcolor: "#FFFFFF",
          borderRadius: "18px",
          border: "1px solid #DFE7EE",
          boxShadow: "0 8px 26px rgba(23,50,77,0.06)",
          p: { xs: 1.25, md: 2.25 },
          "& .fc": { fontFamily: "inherit" },
          // Toolbar
          "& .fc-toolbar.fc-header-toolbar": { mb: "14px !important" },
          "& .fc-toolbar-title": {
            fontSize: "19px !important", fontWeight: "700 !important",
            color: "#17324D !important", letterSpacing: "-0.01em !important",
          },
          "& .fc-button": {
            fontSize: "12.5px !important", fontWeight: "700 !important",
            textTransform: "capitalize !important" as any,
            borderRadius: "10px !important",
            border: "1px solid #DFE7EE !important",
            backgroundColor: "#FFFFFF !important",
            color: "#5F86AC !important",
            boxShadow: "none !important",
            padding: "7px 14px !important", minHeight: "36px",
            transition: "background-color 0.15s, border-color 0.15s, color 0.15s",
          },
          "& .fc-button:hover": {
            backgroundColor: "#F2F6FA !important",
            borderColor: "#C7D5E1 !important",
            color: "#17324D !important",
          },
          "& .fc-button:focus": { boxShadow: "none !important" },
          "& .fc-button-active, & .fc-button:not(:disabled).fc-button-active": {
            backgroundColor: "#EAF2F8 !important",
            color: "#17324D !important",
            border: "1px solid #C7D5E1 !important",
            boxShadow: "none !important",
          },
          // Today button gets a slightly stronger muted-blue fill.
          "& .fc-today-button": {
            backgroundColor: "#EAF2F8 !important",
            color: "#17324D !important",
            border: "1px solid #C7D5E1 !important",
          },
          "& .fc-today-button:hover:not(:disabled)": {
            backgroundColor: "#D8E5EF !important",
            borderColor: "#B4C7D8 !important",
          },
          // Weekday header — very subtle gradient band, uppercase text.
          "& .fc-col-header": {
            backgroundColor: "#F7FAFC !important",
          },
          "& .fc-col-header-cell": { borderColor: "#E8EDF2 !important" },
          "& .fc-col-header-cell-cushion": {
            fontSize: "11px !important", fontWeight: "700 !important",
            textTransform: "uppercase", letterSpacing: "0.08em",
            color: "#65798D !important", padding: "11px 8px !important",
          },
          // Day cells
          "& .fc-daygrid-day": { backgroundColor: "#FFFFFF" },
          "& .fc-day-other": { backgroundColor: "#FBFCFD !important" },
          "& .fc-daygrid-day:hover": { backgroundColor: "#F8FBFD" },
          "& .fc-day-today": { backgroundColor: "#F0F6FA !important" },
          "& .fc-day-today .fc-daygrid-day-number": {
            display: "inline-flex !important", alignItems: "center", justifyContent: "center",
            width: 26, height: 26, borderRadius: "50% !important",
            background: "#5F86AC !important",
            color: "#fff !important", fontWeight: "800 !important",
            boxShadow: "0 3px 8px rgba(95,134,172,0.24) !important",
            margin: "6px 6px 0 0 !important",
          },
          "& .fc-daygrid-day-number": {
            fontSize: "12.5px !important", fontWeight: "600 !important",
            color: "#17324D !important", padding: "6px 10px !important",
          },
          "& .fc-day-other .fc-daygrid-day-number": { color: "#C8D2DC !important" },
          "& .fc-scrollgrid": {
            border: "1px solid #E8EDF2 !important",
            borderRadius: "12px !important", overflow: "hidden",
          },
          "& .fc td, & .fc th": { borderColor: "#E8EDF2 !important" },
          // Event blocks — transparent wrapper; the inner div owns paint.
          "& .fc-daygrid-event-dot": { display: "none !important" },
          "& .fc-daygrid-event": {
            marginBottom: "4px !important", border: "none !important",
            background: "transparent !important", padding: "0 !important",
          },
          "& .fc-daygrid-more-link": {
            color: "#4E78A6 !important", fontWeight: "700 !important",
            fontSize: "11px !important", textDecoration: "none !important",
            padding: "2px 6px !important",
            borderRadius: "999px !important",
            backgroundColor: "#EAF2F8 !important",
          },
        }}>
          <FullCalendar
            plugins={[dayGridPlugin]}
            initialView="dayGridMonth"
            events={calEvents}
            headerToolbar={{ left: "prev,next today", center: "title", right: "" }}
            height="auto"
            dayMaxEvents={2}
            eventDisplay="block"
            datesSet={(info) => setCalMonth(dayjs(info.start).add(15, "day").format("YYYY-MM"))}
            eventClick={(info) => { info.jsEvent.preventDefault(); const ep = info.event.extendedProps; if (ep.id) navigate(`/parent-portal/classes/${ep.id}`); else setDetailCls(ep); }}
            eventContent={(eventInfo) => {
              const ep = eventInfo.event.extendedProps as any;
              const s = subjectStyle(ep.subjectName);
              const isCompleted = ep.status === "completed";
              const isCancelled = ep.status === "cancelled";
              // Subject identity remains the base color; status is a
              // tiny badge only, so semantic accents never override the
              // subject's visual grouping.
              const bg = isCancelled ? "#FCF3F4" : s.bg;
              const border = isCancelled ? "#D97882" : s.border;
              const text = isCancelled ? "#B75F68" : s.text;
              const subjects = (ep.subjectName || "Class").replace(/,\s*/g, " + ");
              return (
                <div
                  className="parent-event-card"
                  style={{
                    background: bg,
                    borderLeft: `3px solid ${border}`,
                    color: text,
                    borderRadius: "8px",
                    padding: "5px 8px",
                    overflow: "hidden",
                    cursor: "pointer",
                    lineHeight: 1.2,
                    boxShadow: "0 2px 6px rgba(23,50,77,0.06)",
                    transition: "transform 0.15s, box-shadow 0.15s",
                    display: "flex", flexDirection: "column", gap: "1px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 4, minWidth: 0 }}>
                    <span style={{ fontSize: 10, fontWeight: 800, color: text, letterSpacing: "0.02em", flexShrink: 0 }}>
                      {fmt12(ep.startTime)}
                    </span>
                    {isCompleted && (
                      <span title="Completed" style={{ display: "inline-flex", width: 12, height: 12, borderRadius: "50%", background: "#5BAA83", color: "#fff", alignItems: "center", justifyContent: "center", fontSize: 9, fontWeight: 800, lineHeight: 1, flexShrink: 0 }}>✓</span>
                    )}
                    {!isCompleted && !isCancelled && (
                      <span title="Scheduled" style={{ display: "inline-flex", width: 6, height: 6, borderRadius: "50%", background: border, flexShrink: 0 }} />
                    )}
                    {isCancelled && (
                      <span title="Cancelled" style={{ fontSize: 10, fontWeight: 800, color: "#B75F68", flexShrink: 0 }}>×</span>
                    )}
                  </div>
                  <div style={{ fontSize: 11.5, fontWeight: 700, color: text, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {subjects}
                  </div>
                  {(ep.locationName || ep.classMode) && (
                    <div style={{ fontSize: 10, fontWeight: 600, color: text, opacity: 0.7, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {ep.locationName || (ep.classMode === "Online" ? "Online" : "In Person")}
                    </div>
                  )}
                </div>
              );
            }}
            eventDidMount={(info) => {
              const el = info.el as HTMLElement;
              const card = el.querySelector(".parent-event-card") as HTMLElement | null;
              if (!card) return;
              el.addEventListener("mouseenter", () => {
                card.style.transform = "translateY(-1px)";
                card.style.boxShadow = "0 5px 12px rgba(23,50,77,0.10)";
              });
              el.addEventListener("mouseleave", () => {
                card.style.transform = "";
                card.style.boxShadow = "0 2px 6px rgba(23,50,77,0.06)";
              });
            }}
          />
        </Box>
      ) : isEmpty ? (
        <Box sx={{
          bgcolor: "#FFFFFF", borderRadius: "16px",
          border: "1px solid #E2E8F0",
          boxShadow: "0 6px 18px rgba(23,50,77,0.05)",
          textAlign: "center", py: 5, px: 3,
        }}>
          <Box sx={{
            width: 56, height: 56, borderRadius: "16px",
            bgcolor: "#EAF2F8", color: "#4E78A6",
            display: "flex", alignItems: "center", justifyContent: "center",
            mx: "auto", mb: 1.5,
          }}>
            <EventNoteIcon sx={{ fontSize: 26 }} />
          </Box>
          <Typography sx={{ fontSize: 15, fontWeight: 800, color: "#17324D", mb: 0.5 }}>No upcoming classes</Typography>
          <Typography sx={{ fontSize: 12.5, color: "#7D8FA1" }}>{activeChild?.studentName || "Your child"} has no classes scheduled.</Typography>
        </Box>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
          {grouped.map(([date, dayClasses]) => (
            <Box key={date}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.25 }}>
                <Typography sx={{ fontSize: 14, fontWeight: 800, color: dayjs(date).isSame(dayjs(), "day") ? "#4E78A6" : "#17324D", letterSpacing: "-0.01em" }}>{formatDayLabel(date)}</Typography>
                <Typography sx={{ fontSize: 11, color: "#7D8FA1", fontWeight: 600 }}>{dayjs(date).format("MMM D")}</Typography>
                <Chip label={`${dayClasses.length} class${dayClasses.length > 1 ? "es" : ""}`} size="small" sx={{ height: 20, fontSize: 10, fontWeight: 700, bgcolor: "#EAF2F8", color: "#4E78A6", border: "1px solid #D6E1EA" }} />
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
                {dayClasses.map((cls: any, i: number) => {
                  const isCompleted = cls.status === "completed";
                  const isCancelled = cls.status === "cancelled";
                  const isPast = dayjs(cls.scheduledDate).isBefore(dayjs(), "day");
                  const s = subjectStyle(cls.subjectName);
                  const subjects = (cls.subjectName || "").replace(/,\s*/g, " + ");
                  const statusChip = isCompleted
                    ? { label: "Completed", bg: "#F1F8F4", fg: "#467F66", border: "#CDE6D8" }
                    : isCancelled
                    ? { label: "Cancelled", bg: "#FCF3F4", fg: "#B75F68", border: "#ECCDD1" }
                    : isPast
                    ? { label: "Missed",    bg: "#FBF7ED", fg: "#9B7A36", border: "#E8D9B1" }
                    : { label: "Upcoming",  bg: "#EAF2F8", fg: "#4E78A6", border: "#D6E1EA" };
                  return (
                    <Box key={cls.id || i} onClick={() => cls.id ? navigate(`/parent-portal/classes/${cls.id}`) : setDetailCls(cls)} sx={{
                      bgcolor: "#FFFFFF", borderRadius: "14px",
                      border: "1px solid #E2E8F0",
                      borderLeft: `4px solid ${s.border}`,
                      display: "flex", alignItems: "center", gap: 2, px: 2.5, py: 2,
                      opacity: isPast && !isCompleted ? 0.65 : 1,
                      cursor: "pointer",
                      boxShadow: "0 2px 6px rgba(23,50,77,0.06)",
                      transition: "transform 0.15s, box-shadow 0.15s",
                      "&:hover": { transform: "translateY(-1px)", boxShadow: "0 5px 12px rgba(23,50,77,0.10)" },
                    }}>
                      <Box sx={{
                        textAlign: "center", minWidth: 72, flexShrink: 0,
                        bgcolor: s.bg, border: `1px solid ${alpha(s.border, 0.35)}`,
                        borderRadius: "10px", py: 1, px: 0.75,
                      }}>
                        <Typography sx={{ fontSize: 14, fontWeight: 800, color: s.text, lineHeight: 1 }}>{fmt12(cls.startTime)}</Typography>
                        <Typography sx={{ fontSize: 10, color: alpha(s.text, 0.65), mt: 0.25 }}>{fmt12(cls.endTime)}</Typography>
                      </Box>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#17324D" }}>
                          {cls.gradeName ? `${cls.gradeName} — ` : ""}{subjects || "Class"}
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mt: 0.5, flexWrap: "wrap" }}>
                          {cls.staffName && (
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                              <PersonOutlineIcon sx={{ fontSize: 13, color: "#7D8FA1" }} />
                              <Typography sx={{ fontSize: 11.5, color: "#6B7F92", fontWeight: 600 }}>{cls.staffName}</Typography>
                            </Box>
                          )}
                          {cls.locationName && (
                            <Chip icon={<PlaceIcon sx={{ fontSize: "11px !important", color: `${s.text} !important` }} />} label={cls.locationName} size="small"
                              sx={{ height: 20, fontSize: 10, fontWeight: 700, bgcolor: s.bg, color: s.text, border: `1px solid ${alpha(s.border, 0.35)}`, "& .MuiChip-label": { px: 0.5 } }} />
                          )}
                          {cls.classMode && (
                            <Chip icon={cls.classMode === "Online" ? <LaptopIcon sx={{ fontSize: "11px !important", color: "#4E78A6 !important" }} /> : <PlaceIcon sx={{ fontSize: "11px !important", color: "#5F86AC !important" }} />}
                              label={cls.classMode === "Online" ? "Online" : "In Person"} size="small"
                              sx={{ height: 20, fontSize: 10, fontWeight: 700, bgcolor: "#EAF2F8", color: "#4E78A6", border: "1px solid #D6E1EA", "& .MuiChip-label": { px: 0.5 } }} />
                          )}
                        </Box>
                      </Box>
                      <Chip label={statusChip.label} size="small"
                        sx={{ height: 24, fontSize: 10.5, fontWeight: 800, flexShrink: 0, bgcolor: statusChip.bg, color: statusChip.fg, border: `1px solid ${statusChip.border}` }} />
                    </Box>
                  );
                })}
              </Box>
            </Box>
          ))}
        </Box>
      )}

      {detailCls && (
        <Box onClick={() => setDetailCls(null)} sx={{ position: "fixed", inset: 0, zIndex: 1300, bgcolor: "rgba(0,0,0,0.4)", backdropFilter: "blur(3px)", display: "flex", alignItems: "center", justifyContent: "center", p: 2 }}>
          <Box onClick={(e) => e.stopPropagation()} sx={{ bgcolor: "#fff", borderRadius: "20px", maxWidth: 420, width: "100%", boxShadow: "0 25px 50px rgba(0,0,0,0.2)", overflow: "hidden" }}>
            <Box sx={{ bgcolor: getAccent(detailCls.subjectName), px: 3, py: 2.5, color: "#fff" }}>
              <Typography sx={{ fontSize: 10, fontWeight: 600, opacity: 0.7, textTransform: "uppercase", letterSpacing: "0.06em" }}>Class Details</Typography>
              <Typography sx={{ fontSize: 20, fontWeight: 800, mt: 0.25 }}>
                {detailCls.gradeName ? `${detailCls.gradeName} — ` : ""}{(detailCls.subjectName || "Class").replace(/,\s*/g, " + ")}
              </Typography>
              <Typography sx={{ fontSize: 13, opacity: 0.85, mt: 0.5 }}>
                {dayjs(detailCls.scheduledDate).format("dddd, MMMM D, YYYY")}
              </Typography>
            </Box>
            <Box sx={{ px: 3, py: 2.5 }}>
              {[
                { icon: <AccessTimeIcon sx={{ fontSize: 16 }} />, label: "Time", value: formatTimeRange(detailCls.startTime, detailCls.endTime) },
                { icon: <PersonOutlineIcon sx={{ fontSize: 16 }} />, label: "Teacher", value: detailCls.staffName },
                { icon: <PlaceIcon sx={{ fontSize: 16 }} />, label: "Location", value: detailCls.locationName || "Not specified" },
                { icon: <LaptopIcon sx={{ fontSize: 16 }} />, label: "Mode", value: detailCls.classMode === "Online" ? "Online" : "In Person" },
              ].map((r, i) => (
                <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 1.5, py: 1.25, borderBottom: i < 3 ? "1px solid rgba(0,0,0,0.04)" : "none" }}>
                  <Box sx={{ color: "text.disabled", display: "flex" }}>{r.icon}</Box>
                  <Box>
                    <Typography sx={{ fontSize: 10, fontWeight: 600, color: "text.disabled", textTransform: "uppercase", letterSpacing: "0.04em" }}>{r.label}</Typography>
                    <Typography sx={{ fontSize: 13.5, fontWeight: 500 }}>{r.value || "—"}</Typography>
                  </Box>
                </Box>
              ))}
            </Box>
            <Box sx={{ px: 3, pb: 2.5, display: "flex", gap: 1 }}>
              {[
                { label: "Mark Absent", color: "#ef4444", onClick: () => { setDetailCls(null); navigate("/parent-portal/attendance"); } },
                { label: "Request Makeup", color: "#f59e0b", onClick: () => { setDetailCls(null); navigate("/parent-portal/classes"); } },
                { label: "Message", color: "#0ea5e9", onClick: () => { setDetailCls(null); navigate("/chat"); } },
              ].map((a) => (
                <Button key={a.label} size="small" fullWidth variant="outlined" onClick={a.onClick}
                  sx={{ textTransform: "none", fontSize: 11.5, fontWeight: 600, borderRadius: "10px", borderColor: alpha(a.color, 0.3), color: a.color, "&:hover": { bgcolor: alpha(a.color, 0.04), borderColor: a.color } }}>
                  {a.label}
                </Button>
              ))}
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

// ════════════════════════════════════════
// Phase-2 Attendance Page
// ════════════════════════════════════════

const statusChipStyle = (status: string) => {
  switch (status) {
    case "present":       return { label: "Present",      bg: alpha("#22c55e", 0.14), fg: "#15803d" };
    case "late":          return { label: "Late",         bg: alpha("#f59e0b", 0.16), fg: "#b45309" };
    case "absent":        return { label: "Absent",       bg: alpha("#ef4444", 0.14), fg: "#b91c1c" };
    case "excused":       return { label: "Excused",      bg: alpha("#0ea5e9", 0.14), fg: "#0369a1" };
    case "not_recorded":  return { label: "Not Recorded", bg: "rgba(0,0,0,0.06)",     fg: "#6b7280" };
    default:              return { label: status || "—",  bg: "rgba(0,0,0,0.06)",     fg: "#6b7280" };
  }
};

// ════════════════════════════════════════
// Record Book Page — filterable class-history table (Aug 2026)
// ════════════════════════════════════════
//
// Read-only Parent-safe class-history table matching the client's
// reference "Record Book" screenshot. Reuses the SAME child-scoped
// useGetChildClassesQuery endpoint the Time Table page uses; no new
// backend endpoint added. Data is filtered client-side within the
// fetched window (server still owns the parent → student scope).

// ════════════════════════════════════════
// Report Cards Page — replaces the previous Record Book surface.
// Backend has no report_cards storage yet, so this renders the
// premium student header + a polished empty state until data lands.
// ════════════════════════════════════════
const ParentReportCardsPage = () => {
  const { selectedChild, activeChild } = useChild();
  const [yearFilter, setYearFilter] = React.useState<string>("all");

  const { data, isLoading, isFetching } = useGetChildReportCardsQuery(
    { studentId: selectedChild },
    { skip: !selectedChild },
  );

  const payload: any = data?.data || null;
  const academicYear: string | null = payload?.academic_year ?? null;
  const reportCards: any[] = Array.isArray(payload?.report_cards) ? payload.report_cards : [];

  const years = React.useMemo(() => {
    const set = new Set<string>();
    reportCards.forEach((r) => { if (r?.academic_year) set.add(String(r.academic_year)); });
    return Array.from(set).sort().reverse();
  }, [reportCards]);

  const filtered = React.useMemo(() => {
    if (yearFilter === "all") return reportCards;
    return reportCards.filter((r) => String(r?.academic_year || "") === yearFilter);
  }, [reportCards, yearFilter]);

  const publishedCount = reportCards.filter((r) => String(r?.status || "").toLowerCase() === "published").length;
  const latestTerm = reportCards
    .filter((r) => r?.term)
    .map((r) => String(r.term))
    .sort()
    .pop() || null;

  const statusTone = (s: string): "green" | "amber" | "grey" => {
    const v = s.toLowerCase();
    if (v === "published" || v === "available") return "green";
    if (v === "draft") return "amber";
    return "grey";
  };

  // When the parent has no published report cards, the tall 3-tile
  // KPI grid becomes a single lonely "Academic Year" card and reads
  // as wasted space. In that case we render a compact toolbar strip
  // instead. When real report cards exist the full KPI grid stays
  // because the numbers are actually useful there.
  const hasCards = reportCards.length > 0;

  return (
    <Box>
      {/* Hero — tightened to sit close to the content below. */}
      <Box sx={{ mb: 1.5 }}>
        <Typography sx={{ fontSize: 11, fontWeight: 800, color: pp.color.muted, textTransform: "uppercase", letterSpacing: "0.1em" }}>
          Parent Portal
        </Typography>
        <Typography sx={{ fontSize: 22, fontWeight: 800, letterSpacing: "-0.01em", mt: 0.25, color: pp.color.text }}>
          Report Cards
        </Typography>
        {activeChild && (
          <Typography sx={{ fontSize: 13, color: pp.color.muted, mt: 0.25 }}>
            {activeChild.studentName || "Your child"}
            {activeChild.gradeLabel ? ` · ${activeChild.gradeLabel}` : ""}
            {academicYear ? ` · ${academicYear} Academic Year` : ""}
          </Typography>
        )}
      </Box>

      <ChildSelectorBar />

      {/* When there are real report cards, keep the informative KPI
          row (Academic Year + Available + Latest Term). Otherwise
          render the compact academic-year toolbar below. */}
      {hasCards && (
        <Box sx={{
          display: "grid",
          gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: `repeat(${[academicYear, "count", latestTerm].filter(Boolean).length || 1}, 1fr)` },
          gap: 1.5, mt: 1.5, mb: 2,
        }}>
          {academicYear && (
            <PortalKpi
              label="Academic Year"
              value={academicYear}
              icon={<CalendarTodayIcon />}
              accent="blue"
            />
          )}
          <PortalKpi
            label="Report Cards Available"
            value={String(publishedCount)}
            icon={<ArticleOutlinedIcon />}
            accent="green"
          />
          {latestTerm && (
            <PortalKpi
              label="Latest Term"
              value={latestTerm}
              icon={<CheckCircleOutlineIcon />}
              accent="navy"
            />
          )}
        </Box>
      )}

      {/* Compact academic-year strip — only when no report cards yet,
          so the page still shows the year context without a giant
          full-width tile. Height ~80px, same visual language as the
          Profile & Account settings rows. */}
      {!hasCards && academicYear && (
        <PortalCard sx={{ mt: 1.5, mb: 2, p: 1.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Box sx={{
              width: 40, height: 40, borderRadius: `${pp.radius.sm}px`,
              bgcolor: pp.surface.blue, color: pp.color.blue,
              display: "flex", alignItems: "center", justifyContent: "center",
              "& svg": { fontSize: 20 }, flexShrink: 0,
            }}>
              <CalendarTodayIcon />
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{
                fontSize: 10.5, fontWeight: 800, color: pp.color.muted,
                textTransform: "uppercase", letterSpacing: "0.08em",
              }}>
                Academic Year
              </Typography>
              <Typography sx={{
                fontSize: 15, fontWeight: 800, color: pp.color.text,
                letterSpacing: "-0.01em", mt: 0.15,
              }}>
                {academicYear}
              </Typography>
            </Box>
          </Box>
        </PortalCard>
      )}

      {/* Filter row — only shown when we have >1 year to filter by. */}
      {years.length > 1 && (
        <PortalCard sx={{ mt: 2, p: 1.5 }}>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.25, alignItems: "center" }}>
            <FormControl size="small" sx={{ minWidth: 180 }}>
              <Select value={yearFilter} onChange={(e) => setYearFilter(String(e.target.value))}
                sx={{ fontSize: 13, borderRadius: "10px", height: 36 }}>
                <MenuItem value="all" sx={{ fontSize: 13 }}>All Academic Years</MenuItem>
                {years.map((y) => (
                  <MenuItem key={y} value={y} sx={{ fontSize: 13 }}>{y}</MenuItem>
                ))}
              </Select>
            </FormControl>
            {yearFilter !== "all" && (
              <Button size="small" onClick={() => setYearFilter("all")}
                sx={{ textTransform: "none", fontWeight: 700 }}>Reset</Button>
            )}
            {isFetching && !isLoading && <CircularProgress size={16} />}
          </Box>
        </PortalCard>
      )}

      {/* Report cards — one card per academic-year window, composed
          from real assessment + attendance data. Multi-term schools
          can add per-term entries later; the DTO already supports it. */}
      {isLoading ? (
        <PortalCard sx={{ mt: 2, p: 6, display: "flex", justifyContent: "center" }}>
          <StepUpSpinner size="medium" />
        </PortalCard>
      ) : filtered.length === 0 ? (
        <>
          {/* Compact premium empty state — ~200px tall, centered.
              No fake report data; honest "not yet published" copy. */}
          <PortalCard sx={{
            mt: 2, p: 0, overflow: "hidden",
            minHeight: 200,
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <Box sx={{ textAlign: "center", py: 3, px: 3 }}>
              <Box sx={{
                width: 56, height: 56, borderRadius: `${pp.radius.md}px`,
                bgcolor: pp.surface.blue, color: pp.color.blue,
                display: "flex", alignItems: "center", justifyContent: "center",
                mx: "auto", mb: 1.5,
                "& svg": { fontSize: 26 },
              }}>
                <ArticleOutlinedIcon />
              </Box>
              <Typography sx={{ fontSize: 15, fontWeight: 800, color: pp.color.text, mb: 0.5 }}>
                No report cards available yet
              </Typography>
              <Typography sx={{ fontSize: 12.5, color: pp.color.muted, maxWidth: 420, mx: "auto" }}>
                Once your child's teachers publish graded assessments, their academic-year report card will appear here.
              </Typography>
            </Box>
          </PortalCard>
          {/* Slim info strip — reassures the parent this is a real
              "not yet published" state, not a page loading problem. */}
          <Box sx={{
            mt: 1.5, px: 1.5, py: 1.15,
            borderRadius: `${pp.radius.sm}px`,
            bgcolor: pp.surface.blue,
            border: `1px solid ${pp.color.border}`,
            display: "flex", alignItems: "center", gap: 1,
          }}>
            <InfoOutlinedIcon sx={{ fontSize: 16, color: pp.color.blue, flexShrink: 0 }} />
            <Typography sx={{ fontSize: 12, color: pp.color.text }}>
              Report cards become available here after they are published by the school.
            </Typography>
          </Box>
        </>
      ) : (
        <Box sx={{ mt: 2 }} className="printable-report">
          {filtered.map((r: any, idx: number) => {
            const summary = r?.summary || {};
            const subjects: any[] = Array.isArray(r?.subjects) ? r.subjects : [];
            const overall: number | null = summary?.overall_average ?? null;
            const overallColor = overall == null ? pp.color.muted
              : overall >= 90 ? "#16A34A"
              : overall >= 80 ? "#14B8A6"
              : overall >= 60 ? "#F59E0B"
              : "#B91C1C";
            return (
              <PortalCard key={r?.id ?? idx} sx={{ p: 0, overflow: "hidden", mb: 2 }}>
                {/* Card header — student + academic year + print */}
                <Box sx={{
                  px: 3, py: 2.25,
                  bgcolor: pp.color.navy,
                  color: "#fff",
                  display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, flexWrap: "wrap",
                }}>
                  <Box sx={{ minWidth: 0 }}>
                    <Typography sx={{ fontSize: 10.5, fontWeight: 800, letterSpacing: "0.8px", textTransform: "uppercase", opacity: 0.75 }}>
                      Report Card
                    </Typography>
                    <Typography sx={{ fontSize: 18, fontWeight: 800, lineHeight: 1.2, mt: 0.25 }}>
                      {activeChild?.studentName || "Student"}
                      {activeChild?.gradeLabel ? ` · ${activeChild.gradeLabel}` : ""}
                    </Typography>
                    <Typography sx={{ fontSize: 12, opacity: 0.85 }}>
                      {r?.academic_year ? `${r.academic_year} Academic Year` : ""}
                      {r?.term ? ` · ${r.term}` : ""}
                      {r?.issued_at ? ` · Issued ${dayjs(r.issued_at).format("MMM D, YYYY")}` : ""}
                    </Typography>
                  </Box>
                  <Button
                    className="no-print"
                    size="small"
                    variant="outlined"
                    startIcon={<PictureAsPdfOutlinedIcon />}
                    onClick={() => window.print()}
                    sx={{
                      textTransform: "none", fontWeight: 700, borderRadius: 2,
                      color: "#fff", borderColor: "rgba(255,255,255,0.35)",
                      "&:hover": { borderColor: "#fff", bgcolor: "rgba(255,255,255,0.08)" },
                    }}
                  >
                    Print Report
                  </Button>
                </Box>

                {/* Summary KPIs */}
                <Box sx={{ p: 2, borderBottom: `1px solid ${pp.color.border}` }}>
                  <Box sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "repeat(3, 1fr)", md: "repeat(5, 1fr)" },
                    gap: 1.25,
                  }}>
                    <ReportSummaryTile label="Overall Average"
                      value={overall != null ? `${overall}%` : "—"} tint={overallColor} />
                    <ReportSummaryTile label="Graded"
                      value={String(summary?.graded_assessments ?? 0)} tint="#1D4ED8" />
                    <ReportSummaryTile label="Passed"
                      value={String(summary?.passed ?? 0)} tint="#16A34A" />
                    <ReportSummaryTile label="Below Pass"
                      value={String(summary?.failed ?? 0)} tint="#B91C1C" />
                    <ReportSummaryTile label="Attendance"
                      value={summary?.attendance_rate != null ? `${summary.attendance_rate}%` : "—"} tint="#14B8A6" />
                  </Box>
                </Box>

                {/* Subjects */}
                <Box sx={{ p: 2 }}>
                  <Typography sx={{ fontSize: 12, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.6px", color: pp.color.muted, mb: 1 }}>
                    Subject Performance
                  </Typography>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
                    {subjects.map((s: any) => {
                      const avg: number | null = s?.average ?? null;
                      const sColor = avg == null ? pp.color.muted
                        : avg >= 90 ? "#16A34A"
                        : avg >= 80 ? "#14B8A6"
                        : avg >= 60 ? "#F59E0B"
                        : "#B91C1C";
                      return (
                        <Box key={s?.subject_id ?? s?.subject_name} sx={{
                          border: `1px solid ${pp.color.border}`, borderRadius: `${pp.radius.md}px`,
                          overflow: "hidden",
                        }}>
                          <Box sx={{
                            display: "flex", alignItems: "center", justifyContent: "space-between",
                            gap: 1.5, p: 1.5, bgcolor: "#f8fafc",
                            borderBottom: `1px solid ${pp.color.border}`,
                          }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
                              <Box sx={{
                                width: 34, height: 34, borderRadius: "9px",
                                bgcolor: alpha(sColor, 0.14), color: sColor,
                                display: "flex", alignItems: "center", justifyContent: "center",
                              }}>
                                <MenuBookOutlinedIcon sx={{ fontSize: 18 }} />
                              </Box>
                              <Box sx={{ minWidth: 0 }}>
                                <Typography sx={{ fontSize: 14, fontWeight: 800, color: pp.color.text }}>
                                  {s?.subject_name || "Subject"}
                                </Typography>
                                <Typography sx={{ fontSize: 11.5, color: pp.color.muted }}>
                                  {s?.assessments_count ?? 0} graded assessment{(s?.assessments_count ?? 0) === 1 ? "" : "s"}
                                </Typography>
                              </Box>
                            </Box>
                            <Box sx={{ textAlign: "right" }}>
                              <Typography sx={{
                                fontSize: 20, fontWeight: 800, color: sColor,
                                lineHeight: 1, fontVariantNumeric: "tabular-nums",
                              }}>
                                {avg != null ? `${avg}%` : "—"}
                              </Typography>
                              <Typography sx={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.4px", textTransform: "uppercase", color: pp.color.muted }}>
                                Average
                              </Typography>
                            </Box>
                          </Box>
                          <Box sx={{ display: "flex", flexDirection: "column" }}>
                            {(Array.isArray(s?.assessments) ? s.assessments : []).map((a: any, i: number) => (
                              <Box key={a?.assessment_id ?? i} sx={{
                                px: 1.75, py: 1.25,
                                borderTop: i === 0 ? "none" : `1px solid ${pp.color.border}`,
                                display: "grid",
                                gridTemplateColumns: { xs: "1fr", sm: "1.4fr 1fr auto auto" },
                                alignItems: "center", gap: 1.25,
                              }}>
                                <Box sx={{ minWidth: 0 }}>
                                  <Typography sx={{ fontSize: 13, fontWeight: 700, color: pp.color.text }} noWrap>
                                    {a?.name || "Assessment"}
                                  </Typography>
                                  {a?.staff && (
                                    <Typography sx={{ fontSize: 11, color: pp.color.muted }} noWrap>
                                      Teacher: {a.staff}
                                    </Typography>
                                  )}
                                </Box>
                                <Typography sx={{ fontSize: 12, color: pp.color.muted }}>
                                  {a?.date ? dayjs(a.date).format("MMM D, YYYY") : "—"}
                                </Typography>
                                <Typography sx={{
                                  fontSize: 13, fontWeight: 800, color: pp.color.text,
                                  fontVariantNumeric: "tabular-nums", textAlign: "right",
                                }}>
                                  {a?.score != null && a?.max_score != null
                                    ? `${a.score} / ${a.max_score}`
                                    : "—"}
                                </Typography>
                                <Typography sx={{
                                  fontSize: 13, fontWeight: 800,
                                  color: a?.percentage == null ? pp.color.muted
                                    : a.percentage >= 90 ? "#16A34A"
                                    : a.percentage >= 80 ? "#14B8A6"
                                    : a.percentage >= 60 ? "#F59E0B"
                                    : "#B91C1C",
                                  fontVariantNumeric: "tabular-nums", textAlign: "right", minWidth: 56,
                                }}>
                                  {a?.percentage != null ? `${a.percentage}%` : "—"}
                                </Typography>
                                {a?.feedback && (
                                  <Box sx={{ gridColumn: "1 / -1", mt: 0.5, p: 1, borderRadius: 1, bgcolor: alpha("#3B82F6", 0.06) }}>
                                    <Typography sx={{ fontSize: 11.5, color: pp.color.text }}>
                                      <Box component="span" sx={{ fontWeight: 700 }}>Teacher feedback:</Box> {a.feedback}
                                    </Typography>
                                  </Box>
                                )}
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              </PortalCard>
            );
          })}
        </Box>
      )}
      {/* Print CSS — hides sidebar/nav, keeps the report card body. */}
      <style>{`
        @media print {
          body * { visibility: hidden; }
          .printable-report, .printable-report * { visibility: visible; }
          .printable-report { position: absolute; left: 0; top: 0; width: 100%; }
          .no-print { display: none !important; }
        }
      `}</style>
    </Box>
  );
};

const ReportSummaryTile: React.FC<{ label: string; value: string; tint: string }> = ({ label, value, tint }) => (
  <Box sx={{
    p: 1.25, borderRadius: `${pp.radius.md}px`,
    bgcolor: alpha(tint, 0.08), border: `1px solid ${alpha(tint, 0.22)}`,
    textAlign: "left",
  }}>
    <Typography sx={{
      fontSize: 10, fontWeight: 800, letterSpacing: "0.5px",
      textTransform: "uppercase", color: pp.color.muted,
    }}>
      {label}
    </Typography>
    <Typography sx={{
      fontSize: 20, fontWeight: 800, color: tint,
      fontVariantNumeric: "tabular-nums", mt: 0.25, lineHeight: 1.1,
    }}>
      {value}
    </Typography>
  </Box>
);

// ════════════════════════════════════════
// Parent Portal — Attendance (redesign, Aug 2026)
// UI-only refresh. Same queries, same filters, same authorization.
// Introduces premium KPI tiles (icon chip + tinted surface + accent
// bar), a refined filter toolbar, and a table with clearer hierarchy
// (day-of-week eyebrow, class primary, grade secondary, dot-status pill).
// ════════════════════════════════════════
const attendanceStatusVisual = (status: string): {
  label: string; tone: string; bg: string; ring: string; icon: React.ReactNode;
} => {
  switch (status) {
    case "present":
      return { label: "Present", tone: "#15803d", bg: pp.surface.mint,  ring: "#22c55e",
        icon: <CheckCircleOutlineIcon sx={{ fontSize: 14 }} /> };
    case "late":
      return { label: "Late",    tone: "#b45309", bg: pp.surface.amber, ring: "#f59e0b",
        icon: <ScheduleOutlinedIcon sx={{ fontSize: 14 }} /> };
    case "absent":
      return { label: "Absent",  tone: "#b91c1c", bg: pp.surface.red,   ring: "#ef4444",
        icon: <EventBusyOutlinedIcon sx={{ fontSize: 14 }} /> };
    case "excused":
      return { label: "Excused", tone: "#0369a1", bg: pp.surface.blue,  ring: "#0ea5e9",
        icon: <CheckCircleOutlineIcon sx={{ fontSize: 14 }} /> };
    case "not_recorded":
      return { label: "Not Recorded", tone: "#4b5563", bg: pp.surface.grey, ring: "#9ca3af",
        icon: <HelpOutlineOutlinedIcon sx={{ fontSize: 14 }} /> };
    default:
      return { label: status || "—", tone: pp.color.muted, bg: pp.surface.grey, ring: "#9ca3af",
        icon: <HelpOutlineOutlinedIcon sx={{ fontSize: 14 }} /> };
  }
};

// Premium month grid for the Parent Attendance page. Consumes the
// SAME records the table below uses (single API call for both views).
// Colors + labels match the KPI palette so parents get an instant
// visual read of the month's attendance health.
const ParentAttendanceCalendar: React.FC<{
  records: any[];
  monthCursor: string;
  isLoading: boolean;
  periodLabel: string;
}> = ({ records, monthCursor, isLoading, periodLabel }) => {
  const monthStart = dayjs(monthCursor + "-01").startOf("month");
  const daysInMonth = monthStart.daysInMonth();
  const leadingBlanks = monthStart.day(); // 0=Sun
  const totalCells = leadingBlanks + daysInMonth;
  const trailingBlanks = (7 - (totalCells % 7)) % 7;

  const byDate = React.useMemo(() => {
    const m = new Map<string, any[]>();
    (records || []).forEach((r) => {
      const k = String(r?.date || "").slice(0, 10);
      if (!k) return;
      if (!m.has(k)) m.set(k, []);
      m.get(k)!.push(r);
    });
    return m;
  }, [records]);

  const [popover, setPopover] = React.useState<{ anchor: HTMLElement; row: any } | null>(null);

  const statusColor = (s: string) => {
    switch (s) {
      case "present":       return { fg: "#15803d", bg: "#dcfce7", label: "Present", icon: "✓" };
      case "late":          return { fg: "#b45309", bg: "#fef3c7", label: "Late",    icon: "⏱" };
      case "absent":        return { fg: "#b91c1c", bg: "#fee2e2", label: "Absent",  icon: "✕" };
      case "excused":       return { fg: "#0369a1", bg: "#e0f2fe", label: "Excused", icon: "○" };
      case "not_recorded":  return { fg: "#475569", bg: "#f1f5f9", label: "Not Recorded", icon: "•" };
      default:              return { fg: "#475569", bg: "#f1f5f9", label: s || "—", icon: "•" };
    }
  };

  const cells: React.ReactNode[] = [];
  for (let i = 0; i < leadingBlanks; i++) {
    cells.push(<Box key={`b-${i}`} sx={{ minHeight: 92, bgcolor: "#fafbfc" }} />);
  }
  for (let d = 1; d <= daysInMonth; d++) {
    const dateStr = monthStart.date(d).format("YYYY-MM-DD");
    const rows = byDate.get(dateStr) || [];
    const isToday = dayjs().format("YYYY-MM-DD") === dateStr;
    cells.push(
      <Box key={dateStr} sx={{
        minHeight: 92, p: 0.75, bgcolor: "#fff",
        borderTop: `1px solid ${pp.color.border}`, borderLeft: `1px solid ${pp.color.border}`,
        display: "flex", flexDirection: "column", gap: 0.4,
      }}>
        <Typography sx={{
          fontSize: 11, fontWeight: 700,
          color: isToday ? "#fff" : pp.color.muted, alignSelf: "flex-start",
          bgcolor: isToday ? pp.color.blue : "transparent",
          borderRadius: "999px", px: isToday ? 0.75 : 0, minWidth: 20, textAlign: "center",
        }}>{d}</Typography>
        {rows.slice(0, 3).map((r, idx) => {
          const c = statusColor(String(r.status || ""));
          return (
            <Box
              key={idx}
              onClick={(e) => setPopover({ anchor: e.currentTarget, row: r })}
              sx={{
                cursor: "pointer",
                px: 0.75, py: 0.4, borderRadius: 1,
                bgcolor: c.bg, color: c.fg,
                fontSize: 10.5, fontWeight: 700,
                display: "flex", alignItems: "center", gap: 0.5,
                overflow: "hidden",
                "&:hover": { filter: "brightness(0.96)" },
              }}
            >
              <span style={{ fontSize: 10 }}>{c.icon}</span>
              <span style={{
                overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1,
              }}>
                {r.start_time ? dayjs(dateStr + " " + r.start_time).format("h:mm A") : ""} · {r.subject || "Class"}
              </span>
            </Box>
          );
        })}
        {rows.length > 3 && (
          <Typography sx={{ fontSize: 10, color: pp.color.muted, fontWeight: 700, pl: 0.5 }}>
            +{rows.length - 3} more
          </Typography>
        )}
      </Box>
    );
  }
  for (let i = 0; i < trailingBlanks; i++) {
    cells.push(<Box key={`t-${i}`} sx={{ minHeight: 92, bgcolor: "#fafbfc" }} />);
  }

  const legend: Array<{ status: string }> = [
    { status: "present" }, { status: "late" }, { status: "absent" },
    { status: "excused" }, { status: "not_recorded" },
  ];

  const detail = popover?.row;
  const detailColor = detail ? statusColor(String(detail.status || "")) : null;

  return (
    <Box sx={{
      bgcolor: pp.color.card, borderRadius: `${pp.radius.md}px`,
      border: `1px solid ${pp.color.border}`, boxShadow: pp.shadow.card,
      overflow: "hidden", mb: 2,
    }}>
      <Box sx={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        px: 2, py: 1.25, borderBottom: `1px solid ${pp.color.border}`, flexWrap: "wrap", gap: 1,
      }}>
        <Typography sx={{ fontSize: 14, fontWeight: 800, color: pp.color.text }}>
          {periodLabel}
        </Typography>
        <Stack direction="row" spacing={0.75} sx={{ flexWrap: "wrap" }}>
          {legend.map((l) => {
            const c = statusColor(l.status);
            return (
              <Box key={l.status} sx={{
                display: "inline-flex", alignItems: "center", gap: 0.4,
                px: 0.75, py: 0.25, borderRadius: 1,
                bgcolor: c.bg, color: c.fg, fontSize: 10.5, fontWeight: 700,
              }}>
                <span>{c.icon}</span><span>{c.label}</span>
              </Box>
            );
          })}
        </Stack>
      </Box>

      {isLoading ? (
        <Box sx={{ py: 6, display: "flex", justifyContent: "center" }}>
          <StepUpSpinner size="medium" />
        </Box>
      ) : (
        <Box sx={{ borderRight: `1px solid ${pp.color.border}`, borderBottom: `1px solid ${pp.color.border}` }}>
          <Box sx={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", bgcolor: "#f8fafc" }}>
            {["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].map((h) => (
              <Box key={h} sx={{
                px: 1, py: 0.75, fontSize: 10.5, fontWeight: 800, color: pp.color.muted,
                letterSpacing: "0.5px", textTransform: "uppercase",
                borderLeft: `1px solid ${pp.color.border}`, borderTop: `1px solid ${pp.color.border}`,
              }}>{h}</Box>
            ))}
          </Box>
          <Box sx={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)" }}>
            {cells}
          </Box>
        </Box>
      )}

      <Popover
        open={!!popover}
        anchorEl={popover?.anchor ?? null}
        onClose={() => setPopover(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{ sx: { borderRadius: "12px", boxShadow: "0 12px 40px rgba(15,23,42,0.14)", maxWidth: 320, mt: 0.5 } }}
      >
        {detail && detailColor && (
          <Box sx={{ p: 2 }}>
            <Box sx={{
              display: "inline-flex", alignItems: "center", gap: 0.5, mb: 1,
              px: 0.75, py: 0.25, borderRadius: 1, bgcolor: detailColor.bg, color: detailColor.fg,
              fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.5px",
            }}>
              <span>{detailColor.icon}</span><span>{detailColor.label}</span>
            </Box>
            <Typography sx={{ fontSize: 15, fontWeight: 800, color: pp.color.text }}>
              {detail.subject || "Class"}
            </Typography>
            <Typography sx={{ fontSize: 12, color: pp.color.muted, mt: 0.25 }}>
              {detail.date ? dayjs(detail.date).format("dddd, MMM D, YYYY") : ""}
              {detail.start_time ? ` · ${dayjs(detail.date + " " + detail.start_time).format("h:mm A")}` : ""}
              {detail.end_time ? ` – ${dayjs(detail.date + " " + detail.end_time).format("h:mm A")}` : ""}
            </Typography>
            <Divider sx={{ my: 1 }} />
            {detail.staff && (
              <Typography sx={{ fontSize: 12.5, color: pp.color.text }}>
                <Box component="span" sx={{ fontWeight: 700 }}>Teacher:</Box> {detail.staff}
              </Typography>
            )}
            {detail.grade && (
              <Typography sx={{ fontSize: 12.5, color: pp.color.text }}>
                <Box component="span" sx={{ fontWeight: 700 }}>Grade:</Box> {detail.grade}
              </Typography>
            )}
            {detail.location && (
              <Typography sx={{ fontSize: 12.5, color: pp.color.text }}>
                <Box component="span" sx={{ fontWeight: 700 }}>Location:</Box> {detail.location}
              </Typography>
            )}
          </Box>
        )}
      </Popover>
    </Box>
  );
};

const ParentAttendancePage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { selectedChild, activeChild } = useChild();

  const [monthCursor, setMonthCursor] = useState(dayjs().format("YYYY-MM"));
  const [subjectFilter, setSubjectFilter] = useState<number | "all">("all");
  const [statusFilter, setStatusFilter] = useState<string>("all");
  const [parentAttendanceView, setParentAttendanceView] = useState<"calendar" | "list">("calendar");

  const from = dayjs(monthCursor + "-01").startOf("month").format("YYYY-MM-DD");
  const to   = dayjs(monthCursor + "-01").endOf("month").format("YYYY-MM-DD");

  React.useEffect(() => { setSubjectFilter("all"); }, [selectedChild]);

  const { data, isLoading, isFetching } = useGetChildAttendanceDetailQuery(
    { studentId: selectedChild, from, to, subject_id: subjectFilter === "all" ? null : subjectFilter, status: statusFilter },
    { skip: !selectedChild },
  );

  const payload: any = data?.data || null;
  const summary = payload?.summary || null;
  const records: any[] = payload?.records || [];
  const subjects: { id: number; name: string }[] = payload?.subjects || [];
  const periodLabel: string = payload?.period?.label || dayjs(monthCursor + "-01").format("MMMM YYYY");

  const monthOptions = useMemo(() => {
    const opts: { value: string; label: string }[] = [];
    for (let i = -12; i <= 1; i++) {
      const d = dayjs().add(i, "month");
      opts.push({ value: d.format("YYYY-MM"), label: d.format("MMMM YYYY") });
    }
    return opts.reverse();
  }, []);

  // KPI tile spec — icon chip + tinted surface + colored accent bar +
  // strong number. `wide` marks the Attendance Rate hero.
  const kpis = [
    { key: "present",      label: "Present",         color: "#15803d", surface: pp.surface.mint,  icon: <CheckCircleOutlineIcon />, suffix: "" },
    { key: "late",         label: "Late",            color: "#b45309", surface: pp.surface.amber, icon: <ScheduleOutlinedIcon />,   suffix: "" },
    { key: "absent",       label: "Absent",          color: "#b91c1c", surface: pp.surface.red,   icon: <EventBusyOutlinedIcon />,  suffix: "" },
    { key: "not_recorded", label: "Not Recorded",    color: "#4b5563", surface: pp.surface.grey,  icon: <HelpOutlineOutlinedIcon />, suffix: "" },
    { key: "rate",         label: "Attendance Rate", color: pp.color.blue, surface: pp.surface.blue, icon: <TrendingUpIcon />,      suffix: "%" },
  ];

  const rateAvailable = summary?.attendance_rate != null;

  return (
    <Box>
      {/* Hero header — mb tightened so the student card sits closer.
          Header only consumes the height it actually needs. */}
      <Box sx={{ mb: 2 }}>
        <Typography sx={{ fontSize: 11, fontWeight: 800, color: pp.color.muted, textTransform: "uppercase", letterSpacing: "0.12em" }}>
          Parent Portal
        </Typography>
        <Typography sx={{ fontSize: { xs: 22, md: 26 }, fontWeight: 800, letterSpacing: "-0.02em", mt: 0.25, color: pp.color.text, lineHeight: 1.15 }}>
          Attendance
        </Typography>
        <Typography sx={{ fontSize: 13, color: pp.color.muted, mt: 0.5, maxWidth: 620 }}>
          Track attendance records, status, and participation for
          {activeChild ? <> <strong style={{ color: pp.color.text }}>{activeChild.studentName || "your child"}</strong></> : " the selected student"}
          {" "}· {periodLabel}
        </Typography>
      </Box>

      <ChildSelectorBar />

      {/* KPI tiles — 5 equal-width cards on desktop. Attendance Rate
          no longer spans 2 columns so the row stays visually balanced
          and the whole row stays shorter (no oversized rate tile
          forcing extra height). */}
      <Box sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "repeat(2, minmax(0, 1fr))",
          sm: "repeat(3, minmax(0, 1fr))",
          md: "repeat(5, minmax(0, 1fr))",
        },
        gap: 1.25, mb: 1.75,
      }}>
        {kpis.map((kpi) => {
          const raw = kpi.key === "rate"
            ? (rateAvailable ? summary.attendance_rate : null)
            : (summary?.[kpi.key] ?? null);
          const displayValue = raw == null ? "—" : `${raw}${kpi.suffix}`;
          return (
            <Box
              key={kpi.key}
              sx={{
                position: "relative",
                bgcolor: pp.color.card,
                borderRadius: `${pp.radius.md}px`,
                border: `1px solid ${pp.color.border}`,
                boxShadow: pp.shadow.card,
                overflow: "hidden",
                p: 1.5,
                transition: pp.transition,
                "&:hover": { boxShadow: pp.shadow.cardHover, borderColor: pp.color.borderStrong },
              }}
            >
              {/* Accent bar */}
              <Box sx={{ position: "absolute", left: 0, top: 0, bottom: 0, width: 3, bgcolor: kpi.color, opacity: 0.85 }} />
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                <Box sx={{
                  width: 28, height: 28, borderRadius: `${pp.radius.sm}px`,
                  bgcolor: kpi.surface, color: kpi.color, display: "flex",
                  alignItems: "center", justifyContent: "center",
                  "& svg": { fontSize: 16 },
                }}>
                  {kpi.icon}
                </Box>
                <Typography sx={{
                  fontSize: 10, fontWeight: 700, color: pp.color.muted,
                  textTransform: "uppercase", letterSpacing: "0.08em",
                  minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                }}>
                  {kpi.label}
                </Typography>
              </Box>
              {isLoading ? (
                <Box sx={{ height: 28, width: 60, bgcolor: alpha(pp.color.text, 0.06), borderRadius: 1 }} />
              ) : (
                <Typography sx={{
                  fontSize: 26, fontWeight: 800, color: raw == null ? pp.color.disabled : kpi.color,
                  lineHeight: 1.05, letterSpacing: "-0.02em",
                }}>
                  {displayValue}
                </Typography>
              )}
            </Box>
          );
        })}
      </Box>

      {/* Filter toolbar — tighter vertical padding + gap to remove
          the empty-white-strip feel between KPIs and table. */}
      <Box sx={{
        bgcolor: pp.color.card,
        borderRadius: `${pp.radius.md}px`,
        border: `1px solid ${pp.color.border}`,
        boxShadow: pp.shadow.card,
        px: 1.75, py: 1, mb: 1.5,
        display: "flex", flexWrap: "wrap", gap: 1.25, alignItems: "center",
      }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, color: pp.color.muted, pr: 1, borderRight: { sm: `1px solid ${pp.color.border}` }, pl: 0.5 }}>
          <FilterAltOutlinedIcon sx={{ fontSize: 18 }} />
          <Typography sx={{ fontSize: 12, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em" }}>Filters</Typography>
        </Box>
        <FormControl size="small" sx={{ minWidth: 190 }}>
          <Select
            value={monthCursor}
            onChange={(e) => setMonthCursor(String(e.target.value))}
            sx={{ fontSize: 13, borderRadius: "10px", height: 36, bgcolor: pp.surface.grey, "& fieldset": { border: "none" } }}
          >
            {monthOptions.map((m) => <MenuItem key={m.value} value={m.value} sx={{ fontSize: 13 }}>{m.label}</MenuItem>)}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 190 }}>
          <Select
            value={subjectFilter as any}
            onChange={(e) => setSubjectFilter(e.target.value === "all" ? "all" : Number(e.target.value))}
            sx={{ fontSize: 13, borderRadius: "10px", height: 36, bgcolor: pp.surface.grey, "& fieldset": { border: "none" } }}
          >
            <MenuItem value="all" sx={{ fontSize: 13 }}>All Subjects</MenuItem>
            {subjects.map((s) => <MenuItem key={s.id} value={s.id} sx={{ fontSize: 13 }}>{s.name}</MenuItem>)}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 170 }}>
          <Select
            value={statusFilter}
            onChange={(e) => setStatusFilter(String(e.target.value))}
            sx={{ fontSize: 13, borderRadius: "10px", height: 36, bgcolor: pp.surface.grey, "& fieldset": { border: "none" } }}
          >
            <MenuItem value="all" sx={{ fontSize: 13 }}>All Statuses</MenuItem>
            <MenuItem value="present" sx={{ fontSize: 13 }}>Present</MenuItem>
            <MenuItem value="late" sx={{ fontSize: 13 }}>Late</MenuItem>
            <MenuItem value="absent" sx={{ fontSize: 13 }}>Absent</MenuItem>
            <MenuItem value="excused" sx={{ fontSize: 13 }}>Excused</MenuItem>
            <MenuItem value="not_recorded" sx={{ fontSize: 13 }}>Not Recorded</MenuItem>
          </Select>
        </FormControl>
        <Box sx={{ flex: 1 }} />
        {isFetching && !isLoading && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, color: pp.color.muted, fontSize: 12 }}>
            <CircularProgress size={14} />
            <span>Updating…</span>
          </Box>
        )}
      </Box>

      {/* View mode toggle — Calendar (default) vs List. Both consume
          the SAME `records` payload (single query, no extra requests).
          Calendar makes status immediately visible; List keeps the
          searchable/filterable table for parents who prefer it. */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1.25, gap: 0.5 }}>
        <Box role="tablist" sx={{
          display: "inline-flex", p: 0.4, borderRadius: 2, bgcolor: alpha(pp.color.blue, 0.06),
          border: `1px solid ${alpha(pp.color.blue, 0.18)}`,
        }}>
          {(["calendar", "list"] as const).map((mode) => {
            const active = parentAttendanceView === mode;
            return (
              <Box
                key={mode}
                role="tab"
                aria-selected={active}
                onClick={() => setParentAttendanceView(mode)}
                sx={{
                  cursor: "pointer", px: 1.75, py: 0.6, borderRadius: 1.5,
                  fontSize: 12.5, fontWeight: 700,
                  color: active ? "#fff" : pp.color.blue,
                  bgcolor: active ? pp.color.blue : "transparent",
                  transition: pp.transition,
                }}
              >
                {mode === "calendar" ? "Calendar" : "List"}
              </Box>
            );
          })}
        </Box>
      </Box>
      {parentAttendanceView === "calendar" && (
        <ParentAttendanceCalendar
          records={records}
          monthCursor={monthCursor}
          isLoading={isLoading}
          periodLabel={periodLabel}
        />
      )}

      {/* Table card */}
      <Box sx={{
        bgcolor: pp.color.card,
        borderRadius: `${pp.radius.md}px`,
        border: `1px solid ${pp.color.border}`,
        boxShadow: pp.shadow.card,
        overflow: "hidden",
        display: parentAttendanceView === "list" ? "block" : "none",
      }}>
        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}><StepUpSpinner size="medium" /></Box>
        ) : records.length === 0 ? (
          <PortalEmptyState
            icon={<FactCheckOutlinedIcon />}
            tone="blue"
            title={summary && summary.total > 0
              ? "No sessions match the selected filters."
              : `No attendance records found for ${periodLabel}.`}
            body={summary && summary.total > 0 && summary.recorded === 0
              ? "Attendance has not been recorded yet for this period."
              : undefined}
          />
        ) : isMobile ? (
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            {records.map((r) => {
              const v = attendanceStatusVisual(r.status);
              return (
                <Box key={r.session_id} sx={{
                  px: 2, py: 1.75,
                  borderBottom: `1px solid ${pp.color.border}`,
                  "&:last-child": { borderBottom: "none" },
                  transition: pp.transition,
                  "&:hover": { bgcolor: alpha(pp.color.blue, 0.03) },
                }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1.5 }}>
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                      <Typography sx={{ fontSize: 10.5, fontWeight: 700, color: pp.color.muted, textTransform: "uppercase", letterSpacing: "0.08em" }}>
                        {dayjs(r.date).format("ddd")} · {dayjs(r.date).format("MMM D")}
                      </Typography>
                      <Typography sx={{ fontSize: 14, fontWeight: 700, color: pp.color.text, mt: 0.25 }}>
                        {r.subject || "Class"}
                      </Typography>
                      {r.grade && (
                        <Typography sx={{ fontSize: 12, color: pp.color.muted }}>{r.grade}</Typography>
                      )}
                      <Box sx={{ display: "flex", gap: 1.25, mt: 0.75, color: pp.color.muted, fontSize: 12, flexWrap: "wrap" }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                          <AccessTimeIcon sx={{ fontSize: 13 }} />
                          <span>{formatTimeRange(r.start_time, r.end_time)}</span>
                        </Box>
                        {r.staff && (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <PersonOutlineIcon sx={{ fontSize: 13 }} />
                            <span>{r.staff}</span>
                          </Box>
                        )}
                      </Box>
                    </Box>
                    <Box sx={{
                      display: "inline-flex", alignItems: "center", gap: 0.5,
                      bgcolor: v.bg, color: v.tone,
                      px: 1, py: 0.35, borderRadius: "999px",
                      fontSize: 11, fontWeight: 700,
                      border: `1px solid ${alpha(v.ring, 0.35)}`,
                      whiteSpace: "nowrap",
                    }}>
                      <Box sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: v.ring }} />
                      {v.label}
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </Box>
        ) : (
          <Box>
            <Box sx={{
              display: "grid",
              gridTemplateColumns: "140px minmax(320px, 1.6fr) minmax(180px, 0.8fr) 180px 150px",
              px: 2.5, py: 1.5,
              bgcolor: alpha(pp.color.navy, 0.03),
              borderBottom: `1px solid ${pp.color.border}`,
              fontSize: 10.5, fontWeight: 800, color: pp.color.muted,
              textTransform: "uppercase", letterSpacing: "0.08em",
            }}>
              <Box>Date</Box>
              <Box>Class / Subject</Box>
              <Box>Staff</Box>
              <Box>Time</Box>
              <Box sx={{ textAlign: "right" }}>Status</Box>
            </Box>
            {records.map((r) => {
              const v = attendanceStatusVisual(r.status);
              return (
                <Box
                  key={r.session_id}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "140px minmax(320px, 1.6fr) minmax(180px, 0.8fr) 180px 150px",
                    px: 2.5, py: 1.5,
                    borderBottom: `1px solid ${pp.color.border}`,
                    alignItems: "center",
                    fontSize: 13,
                    transition: pp.transition,
                    "&:last-child": { borderBottom: "none" },
                    "&:hover": { bgcolor: alpha(pp.color.blue, 0.03) },
                  }}
                >
                  {/* Date — day-of-week eyebrow + big date */}
                  <Box>
                    <Typography sx={{ fontSize: 10, fontWeight: 800, color: pp.color.muted, textTransform: "uppercase", letterSpacing: "0.08em" }}>
                      {dayjs(r.date).format("ddd")}
                    </Typography>
                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: pp.color.text, fontVariantNumeric: "tabular-nums", lineHeight: 1.2 }}>
                      {dayjs(r.date).format("MMM D, YYYY")}
                    </Typography>
                  </Box>

                  {/* Class / Subject — primary + secondary grade */}
                  <Box sx={{ minWidth: 0, pr: 2 }}>
                    <Typography sx={{ fontSize: 13.5, fontWeight: 700, color: pp.color.text, lineHeight: 1.25 }}>
                      {r.subject || "Class"}
                    </Typography>
                    {r.grade && (
                      <Typography sx={{ fontSize: 11.5, color: pp.color.muted, mt: 0.25 }}>
                        {r.grade}
                      </Typography>
                    )}
                  </Box>

                  {/* Staff */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, color: pp.color.text }}>
                    <Box sx={{
                      width: 22, height: 22, borderRadius: "50%",
                      bgcolor: alpha(pp.color.navy, 0.08), color: pp.color.navy,
                      display: "flex", alignItems: "center", justifyContent: "center",
                    }}>
                      <PersonOutlineIcon sx={{ fontSize: 14 }} />
                    </Box>
                    <Typography sx={{ fontSize: 12.5, color: pp.color.text, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {r.staff || <span style={{ color: pp.color.disabled }}>—</span>}
                    </Typography>
                  </Box>

                  {/* Time */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, color: pp.color.muted }}>
                    <AccessTimeIcon sx={{ fontSize: 15 }} />
                    <Typography sx={{ fontSize: 12.5, color: pp.color.text, fontVariantNumeric: "tabular-nums" }}>
                      {formatTimeRange(r.start_time, r.end_time)}
                    </Typography>
                  </Box>

                  {/* Status pill — dot + label + soft ring */}
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Box sx={{
                      display: "inline-flex", alignItems: "center", gap: 0.5,
                      bgcolor: v.bg, color: v.tone,
                      px: 1.1, py: 0.4, borderRadius: "999px",
                      fontSize: 11, fontWeight: 800,
                      border: `1px solid ${alpha(v.ring, 0.35)}`,
                      letterSpacing: "0.02em",
                      whiteSpace: "nowrap",
                    }}>
                      <Box sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: v.ring }} />
                      {v.label}
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </Box>
        )}
      </Box>
    </Box>
  );
};

// ════════════════════════════════════════
// Phase-2 Subjects Page
// ════════════════════════════════════════

const ParentSubjectsPage = () => {
  const theme = useTheme();
  const { selectedChild } = useChild();
  const { data, isLoading, isFetching } = useGetChildSubjectsQuery(
    { studentId: selectedChild },
    { skip: !selectedChild },
  );
  const payload: any = data?.data || null;
  const groups: any[] = payload?.groups || [];

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ fontSize: 11, fontWeight: 700, color: pp.color.muted, textTransform: "uppercase", letterSpacing: "0.1em" }}>Parent Portal</Typography>
        <Typography sx={{ fontSize: 22, fontWeight: 700, letterSpacing: "-0.02em", mt: 0.25 }}>Subjects</Typography>
        <Typography sx={{ fontSize: 13, color: "text.secondary" }}>Enrolled subjects for the selected child.</Typography>
      </Box>

      <ChildSelectorBar />

      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}><StepUpSpinner size="medium" /></Box>
      ) : groups.length === 0 ? (
        <Box sx={{ bgcolor: "#fff", borderRadius: "14px", border: "1px dashed rgba(0,0,0,0.12)", textAlign: "center", py: 6, px: 3 }}>
          <MenuBookOutlinedIcon sx={{ fontSize: 40, color: "text.disabled", mb: 1 }} />
          <Typography sx={{ fontSize: 14, fontWeight: 600 }}>No subjects enrolled yet.</Typography>
          <Typography sx={{ fontSize: 12, color: "text.secondary", mt: 0.5 }}>Subjects will appear once your child has been enrolled.</Typography>
        </Box>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          {groups.map((g: any) => (
            <Box key={g.grade_id}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                <Typography sx={{ fontSize: 13, fontWeight: 700, color: theme.palette.primary.main, textTransform: "uppercase", letterSpacing: "0.06em" }}>
                  {g.grade_name}
                </Typography>
                <Divider sx={{ flex: 1 }} />
                <Chip label={`${g.subjects.length} subject${g.subjects.length === 1 ? "" : "s"}`} size="small" sx={{ height: 20, fontSize: 10, fontWeight: 600, bgcolor: alpha(theme.palette.primary.main, 0.08), color: theme.palette.primary.main }} />
              </Box>
              <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" }, gap: 1.5 }}>
                {g.subjects.map((s: any) => (
                  <Box key={s.subject_id} sx={{ bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)", p: 2, boxShadow: "0 1px 3px rgba(0,0,0,0.03)", display: "flex", flexDirection: "column", gap: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                      <Box sx={{ width: 36, height: 36, borderRadius: "10px", bgcolor: alpha(theme.palette.primary.main, 0.08), color: theme.palette.primary.main, display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <MenuBookOutlinedIcon sx={{ fontSize: 20 }} />
                      </Box>
                      <Box sx={{ minWidth: 0 }}>
                        <Typography sx={{ fontSize: 14, fontWeight: 700, lineHeight: 1.2 }}>{s.subject_name}</Typography>
                        <Typography sx={{ fontSize: 11, color: "text.secondary" }}>{g.grade_name}</Typography>
                      </Box>
                    </Box>
                    {s.staff.length > 0 ? (
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                        {s.staff.map((st: any) => (
                          <Box key={st.id} sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                            <PersonOutlineIcon sx={{ fontSize: 14, color: "text.secondary" }} />
                            <Typography sx={{ fontSize: 12.5, fontWeight: 600 }}>{st.name}</Typography>
                            <Typography sx={{ fontSize: 11, color: "text.secondary" }}>· {st.role || "Teacher"}</Typography>
                          </Box>
                        ))}
                      </Box>
                    ) : (
                      <Typography sx={{ fontSize: 11.5, color: "text.disabled", fontStyle: "italic" }}>Staff not assigned</Typography>
                    )}
                  </Box>
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      )}
      {isFetching && !isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}><CircularProgress size={16} /></Box>
      )}
    </Box>
  );
};

// ════════════════════════════════════════
// Phase-3 Assessments Page
// ════════════════════════════════════════

const assessmentStatusChip = (status: string) => {
  switch (status) {
    case "graded":     return { label: "Graded",     bg: alpha("#22c55e", 0.14), fg: "#15803d" };
    case "excused":    return { label: "Excused",    bg: alpha("#0ea5e9", 0.14), fg: "#0369a1" };
    case "absent":     return { label: "Absent",     bg: alpha("#ef4444", 0.14), fg: "#b91c1c" };
    case "not_graded": return { label: "Not Graded", bg: "rgba(0,0,0,0.06)",     fg: "#6b7280" };
    default:           return { label: status || "—", bg: "rgba(0,0,0,0.06)",   fg: "#6b7280" };
  }
};

const ParentAssessmentsPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { selectedChild } = useChild();

  const [period, setPeriod] = useState<"all" | "3m" | "12m" | "month">("12m");
  const [subjectFilter, setSubjectFilter] = useState<number | "all">("all");
  const [statusFilter, setStatusFilter] = useState<string>("all");
  const [detailFor, setDetailFor] = useState<any>(null);

  React.useEffect(() => { setSubjectFilter("all"); }, [selectedChild]);

  const { from, to } = useMemo(() => {
    const today = dayjs();
    if (period === "all")   return { from: undefined, to: undefined };
    if (period === "month") return { from: today.startOf("month").format("YYYY-MM-DD"), to: today.endOf("month").format("YYYY-MM-DD") };
    if (period === "3m")    return { from: today.subtract(3, "month").format("YYYY-MM-DD"), to: today.format("YYYY-MM-DD") };
    return { from: today.subtract(12, "month").format("YYYY-MM-DD"), to: today.format("YYYY-MM-DD") };
  }, [period]);

  const { data, isLoading, isFetching } = useGetChildAssessmentsQuery(
    { studentId: selectedChild, from, to, subject_id: subjectFilter === "all" ? null : subjectFilter, status: statusFilter },
    { skip: !selectedChild },
  );
  const payload: any = data?.data || null;
  const summary = payload?.summary || null;
  const records: any[] = payload?.records || [];
  const subjects: { id: number; name: string }[] = payload?.subjects || [];

  const fmtScore = (r: any) => {
    if (r.score != null && r.max_score != null) return `${r.score} / ${r.max_score}`;
    if (r.percentage != null) return `${r.percentage}%`;
    return r.status === "graded" ? "Completed" : "—";
  };
  const fmtPct = (r: any) => (r.percentage != null ? `${r.percentage}%` : null);

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ fontSize: 11, fontWeight: 700, color: pp.color.muted, textTransform: "uppercase", letterSpacing: "0.1em" }}>Parent Portal</Typography>
        <Typography sx={{ fontSize: 22, fontWeight: 700, letterSpacing: "-0.02em", mt: 0.25 }}>Assessments</Typography>
        <Typography sx={{ fontSize: 13, color: "text.secondary" }}>Marked assessments and teacher feedback for the selected child.</Typography>
      </Box>

      <ChildSelectorBar />

      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "repeat(4, 1fr)" }, gap: 1.5, mb: 2 }}>
        {[
          { key: "completed",           label: "Completed",         color: theme.palette.primary.main, suffix: "" },
          { key: "average_percentage",  label: "Average Score",     color: "#0ea5e9",                  suffix: "%" },
          { key: "subjects_assessed",   label: "Subjects Assessed", color: "#8b5cf6",                  suffix: "" },
          { key: "latest_percentage",   label: "Latest Score",      color: "#16a34a",                  suffix: "%" },
        ].map((kpi) => {
          const raw = summary?.[kpi.key];
          const display = raw == null ? "—" : `${raw}${kpi.suffix}`;
          return (
            <Box key={kpi.key} sx={{ bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)", p: 2, boxShadow: "0 1px 3px rgba(0,0,0,0.03)" }}>
              <Typography sx={{ fontSize: 10.5, fontWeight: 700, color: "text.secondary", textTransform: "uppercase", letterSpacing: "0.06em" }}>{kpi.label}</Typography>
              <Typography sx={{ fontSize: 22, fontWeight: 800, color: kpi.color, mt: 0.5, lineHeight: 1.1 }}>
                {isLoading ? <Box sx={{ width: 40, height: 22, bgcolor: "rgba(0,0,0,0.06)", borderRadius: 1 }} /> : display}
              </Typography>
            </Box>
          );
        })}
      </Box>

      <Box sx={{ bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)", px: 2, py: 1.5, mb: 2, display: "flex", flexWrap: "wrap", gap: 1.5, alignItems: "center", boxShadow: "0 1px 3px rgba(0,0,0,0.03)" }}>
        <FormControl size="small" sx={{ minWidth: 180 }}>
          <Select value={period} onChange={(e) => setPeriod(e.target.value as any)} sx={{ fontSize: 13, borderRadius: "10px", height: 36 }}>
            <MenuItem value="month" sx={{ fontSize: 13 }}>This Month</MenuItem>
            <MenuItem value="3m"    sx={{ fontSize: 13 }}>Last 3 Months</MenuItem>
            <MenuItem value="12m"   sx={{ fontSize: 13 }}>Last 12 Months</MenuItem>
            <MenuItem value="all"   sx={{ fontSize: 13 }}>All Time</MenuItem>
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 180 }}>
          <Select value={subjectFilter as any} onChange={(e) => setSubjectFilter(e.target.value === "all" ? "all" : Number(e.target.value))} sx={{ fontSize: 13, borderRadius: "10px", height: 36 }}>
            <MenuItem value="all" sx={{ fontSize: 13 }}>All Subjects</MenuItem>
            {subjects.map((s) => <MenuItem key={s.id} value={s.id} sx={{ fontSize: 13 }}>{s.name}</MenuItem>)}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 160 }}>
          <Select value={statusFilter} onChange={(e) => setStatusFilter(String(e.target.value))} sx={{ fontSize: 13, borderRadius: "10px", height: 36 }}>
            <MenuItem value="all"        sx={{ fontSize: 13 }}>All Results</MenuItem>
            <MenuItem value="graded"     sx={{ fontSize: 13 }}>Graded</MenuItem>
            <MenuItem value="excused"    sx={{ fontSize: 13 }}>Excused</MenuItem>
            <MenuItem value="absent"     sx={{ fontSize: 13 }}>Absent</MenuItem>
            <MenuItem value="not_graded" sx={{ fontSize: 13 }}>Not Graded</MenuItem>
          </Select>
        </FormControl>
        {isFetching && !isLoading && <CircularProgress size={16} />}
      </Box>

      <Box sx={{ bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.03)" }}>
        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}><StepUpSpinner size="medium" /></Box>
        ) : records.length === 0 ? (
          <Box sx={{ textAlign: "center", py: 6, px: 3 }}>
            <AssignmentTurnedInOutlinedIcon sx={{ fontSize: 40, color: "text.disabled", mb: 1 }} />
            <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
              {(summary?.completed ?? 0) > 0
                ? "No assessments match the selected filters."
                : "No assessments are available for this student yet."}
            </Typography>
          </Box>
        ) : isMobile ? (
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            {records.map((r) => {
              const chip = assessmentStatusChip(r.status);
              return (
                <Box key={r.assessment_id} onClick={() => setDetailFor(r)}
                  sx={{ px: 2, py: 1.5, borderBottom: "1px solid rgba(0,0,0,0.04)", cursor: "pointer", "&:hover": { bgcolor: "rgba(0,0,0,0.02)" } }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1 }}>
                    <Box sx={{ minWidth: 0 }}>
                      <Typography sx={{ fontSize: 13, fontWeight: 700 }}>{r.name || "Assessment"}</Typography>
                      <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
                        {[r.grade, r.subject].filter(Boolean).join(" — ") || "Subject"}
                        {r.date && ` · ${dayjs(r.date).format("MMM D, YYYY")}`}
                      </Typography>
                      {r.staff && <Typography sx={{ fontSize: 11.5, color: "text.secondary", mt: 0.25 }}>{r.staff}</Typography>}
                    </Box>
                    <Box sx={{ textAlign: "right" }}>
                      <Typography sx={{ fontSize: 13, fontWeight: 700 }}>{fmtScore(r)}</Typography>
                      {fmtPct(r) && r.score != null && <Typography sx={{ fontSize: 11, color: "text.secondary" }}>{fmtPct(r)}</Typography>}
                      <Chip label={chip.label} size="small" sx={{ mt: 0.5, height: 20, fontSize: 10, fontWeight: 700, bgcolor: chip.bg, color: chip.fg }} />
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </Box>
        ) : (
          <Box>
            <Box sx={{ display: "grid", gridTemplateColumns: "110px 1fr 180px 140px 140px 110px 80px", px: 2, py: 1.25, bgcolor: "rgba(0,0,0,0.02)", borderBottom: "1px solid rgba(0,0,0,0.06)", fontSize: 10.5, fontWeight: 700, color: "text.secondary", textTransform: "uppercase", letterSpacing: "0.06em" }}>
              <Box>Date</Box><Box>Assessment</Box><Box>Subject</Box><Box>Staff</Box><Box>Score</Box><Box>Result</Box><Box></Box>
            </Box>
            {records.map((r) => {
              const chip = assessmentStatusChip(r.status);
              return (
                <Box key={r.assessment_id} sx={{ display: "grid", gridTemplateColumns: "110px 1fr 180px 140px 140px 110px 80px", px: 2, py: 1.25, borderBottom: "1px solid rgba(0,0,0,0.04)", alignItems: "center", fontSize: 12.5 }}>
                  <Box>{r.date ? dayjs(r.date).format("MMM D, YYYY") : "—"}</Box>
                  <Box sx={{ minWidth: 0, pr: 1 }}>
                    <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{r.name || "Assessment"}</Typography>
                    {r.has_feedback && <Typography sx={{ fontSize: 10.5, color: "text.disabled" }}>Includes teacher feedback</Typography>}
                  </Box>
                  <Box sx={{ color: "text.secondary" }}>{[r.grade, r.subject].filter(Boolean).join(" — ") || "—"}</Box>
                  <Box sx={{ color: "text.secondary" }}>{r.staff || "—"}</Box>
                  <Box>
                    <Typography sx={{ fontSize: 13, fontWeight: 700 }}>{fmtScore(r)}</Typography>
                    {fmtPct(r) && r.score != null && <Typography sx={{ fontSize: 11, color: "text.secondary" }}>{fmtPct(r)}</Typography>}
                  </Box>
                  <Box><Chip label={chip.label} size="small" sx={{ height: 22, fontSize: 10.5, fontWeight: 700, bgcolor: chip.bg, color: chip.fg }} /></Box>
                  <Box>
                    <Button size="small" onClick={() => setDetailFor(r)} sx={{ textTransform: "none", fontSize: 11.5, minWidth: 0, px: 1 }}>View</Button>
                  </Box>
                </Box>
              );
            })}
          </Box>
        )}
      </Box>

      <Dialog open={!!detailFor} onClose={() => setDetailFor(null)} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: "14px" } }}>
        <DialogTitle sx={{ fontSize: 16, fontWeight: 700 }}>{detailFor?.name || "Assessment"}</DialogTitle>
        <DialogContent dividers sx={{ py: 2 }}>
          {detailFor && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25, fontSize: 13 }}>
              {[
                ["Date",       detailFor.date ? dayjs(detailFor.date).format("dddd, MMMM D, YYYY") : "—"],
                ["Subject",    [detailFor.grade, detailFor.subject].filter(Boolean).join(" — ") || "—"],
                ["Staff",      detailFor.staff || "—"],
                ["Score",      fmtScore(detailFor)],
                ["Max Score",  detailFor.max_score ?? "—"],
                ["Percentage", detailFor.percentage != null ? `${detailFor.percentage}%` : "—"],
                ["Result",     assessmentStatusChip(detailFor.status).label],
              ].map(([k, v]) => (
                <Box key={String(k)} sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}>
                  <Typography sx={{ fontSize: 12.5, color: "text.secondary" }}>{k as string}</Typography>
                  <Typography sx={{ fontSize: 12.5, fontWeight: 600, textAlign: "right" }}>{v as string}</Typography>
                </Box>
              ))}
              {detailFor.feedback && (
                <Box sx={{ mt: 1, bgcolor: alpha(theme.palette.primary.main, 0.04), borderRadius: "10px", p: 1.5 }}>
                  <Typography sx={{ fontSize: 10.5, fontWeight: 700, color: "text.secondary", textTransform: "uppercase", letterSpacing: "0.06em", mb: 0.5 }}>Teacher Feedback</Typography>
                  <Typography sx={{ fontSize: 13, whiteSpace: "pre-wrap" }}>{detailFor.feedback}</Typography>
                </Box>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDetailFor(null)} sx={{ textTransform: "none" }}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

// ════════════════════════════════════════
// Phase-3 Performance Page
// ════════════════════════════════════════

const trendLabel = (t: string | null) => {
  if (t === "improving") return { label: "Improving", bg: alpha("#22c55e", 0.14), fg: "#15803d" };
  if (t === "declining") return { label: "Declining", bg: alpha("#ef4444", 0.14), fg: "#b91c1c" };
  if (t === "stable")    return { label: "Stable",    bg: alpha("#0ea5e9", 0.14), fg: "#0369a1" };
  return null;
};

const ParentPerformancePage = () => {
  const theme = useTheme();
  const { selectedChild } = useChild();
  const [subjectFilter, setSubjectFilter] = useState<number | "all">("all");
  React.useEffect(() => { setSubjectFilter("all"); }, [selectedChild]);

  const { data, isLoading, isFetching } = useGetChildPerformanceQuery(
    { studentId: selectedChild, subject_id: subjectFilter === "all" ? null : subjectFilter },
    { skip: !selectedChild },
  );
  const payload: any = data?.data || null;
  const summary = payload?.summary || null;
  const subjectPerf: any[] = payload?.subjects || [];
  const trend: any[] = payload?.trend || [];
  const subjectOptions: { id: number; name: string }[] = payload?.subjects_options || [];

  const trendData = trend.map((p) => ({ label: p.label, value: p.percentage }));

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ fontSize: 11, fontWeight: 700, color: pp.color.muted, textTransform: "uppercase", letterSpacing: "0.1em" }}>Parent Portal</Typography>
        <Typography sx={{ fontSize: 22, fontWeight: 700, letterSpacing: "-0.02em", mt: 0.25 }}>Performance</Typography>
        <Typography sx={{ fontSize: 13, color: "text.secondary" }}>Aggregated academic performance from marked assessments.</Typography>
      </Box>

      <ChildSelectorBar />

      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "repeat(4, 1fr)" }, gap: 1.5, mb: 2 }}>
        {[
          { key: "overall_average",  label: "Overall Average",  color: theme.palette.primary.main, suffix: "%" },
          { key: "assessment_count", label: "Assessments",      color: "#0ea5e9",                  suffix: "" },
          { key: "subject_count",    label: "Subjects",         color: "#8b5cf6",                  suffix: "" },
          { key: "attendance_rate",  label: "Attendance (mo.)", color: "#16a34a",                  suffix: "%" },
        ].map((kpi) => {
          const raw = summary?.[kpi.key];
          const display = raw == null ? "—" : `${raw}${kpi.suffix}`;
          return (
            <Box key={kpi.key} sx={{ bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)", p: 2, boxShadow: "0 1px 3px rgba(0,0,0,0.03)" }}>
              <Typography sx={{ fontSize: 10.5, fontWeight: 700, color: "text.secondary", textTransform: "uppercase", letterSpacing: "0.06em" }}>{kpi.label}</Typography>
              <Typography sx={{ fontSize: 22, fontWeight: 800, color: kpi.color, mt: 0.5, lineHeight: 1.1 }}>
                {isLoading ? <Box sx={{ width: 40, height: 22, bgcolor: "rgba(0,0,0,0.06)", borderRadius: 1 }} /> : display}
              </Typography>
            </Box>
          );
        })}
      </Box>

      <Box sx={{ bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)", p: 2, mb: 2, boxShadow: "0 1px 3px rgba(0,0,0,0.03)" }}>
        <Typography sx={{ fontSize: 14, fontWeight: 700, mb: 1.5 }}>Subject Performance</Typography>
        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}><StepUpSpinner size="small" /></Box>
        ) : subjectPerf.length === 0 ? (
          <Typography sx={{ fontSize: 12.5, color: "text.secondary", py: 2 }}>No scored assessments yet.</Typography>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
            {subjectPerf.map((s: any) => {
              const chip = trendLabel(s.trend);
              const pct = s.average_percentage ?? 0;
              return (
                <Box key={s.subject_id}>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 0.5 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Typography sx={{ fontSize: 13, fontWeight: 700 }}>{s.subject_name || "Subject"}</Typography>
                      {s.grade && <Typography sx={{ fontSize: 11, color: "text.secondary" }}>· {s.grade}</Typography>}
                      <Chip label={`${s.assessment_count} assessment${s.assessment_count === 1 ? "" : "s"}`} size="small" sx={{ height: 18, fontSize: 10, fontWeight: 600, bgcolor: "rgba(0,0,0,0.04)" }} />
                      {chip && <Chip label={chip.label} size="small" sx={{ height: 18, fontSize: 10, fontWeight: 700, bgcolor: chip.bg, color: chip.fg }} />}
                    </Box>
                    <Typography sx={{ fontSize: 13, fontWeight: 800, color: pct >= 80 ? "#16a34a" : pct >= 50 ? "#d97706" : "#dc2626" }}>
                      {s.average_percentage != null ? `${s.average_percentage}%` : "—"}
                    </Typography>
                  </Box>
                  <LinearProgress
                    variant="determinate"
                    value={Math.min(100, Math.max(0, pct))}
                    sx={{
                      height: 6, borderRadius: 3, bgcolor: "rgba(0,0,0,0.06)",
                      "& .MuiLinearProgress-bar": { bgcolor: pct >= 80 ? "#16a34a" : pct >= 50 ? "#d97706" : "#dc2626" },
                    }}
                  />
                </Box>
              );
            })}
          </Box>
        )}
      </Box>

      <Box sx={{ bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)", p: 2, boxShadow: "0 1px 3px rgba(0,0,0,0.03)" }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1, flexWrap: "wrap", gap: 1 }}>
          <Typography sx={{ fontSize: 14, fontWeight: 700 }}>Assessment Performance Over Time</Typography>
          <FormControl size="small" sx={{ minWidth: 160 }}>
            <Select value={subjectFilter as any} onChange={(e) => setSubjectFilter(e.target.value === "all" ? "all" : Number(e.target.value))} sx={{ fontSize: 13, borderRadius: "10px", height: 36 }}>
              <MenuItem value="all" sx={{ fontSize: 13 }}>All Subjects</MenuItem>
              {subjectOptions.map((s) => <MenuItem key={s.id} value={s.id} sx={{ fontSize: 13 }}>{s.name}</MenuItem>)}
            </Select>
          </FormControl>
        </Box>
        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}><StepUpSpinner size="small" /></Box>
        ) : trendData.length < 2 ? (
          <Box sx={{ textAlign: "center", py: 4, color: "text.secondary" }}>
            <Typography sx={{ fontSize: 13 }}>More assessment data is needed to show a performance trend.</Typography>
          </Box>
        ) : (
          <TrendCard
            title="Monthly average"
            subtitle={subjectFilter === "all" ? "All subjects" : (subjectOptions.find((s) => s.id === subjectFilter)?.name || "Subject")}
            data={trendData}
            height={200}
            renderTooltip={(p) => `${p.label}: ${p.value}%`}
          />
        )}
      </Box>
      {isFetching && !isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}><CircularProgress size={16} /></Box>
      )}
    </Box>
  );
};

// ════════════════════════════════════════
// Phase-4 Assignments Page
// ════════════════════════════════════════

const assignmentStatusChip = (status: string) => {
  switch (status) {
    case "pending":   return { label: "Pending",   bg: alpha("#3b82f6", 0.14), fg: "#1d4ed8" };
    case "submitted": return { label: "Submitted", bg: alpha("#0ea5e9", 0.14), fg: "#0369a1" };
    case "returned":  return { label: "Returned",  bg: alpha("#8b5cf6", 0.14), fg: "#6d28d9" };
    case "graded":    return { label: "Graded",    bg: alpha("#22c55e", 0.14), fg: "#15803d" };
    case "overdue":   return { label: "Overdue",   bg: alpha("#ef4444", 0.14), fg: "#b91c1c" };
    case "excused":   return { label: "Excused",   bg: "rgba(0,0,0,0.06)",     fg: "#6b7280" };
    case "cancelled": return { label: "Cancelled", bg: "rgba(0,0,0,0.06)",     fg: "#6b7280" };
    default:          return { label: status || "—", bg: "rgba(0,0,0,0.06)",   fg: "#6b7280" };
  }
};

const ParentAssignmentsPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { selectedChild } = useChild();

  const [period, setPeriod] = useState<"current" | "month" | "3m" | "all">("current");
  const [statusFilter, setStatusFilter] = useState<string>("all");
  const [subjectFilter, setSubjectFilter] = useState<number | "all">("all");
  const [detailFor, setDetailFor] = useState<number | null>(null);

  React.useEffect(() => { setSubjectFilter("all"); }, [selectedChild]);

  const { data, isLoading, isFetching } = useGetChildAssignmentsQuery(
    { studentId: selectedChild, status: statusFilter, subject_id: subjectFilter === "all" ? null : subjectFilter, period },
    { skip: !selectedChild },
  );
  const payload: any = data?.data || null;
  const summary = payload?.summary || null;
  const records: any[] = payload?.records || [];
  const subjects: { id: number; name: string }[] = payload?.subjects || [];

  const fmtScore = (r: any) => {
    if (r.score != null && r.max_score != null) return `${r.score} / ${r.max_score}`;
    if (r.percentage != null) return `${r.percentage}%`;
    return r.status === "graded" ? "Completed" : "—";
  };
  const fmtPct = (r: any) => (r.percentage != null ? `${r.percentage}%` : null);

  const dueLabel = (iso: string | null) => {
    if (!iso) return "No due date";
    const d = dayjs(iso);
    const today = dayjs();
    const diff = d.startOf("day").diff(today.startOf("day"), "day");
    const abs = d.format("MMM D, YYYY");
    if (diff === 0)  return `Due today · ${abs}`;
    if (diff === 1)  return `Due tomorrow · ${abs}`;
    if (diff > 1 && diff <= 7) return `Due in ${diff} days · ${abs}`;
    if (diff < 0 && diff >= -7) return `${-diff} day${diff === -1 ? "" : "s"} overdue · ${abs}`;
    return abs;
  };

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ fontSize: 11, fontWeight: 700, color: pp.color.muted, textTransform: "uppercase", letterSpacing: "0.1em" }}>Parent Portal</Typography>
        <Typography sx={{ fontSize: 22, fontWeight: 700, letterSpacing: "-0.02em", mt: 0.25 }}>Assignments</Typography>
        <Typography sx={{ fontSize: 13, color: "text.secondary" }}>Homework, projects and quizzes assigned to the selected child.</Typography>
      </Box>

      <ChildSelectorBar />

      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "repeat(4, 1fr)", md: "repeat(5, 1fr)" }, gap: 1.5, mb: 2 }}>
        {[
          { key: "pending",    label: "Pending",   color: "#1d4ed8", suffix: "" },
          { key: "submitted",  label: "Submitted", color: "#0369a1", suffix: "" },
          { key: "graded",     label: "Graded",    color: "#15803d", suffix: "" },
          { key: "overdue",    label: "Overdue",   color: "#b91c1c", suffix: "" },
          { key: "average_percentage", label: "Average Score", color: theme.palette.primary.main, suffix: "%" },
        ].map((kpi) => {
          const raw = summary?.[kpi.key];
          const display = raw == null ? "—" : `${raw}${kpi.suffix}`;
          return (
            <Box key={kpi.key} sx={{ bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)", p: 2, boxShadow: "0 1px 3px rgba(0,0,0,0.03)" }}>
              <Typography sx={{ fontSize: 10.5, fontWeight: 700, color: "text.secondary", textTransform: "uppercase", letterSpacing: "0.06em" }}>{kpi.label}</Typography>
              <Typography sx={{ fontSize: 22, fontWeight: 800, color: kpi.color, mt: 0.5, lineHeight: 1.1 }}>
                {isLoading ? <Box sx={{ width: 40, height: 22, bgcolor: "rgba(0,0,0,0.06)", borderRadius: 1 }} /> : display}
              </Typography>
            </Box>
          );
        })}
      </Box>

      <Box sx={{ bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)", px: 2, py: 1.5, mb: 2, display: "flex", flexWrap: "wrap", gap: 1.5, alignItems: "center", boxShadow: "0 1px 3px rgba(0,0,0,0.03)" }}>
        <FormControl size="small" sx={{ minWidth: 180 }}>
          <Select value={statusFilter} onChange={(e) => setStatusFilter(String(e.target.value))} sx={{ fontSize: 13, borderRadius: "10px", height: 36 }}>
            <MenuItem value="all"       sx={{ fontSize: 13 }}>All Statuses</MenuItem>
            <MenuItem value="pending"   sx={{ fontSize: 13 }}>Pending</MenuItem>
            <MenuItem value="submitted" sx={{ fontSize: 13 }}>Submitted</MenuItem>
            <MenuItem value="graded"    sx={{ fontSize: 13 }}>Graded</MenuItem>
            <MenuItem value="overdue"   sx={{ fontSize: 13 }}>Overdue</MenuItem>
            <MenuItem value="returned"  sx={{ fontSize: 13 }}>Returned</MenuItem>
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 180 }}>
          <Select value={subjectFilter as any} onChange={(e) => setSubjectFilter(e.target.value === "all" ? "all" : Number(e.target.value))} sx={{ fontSize: 13, borderRadius: "10px", height: 36 }}>
            <MenuItem value="all" sx={{ fontSize: 13 }}>All Subjects</MenuItem>
            {subjects.map((s) => <MenuItem key={s.id} value={s.id} sx={{ fontSize: 13 }}>{s.name}</MenuItem>)}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 170 }}>
          <Select value={period} onChange={(e) => setPeriod(e.target.value as any)} sx={{ fontSize: 13, borderRadius: "10px", height: 36 }}>
            <MenuItem value="current" sx={{ fontSize: 13 }}>Current / Active</MenuItem>
            <MenuItem value="month"   sx={{ fontSize: 13 }}>This Month</MenuItem>
            <MenuItem value="3m"      sx={{ fontSize: 13 }}>Last 3 Months</MenuItem>
            <MenuItem value="all"     sx={{ fontSize: 13 }}>All Time</MenuItem>
          </Select>
        </FormControl>
        {isFetching && !isLoading && <CircularProgress size={16} />}
      </Box>

      <Box sx={{ bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.03)" }}>
        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}><StepUpSpinner size="medium" /></Box>
        ) : records.length === 0 ? (
          <Box sx={{ textAlign: "center", py: 6, px: 3 }}>
            <AssignmentOutlinedIcon sx={{ fontSize: 40, color: "text.disabled", mb: 1 }} />
            <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
              {(summary?.total ?? 0) > 0
                ? "No assignments match the selected filters."
                : "No assignments are available for this student yet."}
            </Typography>
          </Box>
        ) : isMobile ? (
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            {records.map((r) => {
              const chip = assignmentStatusChip(r.status);
              return (
                <Box key={r.assignment_id} onClick={() => setDetailFor(r.assignment_id)}
                  sx={{ px: 2, py: 1.5, borderBottom: "1px solid rgba(0,0,0,0.04)", cursor: "pointer", "&:hover": { bgcolor: "rgba(0,0,0,0.02)" } }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1 }}>
                    <Box sx={{ minWidth: 0 }}>
                      <Typography sx={{ fontSize: 13, fontWeight: 700 }}>{r.title || "Assignment"}</Typography>
                      <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
                        {r.subject || "Subject"}{r.staff ? ` · ${r.staff}` : ""}
                      </Typography>
                      <Typography sx={{ fontSize: 11.5, color: r.status === "overdue" ? "#b91c1c" : "text.secondary", mt: 0.25 }}>
                        {dueLabel(r.due_date)}
                      </Typography>
                    </Box>
                    <Box sx={{ textAlign: "right" }}>
                      <Typography sx={{ fontSize: 13, fontWeight: 700 }}>{fmtScore(r)}</Typography>
                      {fmtPct(r) && r.score != null && <Typography sx={{ fontSize: 11, color: "text.secondary" }}>{fmtPct(r)}</Typography>}
                      <Chip label={chip.label} size="small" sx={{ mt: 0.5, height: 20, fontSize: 10, fontWeight: 700, bgcolor: chip.bg, color: chip.fg }} />
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </Box>
        ) : (
          <Box>
            <Box sx={{ display: "grid", gridTemplateColumns: "170px 1fr 180px 140px 110px 130px 80px", px: 2, py: 1.25, bgcolor: "rgba(0,0,0,0.02)", borderBottom: "1px solid rgba(0,0,0,0.06)", fontSize: 10.5, fontWeight: 700, color: "text.secondary", textTransform: "uppercase", letterSpacing: "0.06em" }}>
              <Box>Due</Box><Box>Assignment</Box><Box>Subject</Box><Box>Staff</Box><Box>Status</Box><Box>Score</Box><Box></Box>
            </Box>
            {records.map((r) => {
              const chip = assignmentStatusChip(r.status);
              return (
                <Box key={r.assignment_id} sx={{ display: "grid", gridTemplateColumns: "170px 1fr 180px 140px 110px 130px 80px", px: 2, py: 1.25, borderBottom: "1px solid rgba(0,0,0,0.04)", alignItems: "center", fontSize: 12.5 }}>
                  <Box>
                    <Typography sx={{ fontSize: 12.5, fontWeight: 600, color: r.status === "overdue" ? "#b91c1c" : "text.primary" }}>
                      {r.due_date ? dayjs(r.due_date).format("MMM D, YYYY") : "—"}
                    </Typography>
                    {r.due_date && (
                      <Typography sx={{ fontSize: 10.5, color: "text.disabled" }}>{dueLabel(r.due_date)}</Typography>
                    )}
                  </Box>
                  <Box sx={{ minWidth: 0, pr: 1 }}>
                    <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{r.title || "Assignment"}</Typography>
                    {(r.has_feedback || r.has_attachments) && (
                      <Typography sx={{ fontSize: 10.5, color: "text.disabled" }}>
                        {[r.has_feedback ? "Teacher feedback" : null, r.has_attachments ? "Attachments" : null].filter(Boolean).join(" · ")}
                      </Typography>
                    )}
                  </Box>
                  <Box sx={{ color: "text.secondary" }}>{r.subject || "—"}</Box>
                  <Box sx={{ color: "text.secondary" }}>{r.staff || "—"}</Box>
                  <Box><Chip label={chip.label} size="small" sx={{ height: 22, fontSize: 10.5, fontWeight: 700, bgcolor: chip.bg, color: chip.fg }} /></Box>
                  <Box>
                    <Typography sx={{ fontSize: 13, fontWeight: 700 }}>{fmtScore(r)}</Typography>
                    {fmtPct(r) && r.score != null && <Typography sx={{ fontSize: 11, color: "text.secondary" }}>{fmtPct(r)}</Typography>}
                  </Box>
                  <Box>
                    <Button size="small" onClick={() => setDetailFor(r.assignment_id)} sx={{ textTransform: "none", fontSize: 11.5, minWidth: 0, px: 1 }}>View</Button>
                  </Box>
                </Box>
              );
            })}
          </Box>
        )}
      </Box>

      {detailFor && (
        <ParentAssignmentDetailDialog
          studentId={selectedChild}
          assignmentId={detailFor}
          onClose={() => setDetailFor(null)}
        />
      )}
    </Box>
  );
};

const ParentAssignmentDetailDialog: React.FC<{
  studentId: number | null;
  assignmentId: number;
  onClose: () => void;
}> = ({ studentId, assignmentId, onClose }) => {
  const theme = useTheme();
  const { data, isLoading } = useGetChildAssignmentDetailQuery(
    { studentId, assignmentId },
    { skip: !studentId || !assignmentId },
  );
  const d: any = data?.data || null;
  const chip = d ? assignmentStatusChip(d.status) : null;
  const errored = data && (data as any).status === false;
  const fmtScoreDetail = (row: any) =>
    row.score != null && row.max_score != null
      ? `${row.score} / ${row.max_score}`
      : (row.percentage != null ? `${row.percentage}%` : "—");

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: "14px" } }}>
      <DialogTitle sx={{ fontSize: 16, fontWeight: 700 }}>
        {isLoading ? "Loading…" : (d?.title || "Assignment")}
      </DialogTitle>
      <DialogContent dividers sx={{ py: 2 }}>
        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}><StepUpSpinner size="small" /></Box>
        ) : errored || !d ? (
          <Typography sx={{ fontSize: 13, color: "error.main" }}>
            {(data as any)?.message || "Assignment not found for this student."}
          </Typography>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25, fontSize: 13 }}>
            {[
              ["Subject",       d.subject || "—"],
              ["Staff",         d.staff || "—"],
              ["Assigned",      d.assigned_date ? dayjs(d.assigned_date).format("dddd, MMMM D, YYYY") : "—"],
              ["Due",           d.due_date ? dayjs(d.due_date).format("dddd, MMMM D, YYYY · h:mm A") : "No due date"],
              ["Status",        chip?.label || "—"],
              ["Submitted",     d.submitted_at ? dayjs(d.submitted_at).format("MMM D, YYYY · h:mm A") : "—"],
              ["Score",         fmtScoreDetail(d)],
              ["Percentage",    d.percentage != null ? `${d.percentage}%` : "—"],
            ].map(([k, v]) => (
              <Box key={String(k)} sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}>
                <Typography sx={{ fontSize: 12.5, color: "text.secondary" }}>{k as string}</Typography>
                <Typography sx={{ fontSize: 12.5, fontWeight: 600, textAlign: "right" }}>{v as string}</Typography>
              </Box>
            ))}
            {d.description && (
              <Box sx={{ mt: 1, bgcolor: "rgba(0,0,0,0.03)", borderRadius: "10px", p: 1.5 }}>
                <Typography sx={{ fontSize: 10.5, fontWeight: 700, color: "text.secondary", textTransform: "uppercase", letterSpacing: "0.06em", mb: 0.5 }}>Description</Typography>
                <Typography sx={{ fontSize: 13, whiteSpace: "pre-wrap" }}>{d.description}</Typography>
              </Box>
            )}
            {d.feedback && (
              <Box sx={{ mt: 1, bgcolor: alpha(theme.palette.primary.main, 0.04), borderRadius: "10px", p: 1.5 }}>
                <Typography sx={{ fontSize: 10.5, fontWeight: 700, color: "text.secondary", textTransform: "uppercase", letterSpacing: "0.06em", mb: 0.5 }}>Teacher Feedback</Typography>
                <Typography sx={{ fontSize: 13, whiteSpace: "pre-wrap" }}>{d.feedback}</Typography>
              </Box>
            )}
            {Array.isArray(d.attachments) && d.attachments.length > 0 && (
              <Box sx={{ mt: 1 }}>
                <Typography sx={{ fontSize: 10.5, fontWeight: 700, color: "text.secondary", textTransform: "uppercase", letterSpacing: "0.06em", mb: 0.5 }}>Attachments</Typography>
                {d.attachments.map((att: any, i: number) => (
                  <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 0.75, py: 0.25 }}>
                    <AttachFileIcon sx={{ fontSize: 14, color: "text.secondary" }} />
                    <Typography sx={{ fontSize: 12.5 }}>
                      {att.name} <Typography component="span" sx={{ fontSize: 10.5, color: "text.disabled" }}>· {att.source === "submission" ? "student submission" : "assignment file"}</Typography>
                    </Typography>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ textTransform: "none" }}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

// ════════════════════════════════════════
// Payments Page
// ════════════════════════════════════════

const ParentPaymentsPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { showMessage, showErrorMessage } = useNotifier();
  const { selectedChild, children: linkedChildren } = useChild();
  const [selectedIds, setSelectedIds] = useState<Set<number>>(new Set());
  const [paySuccess, setPaySuccess] = useState<{ total: number; count: number } | null>(null);
  // Phase-5 polish: default the Payments student-filter to the globally
  // selected child so switching child on the Dashboard immediately scopes
  // Payments too. "All Children" remains available as an explicit family
  // view (spec §24).
  const [filterStudent, setFilterStudent] = useState<number | "all">(
    selectedChild ?? (linkedChildren?.length === 1 ? linkedChildren[0].studentId : "all"),
  );
  React.useEffect(() => {
    if (selectedChild) setFilterStudent(selectedChild);
  }, [selectedChild]);

  const { data: invData, isLoading } = useGetFamilyInvoicesQuery();
  const [payInvoices, { isLoading: paying }] = usePayFamilyInvoicesMutation();

  const familyData = useMemo(() => (invData?.data as any) || null, [invData]);
  const students: any[] = useMemo(() => familyData?.students || [], [familyData]);
  const familyTotal: number = familyData?.familyTotal || 0;
  const recentPayments: any[] = familyData?.recentPayments || [];

  const totalPaid = useMemo(() => recentPayments.reduce((sum: number, p: any) => sum + Number(p.amount || 0), 0), [recentPayments]);
  const overdueCount = useMemo(() => {
    let c = 0;
    students.forEach((s: any) => (s.invoices || []).forEach((inv: any) => {
      if (inv.dueDate && dayjs(inv.dueDate).isBefore(dayjs(), "day")) c++;
    }));
    return c;
  }, [students]);

  const nextDue = useMemo(() => {
    let earliest: any = null;
    students.forEach((s: any) => (s.invoices || []).forEach((inv: any) => {
      if (inv.dueDate && (!earliest || dayjs(inv.dueDate).isBefore(dayjs(earliest)))) earliest = inv.dueDate;
    }));
    return earliest;
  }, [students]);

  const filteredStudents = useMemo(() => {
    if (filterStudent === "all") return students;
    return students.filter((s: any) => s.studentId === filterStudent);
  }, [students, filterStudent]);

  const allInvoiceIds = useMemo(() => {
    const ids: number[] = [];
    filteredStudents.forEach((s: any) => (s.invoices || []).forEach((inv: any) => ids.push(inv.id)));
    return ids;
  }, [filteredStudents]);

  React.useEffect(() => {
    if (allInvoiceIds.length > 0 && selectedIds.size === 0) setSelectedIds(new Set(allInvoiceIds));
  }, [allInvoiceIds]);

  const selectedTotal = useMemo(() => {
    let total = 0;
    students.forEach((s: any) => (s.invoices || []).forEach((inv: any) => {
      if (selectedIds.has(inv.id)) total += inv.balanceDue || 0;
    }));
    return total;
  }, [selectedIds, students]);

  const toggleInvoice = (id: number) => {
    setSelectedIds((prev) => { const next = new Set(prev); if (next.has(id)) next.delete(id); else next.add(id); return next; });
  };
  const selectAll = () => setSelectedIds(new Set(allInvoiceIds));
  const selectNone = () => setSelectedIds(new Set());

  const handlePay = async () => {
    const ids = Array.from(selectedIds);
    if (ids.length === 0) return;
    try {
      const r = await payInvoices({ invoice_ids: ids }).unwrap();
      if (r.status) {
        showMessage(r.message);
        setPaySuccess({ total: (r.data as any)?.totalPaid || 0, count: (r.data as any)?.invoicesPaid || 0 });
        setSelectedIds(new Set());
      } else { showErrorMessage(r.message); }
    } catch (err: any) { showErrorMessage(err?.data?.message || "Payment failed"); }
  };

  const StatCard = ({ label, value, color, sub }: { label: string; value: string; color: string; sub?: string }) => (
    <Box sx={{ bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)", p: 2.5, boxShadow: "0 1px 3px rgba(0,0,0,0.03)", transition: "transform 0.15s", "&:hover": { transform: "translateY(-2px)", boxShadow: "0 4px 12px rgba(0,0,0,0.06)" } }}>
      <Typography sx={{ fontSize: 11, fontWeight: 600, color: "text.disabled", textTransform: "uppercase", letterSpacing: "0.05em", mb: 0.75 }}>{label}</Typography>
      <Typography sx={{ fontSize: 26, fontWeight: 800, color, lineHeight: 1, letterSpacing: "-0.02em" }}>{value}</Typography>
      {sub && <Typography sx={{ fontSize: 11, color: "text.disabled", mt: 0.5 }}>{sub}</Typography>}
    </Box>
  );

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ fontSize: 11, fontWeight: 700, color: pp.color.muted, textTransform: "uppercase", letterSpacing: "0.1em" }}>Parent Portal</Typography>
        <Typography sx={{ fontSize: 22, fontWeight: 700, letterSpacing: "-0.02em", mt: 0.25 }}>Payments & Invoices</Typography>
        <Typography sx={{ fontSize: 13, color: "text.secondary" }}>Invoices and payments for the selected child. Switch to "All Children" for the family view.</Typography>
      </Box>

      <ChildSelectorBar />

      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}><StepUpSpinner size="medium" /></Box>
      ) : paySuccess ? (
        <Box sx={{ bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)", textAlign: "center", py: 6, px: 3 }}>
          <Box sx={{ width: 72, height: 72, borderRadius: "50%", bgcolor: alpha("#22c55e", 0.08), display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
            <CheckCircleOutlineIcon sx={{ fontSize: 36, color: "#22c55e" }} />
          </Box>
          <Typography sx={{ fontSize: 22, fontWeight: 700, mb: 0.5 }}>Payment Successful</Typography>
          <Typography sx={{ fontSize: 28, fontWeight: 800, color: "#22c55e", mb: 0.5 }}>${paySuccess.total.toFixed(2)}</Typography>
          <Typography sx={{ fontSize: 13, color: "text.secondary" }}>
            {paySuccess.count} invoice{paySuccess.count !== 1 ? "s" : ""} paid
          </Typography>
          <Button size="small" variant="outlined" onClick={() => setPaySuccess(null)}
            sx={{ mt: 3, textTransform: "none", fontSize: 12, borderRadius: "10px", px: 3 }}>
            Back to Payments
          </Button>
        </Box>
      ) : (
        <>
          {overdueCount > 0 && (
            <Box sx={{
              display: "flex", alignItems: "center", gap: 1.5, p: 2, mb: 2.5,
              borderRadius: "12px", bgcolor: alpha("#ef4444", 0.04),
              border: `1.5px solid ${alpha("#ef4444", 0.15)}`,
            }}>
              <Box sx={{ width: 36, height: 36, borderRadius: "10px", bgcolor: alpha("#ef4444", 0.1), display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <PaymentOutlinedIcon sx={{ fontSize: 20, color: "#ef4444" }} />
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#dc2626" }}>
                  {overdueCount} Overdue Invoice{overdueCount > 1 ? "s" : ""}
                </Typography>
                <Typography sx={{ fontSize: 11.5, color: "#991b1b" }}>
                  Please make payment to avoid service interruption
                </Typography>
              </Box>
              <Button size="small" variant="contained" onClick={handlePay} disabled={selectedIds.size === 0 || paying}
                sx={{ bgcolor: "#ef4444", textTransform: "none", fontSize: 12, fontWeight: 700, borderRadius: "10px", px: 2.5, boxShadow: "none", "&:hover": { bgcolor: "#dc2626" } }}>
                Pay Now
              </Button>
            </Box>
          )}

          <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr 1fr", md: "1fr 1fr 1fr 1fr" }, gap: 2, mb: 3 }}>
            <StatCard label="Total Outstanding" value={`$${familyTotal.toFixed(2)}`} color={familyTotal > 0 ? "#ef4444" : "#22c55e"} sub={`${allInvoiceIds.length} invoice${allInvoiceIds.length !== 1 ? "s" : ""}`} />
            <StatCard label="Total Paid" value={`$${totalPaid.toFixed(2)}`} color="#22c55e" sub={`${recentPayments.length} payment${recentPayments.length !== 1 ? "s" : ""}`} />
            <StatCard label="Overdue" value={String(overdueCount)} color={overdueCount > 0 ? "#dc2626" : "#22c55e"} sub={overdueCount > 0 ? "Please settle soon" : "None"} />
            <StatCard label="Next Due" value={nextDue ? dayjs(nextDue).format("MMM D") : "—"} color="#f59e0b" sub={nextDue ? dayjs(nextDue).format("YYYY") : "No upcoming"} />
          </Box>

          {students.length > 1 && (
            <Box sx={{ display: "flex", gap: 1.5, mb: 2.5, overflowX: "auto", pb: 0.5, "&::-webkit-scrollbar": { height: 0 } }}>
              <Chip
                label={`All (${students.length})`}
                onClick={() => setFilterStudent("all")}
                sx={{
                  height: 36, fontSize: 12, fontWeight: 600, borderRadius: "10px", cursor: "pointer",
                  bgcolor: filterStudent === "all" ? theme.palette.primary.main : "#fff",
                  color: filterStudent === "all" ? "#fff" : "text.secondary",
                  border: filterStudent === "all" ? "none" : "1px solid rgba(0,0,0,0.08)",
                  "&:hover": { bgcolor: filterStudent === "all" ? theme.palette.primary.dark : "rgba(0,0,0,0.04)" },
                }}
              />
              {students.map((s: any) => {
                const isActive = filterStudent === s.studentId;
                return (
                  <Chip
                    key={s.studentId}
                    avatar={<Avatar sx={{ width: 24, height: 24, fontSize: 10, fontWeight: 700, bgcolor: isActive ? "rgba(255,255,255,0.2)" : alpha(theme.palette.primary.main, 0.08), color: isActive ? "#fff" : theme.palette.primary.main }}>{(s.studentName || "S").charAt(0)}</Avatar>}
                    label={`${s.studentName} · $${(s.subtotal || 0).toFixed(2)}`}
                    onClick={() => setFilterStudent(s.studentId)}
                    sx={{
                      height: 36, fontSize: 12, fontWeight: 500, borderRadius: "10px", cursor: "pointer", flexShrink: 0,
                      bgcolor: isActive ? theme.palette.primary.main : "#fff",
                      color: isActive ? "#fff" : "text.primary",
                      border: isActive ? "none" : "1px solid rgba(0,0,0,0.08)",
                      "&:hover": { bgcolor: isActive ? theme.palette.primary.dark : "rgba(0,0,0,0.04)" },
                    }}
                  />
                );
              })}
            </Box>
          )}

          {filteredStudents.length === 0 ? (
            <Box sx={{ bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)", textAlign: "center", py: 6, px: 3 }}>
              <CheckCircleOutlineIcon sx={{ fontSize: 40, color: "#22c55e", mb: 1 }} />
              <Typography sx={{ fontSize: 16, fontWeight: 700, mb: 0.5 }}>All Paid Up</Typography>
              <Typography sx={{ fontSize: 13, color: "text.secondary" }}>No outstanding invoices.</Typography>
            </Box>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 2 }}>
              {filteredStudents.map((student: any) => (
                <Box key={student.studentId} sx={{ bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.03)" }}>
                  <Box sx={{ px: 2.5, py: 1.75, borderBottom: "1px solid rgba(0,0,0,0.04)", display: "flex", alignItems: "center", justifyContent: "space-between", bgcolor: "rgba(0,0,0,0.008)" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                      <Avatar sx={{ width: 34, height: 34, fontSize: 14, fontWeight: 700, bgcolor: alpha(theme.palette.primary.main, 0.08), color: theme.palette.primary.main }}>
                        {(student.studentName || "S").charAt(0).toUpperCase()}
                      </Avatar>
                      <Box>
                        <Typography sx={{ fontSize: 14, fontWeight: 700 }}>{student.studentName}</Typography>
                        <Typography sx={{ fontSize: 11, color: "text.disabled" }}>{(student.invoices || []).length} invoice{(student.invoices || []).length !== 1 ? "s" : ""}</Typography>
                      </Box>
                    </Box>
                    <Box sx={{ textAlign: "right" }}>
                      <Typography sx={{ fontSize: 18, fontWeight: 800, color: (student.subtotal || 0) > 0 ? "#ef4444" : "#22c55e" }}>${(student.subtotal || 0).toFixed(2)}</Typography>
                      <Typography sx={{ fontSize: 10, color: "text.disabled" }}>outstanding</Typography>
                    </Box>
                  </Box>

                  <Box>
                    {(student.invoices || []).map((inv: any, idx: number) => {
                      const isSelected = selectedIds.has(inv.id);
                      const isOverdue = inv.dueDate && dayjs(inv.dueDate).isBefore(dayjs(), "day");
                      const isPaid = inv.status === "paid";
                      return (
                        <Box key={inv.id}
                          onClick={() => !isPaid && toggleInvoice(inv.id)}
                          sx={{
                            display: "flex", alignItems: "center", gap: 1.5,
                            px: 2.5, py: 1.5, cursor: isPaid ? "default" : "pointer",
                            bgcolor: isSelected ? alpha(theme.palette.primary.main, 0.02) : "transparent",
                            "&:hover": { bgcolor: isPaid ? "transparent" : alpha(theme.palette.primary.main, 0.03) },
                            borderBottom: idx < (student.invoices || []).length - 1 ? "1px solid rgba(0,0,0,0.03)" : "none",
                            transition: "background 0.1s",
                          }}>
                          {!isPaid && (
                            <Checkbox checked={isSelected} size="small" sx={{ p: 0 }}
                              onClick={(e) => { e.stopPropagation(); toggleInvoice(inv.id); }} />
                          )}
                          {isPaid && <CheckCircleOutlineIcon sx={{ fontSize: 20, color: "#22c55e" }} />}
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                              <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                                {inv.invoiceNumber || `Invoice #${inv.id}`}
                              </Typography>
                              {isOverdue && <Chip label="Overdue" size="small" sx={{ height: 18, fontSize: 9, fontWeight: 700, bgcolor: alpha("#ef4444", 0.08), color: "#ef4444" }} />}
                              {inv.status === "partial" && <Chip label="Partial" size="small" sx={{ height: 18, fontSize: 9, fontWeight: 600, bgcolor: alpha("#f59e0b", 0.08), color: "#f59e0b" }} />}
                              {isPaid && <Chip label="Paid" size="small" sx={{ height: 18, fontSize: 9, fontWeight: 600, bgcolor: alpha("#22c55e", 0.08), color: "#22c55e" }} />}
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mt: 0.25 }}>
                              {inv.dueDate && (
                                <Typography sx={{ fontSize: 11, color: isOverdue ? "#ef4444" : "text.disabled" }}>
                                  Due {dayjs(inv.dueDate).format("MMM D, YYYY")}
                                </Typography>
                              )}
                              {inv.notes && (
                                <Typography sx={{ fontSize: 11, color: "text.disabled", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                  {inv.notes}
                                </Typography>
                              )}
                            </Box>
                          </Box>
                          <Typography sx={{ fontSize: 15, fontWeight: 700, color: isPaid ? "#22c55e" : "text.primary", flexShrink: 0 }}>
                            ${(inv.balanceDue || 0).toFixed(2)}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              ))}
            </Box>
          )}

          {recentPayments.length > 0 && (
            <Box sx={{ mb: 2 }}>
              <Typography sx={{ fontSize: 13, fontWeight: 700, mb: 1.5 }}>Payment History</Typography>
              <Box sx={{ bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)", overflow: "hidden" }}>
                {recentPayments.map((p: any, i: number) => (
                  <Box key={p.id || i} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2.5, py: 1.5, borderBottom: i < recentPayments.length - 1 ? "1px solid rgba(0,0,0,0.04)" : "none" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                      <Box sx={{ width: 32, height: 32, borderRadius: "8px", bgcolor: alpha("#22c55e", 0.08), display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <CheckCircleOutlineIcon sx={{ fontSize: 16, color: "#22c55e" }} />
                      </Box>
                      <Box>
                        <Typography sx={{ fontSize: 12.5, fontWeight: 600 }}>{p.studentName || "Student"}</Typography>
                        <Typography sx={{ fontSize: 10.5, color: "text.disabled" }}>{p.paymentDate ? dayjs(p.paymentDate).format("MMM D, YYYY") : ""}</Typography>
                      </Box>
                    </Box>
                    <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#22c55e" }}>
                      +${Number(p.amount || 0).toFixed(2)}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          )}

          {selectedIds.size > 0 && (
            <Box sx={{
              position: "sticky", bottom: 16, mt: 1,
              bgcolor: theme.palette.primary.main,
              borderRadius: "16px",
              px: 3, py: 2, display: "flex", alignItems: "center", justifyContent: "space-between",
              boxShadow: "0 8px 32px rgba(0,0,0,0.2)", color: "#fff",
            }}>
              <Box>
                <Typography sx={{ fontSize: 11, opacity: 0.7, fontWeight: 500 }}>
                  {selectedIds.size} invoice{selectedIds.size !== 1 ? "s" : ""} selected
                </Typography>
                <Typography sx={{ fontSize: 24, fontWeight: 800, letterSpacing: "-0.02em" }}>
                  ${selectedTotal.toFixed(2)}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button variant="text" onClick={selectNone}
                  sx={{ color: "rgba(255,255,255,0.7)", textTransform: "none", fontSize: 12, "&:hover": { color: "#fff" } }}>
                  Clear
                </Button>
                <Button variant="contained" onClick={handlePay} disabled={paying}
                  sx={{
                    bgcolor: "rgba(255,255,255,0.2)", color: "#fff",
                    textTransform: "none", fontSize: 14, fontWeight: 700, borderRadius: "12px", px: 4,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    "&:hover": { bgcolor: "rgba(255,255,255,0.3)" },
                  }}>
                  {paying ? <CircularProgress size={20} color="inherit" /> : "Pay Now"}
                </Button>
              </Box>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

// ════════════════════════════════════════
// Messages
// ════════════════════════════════════════

type MessageItem = {
  id: number;
  subject: string;
  body: string;
  channel: string;
  status: string;
  direction: string;
  sent_at: string | null;
  date: string | null;
  read: boolean;
  read_at: string | null;
  sender: { id: number | null; name: string; email: string | null };
  recipient: { parent_id: number | null; name: string; email: string | null; display: string };
  student: { id: number | null; name: string };
};

const channelBadge = (channel: string) => {
  const map: Record<string, { label: string; bg: string; fg: string }> = {
    email:   { label: "Email",          bg: "#dbeafe", fg: "#1d4ed8" },
    portal:  { label: "Portal Message", bg: "#dcfce7", fg: "#166534" },
    sms:     { label: "SMS",            bg: "#ede9fe", fg: "#6d28d9" },
  };
  const c = map[channel] || map.email;
  return (
    <Chip
      size="small"
      label={c.label}
      sx={{ bgcolor: c.bg, color: c.fg, fontWeight: 700, fontSize: 10.5, height: 22, "& .MuiChip-label": { px: 1 } }}
    />
  );
};

const statusBadge = (status: string) => {
  const map: Record<string, { label: string; bg: string; fg: string }> = {
    sent:      { label: "Sent",      bg: "#dcfce7", fg: "#166534" },
    delivered: { label: "Delivered", bg: "#dcfce7", fg: "#166534" },
    failed:    { label: "Failed",    bg: "#fee2e2", fg: "#991b1b" },
    read:      { label: "Read",      bg: "#e0f2fe", fg: "#075985" },
  };
  const c = map[status] || map.sent;
  return (
    <Chip
      size="small"
      label={c.label}
      sx={{ bgcolor: c.bg, color: c.fg, fontWeight: 700, fontSize: 10.5, height: 22, "& .MuiChip-label": { px: 1 } }}
    />
  );
};

const SummaryTile: React.FC<{
  label: string; value: number; icon: React.ReactNode; color: string; active: boolean; onClick: () => void;
}> = ({ label, value, icon, color, active, onClick }) => (
  <Box
    role="button" tabIndex={0}
    aria-pressed={active}
    onClick={onClick}
    onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(); } }}
    sx={{
      flex: 1, minWidth: 130,
      bgcolor: "#fff", borderRadius: "12px",
      border: `1.5px solid ${active ? color : "rgba(0,0,0,0.06)"}`,
      boxShadow: active ? `0 4px 12px ${alpha(color, 0.15)}` : "0 1px 3px rgba(0,0,0,0.03)",
      p: 1.75, cursor: "pointer",
      transition: "all .15s ease",
      "&:hover": { borderColor: color, boxShadow: `0 4px 12px ${alpha(color, 0.1)}` },
      "&:focus-visible": { outline: `2px solid ${color}`, outlineOffset: 2 },
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
      <Box sx={{
        width: 36, height: 36, borderRadius: "10px",
        bgcolor: alpha(color, 0.1), color, display: "flex",
        alignItems: "center", justifyContent: "center", "& svg": { fontSize: 20 },
      }}>{icon}</Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontSize: 10.5, fontWeight: 700, color: "text.secondary", textTransform: "uppercase", letterSpacing: .6 }}>{label}</Typography>
        <Typography sx={{ fontSize: 20, fontWeight: 800, color: "text.primary", lineHeight: 1.1 }}>{value}</Typography>
      </Box>
    </Box>
  </Box>
);

// ════════════════════════════════════════
// Profile Page — Parent + Student information (Aug 2026)
// ════════════════════════════════════════
//
// Read-only Parent Portal profile page. Uses ONLY data the portal
// already loads:
//   - Parent: useUser() (username, email, user_type, staff/greeting name)
//   - Student: ChildContext.activeChild + useGetChildDashboardQuery
//     for the child's subject_summary + billing_summary
// No new backend endpoint added.
//
// Never displays: password, hash, temporary password, other parents'
// contact info, admin metadata, or DB internals.

// ══════════════════════════════════════════════════════════════════
// Profile & Account (2026-08-24 workspace redesign)
//
// PowerSchool-inspired information architecture, Step Up premium
// visual language. The Profile page is now a tabbed parent account
// workspace instead of a shallow read-only summary. Four tabs:
//
//   Parent Account   — personal + login info, editability transparent
//   Student Profile  — currently-selected student's academic snapshot
//   Linked Students  — every child on this account, "Currently Viewing"
//                      chip on the active one, one-click switch
//   Security         — password change (wired to the real backend
//                      endpoint used by StaffProfile); notification
//                      prefs shown as "Managed by Step Up Academy"
//                      because no parent-self-service endpoint exists
//
// Backend truthfulness rules (spec §6, §24):
//   - Parent self-service edit endpoints DO NOT exist. Every field
//     that isn't updatable is labelled "Managed by Step Up Academy"
//     rather than shown with a fake Edit affordance.
//   - Username cannot be changed (system-locked "STP###" per
//     ParentController::syncAccount) — shown read-only.
//   - Password change reuses POST /user/system/change-password via
//     the existing useChangeUserPasswordSystemMutation hook.
// ══════════════════════════════════════════════════════════════════

/** Compact row used across every settings-style card. Left label,
 *  right value, optional right-aligned action (Edit / Managed chip). */
const AccountRow: React.FC<{
  label: string;
  value: React.ReactNode;
  action?: React.ReactNode;
  icon?: React.ReactNode;
}> = ({ label, value, action, icon }) => (
  <Box sx={{
    display: "flex", alignItems: "center", gap: 1.5,
    minHeight: 60, py: 1.25,
    borderBottom: `1px solid ${pp.color.border}`,
    "&:last-child": { borderBottom: "none" },
  }}>
    {icon && (
      <Box sx={{
        width: 32, height: 32, borderRadius: `${pp.radius.sm}px`,
        bgcolor: pp.surface.blue, color: pp.color.blue,
        display: "flex", alignItems: "center", justifyContent: "center",
        "& svg": { fontSize: 17 }, flexShrink: 0,
      }}>{icon}</Box>
    )}
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography sx={{
        fontSize: 10.5, fontWeight: 800, color: pp.color.muted,
        textTransform: "uppercase", letterSpacing: "0.08em", mb: 0.35,
      }}>
        {label}
      </Typography>
      <Typography sx={{
        fontSize: 13.5, fontWeight: 700, color: pp.color.text,
        overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
      }}>
        {value ?? "—"}
      </Typography>
    </Box>
    {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
  </Box>
);

/** "Managed by Step Up Academy" chip — displayed instead of a fake
 *  Edit button on every field the parent cannot self-service. Honest
 *  UX beats a button that only opens a "contact the school" toast. */
const ManagedChip: React.FC = () => (
  <Chip
    size="small"
    icon={<ShieldOutlinedIcon sx={{ fontSize: "13px !important", color: `${pp.color.muted} !important` }} />}
    label="Managed by school"
    sx={{
      height: 22, fontSize: 10.5, fontWeight: 700,
      bgcolor: pp.surface.grey, color: pp.color.muted,
      border: `1px solid ${pp.color.border}`,
    }}
  />
);

/** Small card section header used at the top of every settings card. */
const SectionHeader: React.FC<{ icon: React.ReactNode; title: string; hint?: string }> = ({ icon, title, hint }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, mb: 1.5 }}>
    <Box sx={{
      width: 30, height: 30, borderRadius: `${pp.radius.sm}px`,
      bgcolor: pp.surface.blue, color: pp.color.blue,
      display: "flex", alignItems: "center", justifyContent: "center",
      "& svg": { fontSize: 17 },
    }}>{icon}</Box>
    <Box sx={{ minWidth: 0 }}>
      <Typography sx={{
        fontSize: 12.5, fontWeight: 800, letterSpacing: "0.06em",
        textTransform: "uppercase", color: pp.color.text,
      }}>
        {title}
      </Typography>
      {hint && (
        <Typography sx={{ fontSize: 11, color: pp.color.muted, mt: 0.15 }}>
          {hint}
        </Typography>
      )}
    </Box>
  </Box>
);

/** Change-password dialog. Wired to the same backend endpoint
 *  (`POST /user/system/change-password`) that StaffProfile already
 *  uses, so no new API surface is introduced. Live requirement list
 *  matches the server-side rule (min 6) plus the strong-password
 *  hints the client wants users to hit. */
const ParentChangePasswordDialog: React.FC<{
  open: boolean;
  onClose: () => void;
}> = ({ open, onClose }) => {
  const { showMessage, showErrorMessage } = useNotifier();
  const [changePassword, { isLoading }] = useChangeUserPasswordSystemMutation();
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const resetAndClose = () => {
    setNewPw(""); setConfirmPw(""); setShowNew(false); setShowConfirm(false);
    onClose();
  };

  // Client-side rule list. `hasMinLength` (>=6) mirrors the server
  // rule so submit stays enabled the moment the backend would accept.
  // The other rules are advisory guidance shown as green ticks — they
  // do not gate submission because the server does not require them.
  const hasMinLength = newPw.length >= 8;
  const hasUpperLower = /[a-z]/.test(newPw) && /[A-Z]/.test(newPw);
  const hasNumber = /\d/.test(newPw);
  const hasSpecial = /[^A-Za-z0-9]/.test(newPw);
  const matches = newPw.length > 0 && newPw === confirmPw;
  const canSubmit = newPw.length >= 6 && matches && !isLoading;

  const submit = async () => {
    if (!canSubmit) return;
    try {
      const res: any = await changePassword({
        userId: "",
        new_password: newPw,
        new_password_confirmation: confirmPw,
      }).unwrap();
      if (res?.status) {
        showMessage(res?.message || "Password updated.");
        resetAndClose();
      } else {
        showErrorMessage(res?.message || "Unable to update password.");
      }
    } catch (e: any) {
      showErrorMessage(e?.data?.message || "Unable to update password.");
    }
  };

  const Requirement: React.FC<{ met: boolean; label: string }> = ({ met, label }) => (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
      <CheckCircleOutlineIcon sx={{
        fontSize: 15,
        color: met ? pp.color.green : pp.color.disabled,
        transition: "color 0.15s",
      }} />
      <Typography sx={{ fontSize: 11.5, color: met ? pp.color.text : pp.color.muted, fontWeight: met ? 700 : 500 }}>
        {label}
      </Typography>
    </Box>
  );

  return (
    <Dialog open={open} onClose={resetAndClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: `${pp.radius.dialog}px` } }}>
      <DialogTitle sx={{ px: 3, py: 2, display: "flex", alignItems: "center", gap: 1.25, borderBottom: `1px solid ${pp.color.border}` }}>
        <Box sx={{
          width: 34, height: 34, borderRadius: `${pp.radius.sm}px`,
          bgcolor: pp.surface.blue, color: pp.color.blue,
          display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          <LockOutlinedIcon fontSize="small" />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography sx={{ fontSize: 15, fontWeight: 800, color: pp.color.text }}>Change Password</Typography>
          <Typography sx={{ fontSize: 11.5, color: pp.color.muted }}>You'll stay signed in on this device.</Typography>
        </Box>
        <IconButton size="small" onClick={resetAndClose}><CloseIcon /></IconButton>
      </DialogTitle>
      <DialogContent sx={{ px: 3, py: 2.5 }}>
        <TextField
          label="New Password"
          type={showNew ? "text" : "password"}
          fullWidth size="small" autoFocus
          value={newPw}
          onChange={(e) => setNewPw(e.target.value)}
          sx={{ mb: 1.5 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton size="small" onClick={() => setShowNew((v) => !v)} aria-label={showNew ? "Hide password" : "Show password"}>
                  {showNew ? <VisibilityOffOutlinedIcon fontSize="small" /> : <VisibilityOutlinedIcon fontSize="small" />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Confirm New Password"
          type={showConfirm ? "text" : "password"}
          fullWidth size="small"
          value={confirmPw}
          onChange={(e) => setConfirmPw(e.target.value)}
          error={confirmPw.length > 0 && !matches}
          helperText={confirmPw.length > 0 && !matches ? "Passwords don't match" : " "}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton size="small" onClick={() => setShowConfirm((v) => !v)} aria-label={showConfirm ? "Hide password" : "Show password"}>
                  {showConfirm ? <VisibilityOffOutlinedIcon fontSize="small" /> : <VisibilityOutlinedIcon fontSize="small" />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Box sx={{
          mt: 1, p: 1.5, borderRadius: `${pp.radius.sm}px`,
          bgcolor: pp.surface.blue, border: `1px solid ${pp.color.border}`,
          display: "flex", flexDirection: "column", gap: 0.5,
        }}>
          <Typography sx={{ fontSize: 11, fontWeight: 800, color: pp.color.muted, textTransform: "uppercase", letterSpacing: "0.08em", mb: 0.25 }}>
            Password strength
          </Typography>
          <Requirement met={hasMinLength} label="At least 8 characters" />
          <Requirement met={hasUpperLower} label="Uppercase and lowercase letters" />
          <Requirement met={hasNumber} label="At least one number" />
          <Requirement met={hasSpecial} label="At least one special character" />
          <Requirement met={matches} label="Passwords match" />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2, borderTop: `1px solid ${pp.color.border}` }}>
        <Button onClick={resetAndClose} sx={{ textTransform: "none", fontWeight: 700, borderRadius: 2 }}>Cancel</Button>
        <Button
          variant="contained" onClick={submit} disabled={!canSubmit}
          sx={{
            textTransform: "none", fontWeight: 800, borderRadius: 2,
            bgcolor: pp.color.blue,
            "&:hover": { bgcolor: pp.color.blue, boxShadow: `0 6px 14px ${alpha(pp.color.blue, 0.30)}` },
          }}
        >
          {isLoading ? "Updating…" : "Update Password"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const ParentProfilePage: React.FC = () => {
  const { userData } = useUser();
  const navigate = useNavigate();
  const { activeChild, selectedChild, setSelectedChild, children } = useChild();
  const { data: dashData, isLoading } = useGetChildDashboardQuery(
    { studentId: selectedChild },
    { skip: !selectedChild },
  );
  const d: any = dashData?.data || null;
  const subj = d?.subject_summary || null;
  const bill = d?.billing_summary || null;

  // Parent identity — only fields the /user/userInfo DTO actually
  // exposes today; NEVER read password/hash. `parent_id` is safe to
  // surface as an internal reference id if present.
  const parentDisplayName = userData?.staff || userData?.username || "Parent";
  const parentEmail = (userData as any)?.email || null;
  const parentUsername = userData?.username || null;
  const parentRoleLabel = (userData as any)?.user_type === "parent" ? "Parent" : "Portal User";
  const parentInitial = (parentDisplayName || "P").charAt(0).toUpperCase();
  const linkedChildrenCount = Array.isArray(children) ? children.length : 0;

  const [tab, setTab] = useState<"account" | "student" | "linked" | "security">("account");
  const [pwOpen, setPwOpen] = useState(false);

  const subjectList: string[] = Array.isArray(subj?.preview)
    ? subj.preview.map((s: any) => s.subject_name).filter(Boolean)
    : [];

  // Preserve `?student_id=` when jumping into other Parent Portal
  // routes from the Student Profile "Academic quick links" tiles.
  const navWithChild = (path: string) => {
    const qs = window.location.search || "";
    navigate({ pathname: path, search: qs });
  };

  return (
    <Box>
      {/* ═══════════ Workspace header — Parent-first, not student-first.
             PowerSchool teaches us the parent account and the student
             are distinct concepts. The header shows the PARENT with a
             quick summary of their linked-student context; the student
             identity lives inside the Student Profile tab. */}
      <PortalCard sx={{
        mb: 2,
        bgcolor: pp.surface.blue,
        border: `1px solid ${pp.color.border}`,
      }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
          <Avatar sx={{
            width: 60, height: 60, fontSize: 22, fontWeight: 800,
            bgcolor: pp.color.blue, color: "#fff",
            boxShadow: `0 0 0 4px ${alpha(pp.color.blue, 0.10)}`,
          }}>
            {parentInitial}
          </Avatar>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ fontSize: 10.5, fontWeight: 800, color: pp.color.muted, letterSpacing: "0.12em", textTransform: "uppercase" }}>
              Parent Portal
            </Typography>
            <Typography sx={{ fontSize: { xs: 20, md: 24 }, fontWeight: 800, color: pp.color.text, letterSpacing: "-0.01em", lineHeight: 1.15, mt: 0.25 }}>
              Profile &amp; Account
            </Typography>
            <Typography sx={{ fontSize: 13, color: pp.color.muted, mt: 0.35 }}>
              Manage your account and review information for your selected student.
            </Typography>
          </Box>
          <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", rowGap: 0.75 }}>
            <Chip
              icon={<PersonOutlineIcon sx={{ fontSize: "14px !important" }} />}
              label={parentDisplayName}
              size="small"
              sx={{ height: 26, fontSize: 12, fontWeight: 700, bgcolor: pp.color.card, color: pp.color.text, border: `1px solid ${pp.color.border}` }}
            />
            <Chip
              icon={<ChildCareIcon sx={{ fontSize: "14px !important" }} />}
              label={`${linkedChildrenCount} linked student${linkedChildrenCount === 1 ? "" : "s"}`}
              size="small"
              sx={{ height: 26, fontSize: 12, fontWeight: 700, bgcolor: pp.surface.blue, color: pp.color.blue, border: `1px solid ${pp.color.border}` }}
            />
            <Chip
              icon={<CheckCircleOutlineIcon sx={{ fontSize: "14px !important", color: `${pp.color.green} !important` }} />}
              label="Active account"
              size="small"
              sx={{ height: 26, fontSize: 12, fontWeight: 700, bgcolor: pp.surface.mint, color: pp.color.green, border: `1px solid ${pp.color.border}` }}
            />
          </Stack>
        </Box>
      </PortalCard>

      {/* ═══════════ Tabs — Parent Account is first because the
             page's own title is Profile & Account and parents most
             commonly land here to check/update their own login. */}
      <Box sx={{
        borderBottom: `1px solid ${pp.color.border}`, mb: 2,
      }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile
          sx={{
            minHeight: 44,
            "& .MuiTab-root": {
              textTransform: "none", fontWeight: 700, fontSize: 13.5,
              color: pp.color.muted, minHeight: 44, px: 2,
            },
            "& .Mui-selected": { color: `${pp.color.blue} !important`, fontWeight: 800 },
            "& .MuiTabs-indicator": { backgroundColor: pp.color.blue, height: 3, borderRadius: 3 },
          }}
        >
          <Tab value="account" label="Parent Account" icon={<AccountCircleOutlinedIcon sx={{ fontSize: 18 }} />} iconPosition="start" />
          <Tab value="student" label="Student Profile" icon={<SchoolOutlinedIcon sx={{ fontSize: 18 }} />} iconPosition="start" />
          <Tab
            value="linked"
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                Linked Students
                {linkedChildrenCount > 0 && (
                  <Box component="span" sx={{
                    display: "inline-flex", alignItems: "center", justifyContent: "center",
                    minWidth: 20, height: 20, px: 0.75, borderRadius: 999,
                    bgcolor: pp.surface.blue, color: pp.color.blue,
                    fontSize: 11, fontWeight: 800,
                  }}>{linkedChildrenCount}</Box>
                )}
              </Box>
            }
            icon={<LinkOutlinedIcon sx={{ fontSize: 18 }} />}
            iconPosition="start"
          />
          <Tab value="security" label="Security &amp; Preferences" icon={<ShieldOutlinedIcon sx={{ fontSize: 18 }} />} iconPosition="start" />
        </Tabs>
      </Box>

      {/* ═══════════ Tab: PARENT ACCOUNT */}
      {tab === "account" && (
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 2 }}>
          {/* Personal information */}
          <PortalCard>
            <SectionHeader
              icon={<PersonOutlineIcon />}
              title="Personal Information"
              hint="Legal identity on file with the school."
            />
            <AccountRow icon={<PersonOutlineIcon />} label="Full Name" value={parentDisplayName} action={<ManagedChip />} />
            <AccountRow icon={<ChildCareIcon />} label="Relationship" value={parentRoleLabel} action={<ManagedChip />} />
            <AccountRow icon={<CallOutlinedIcon />} label="Phone" value={<Typography component="span" sx={{ fontSize: 13.5, color: pp.color.muted, fontStyle: "italic" }}>Not provided</Typography>} action={<ManagedChip />} />
          </PortalCard>

          {/* Login / account information */}
          <PortalCard>
            <SectionHeader
              icon={<AccountCircleOutlinedIcon />}
              title="Login Information"
              hint="Used to sign in to the parent portal."
            />
            <AccountRow icon={<EmailOutlinedIcon />} label="Login Email" value={parentEmail || <Typography component="span" sx={{ fontSize: 13.5, color: pp.color.muted, fontStyle: "italic" }}>Not provided</Typography>} action={<ManagedChip />} />
            <AccountRow icon={<VpnKeyOutlinedIcon />} label="Username" value={parentUsername || "—"} action={<ManagedChip />} />
            <AccountRow icon={<ShieldOutlinedIcon />} label="Account Role" value={<Chip size="small" label={parentRoleLabel} sx={{ height: 22, fontSize: 11, fontWeight: 700, bgcolor: pp.surface.blue, color: pp.color.blue, border: `1px solid ${pp.color.border}` }} />} />
            <AccountRow icon={<CheckCircleOutlineIcon />} label="Portal Status" value={<Chip size="small" label="Active" sx={{ height: 22, fontSize: 11, fontWeight: 700, bgcolor: pp.surface.mint, color: pp.color.green, border: `1px solid ${pp.color.border}` }} />} />
          </PortalCard>

          {/* Managed-by-school info strip — honest UX (spec §6, §24). */}
          <PortalCard sx={{
            gridColumn: { xs: "1", md: "1 / -1" },
            bgcolor: pp.surface.blue, border: `1px solid ${pp.color.border}`,
          }}>
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
              <Box sx={{
                width: 32, height: 32, borderRadius: `${pp.radius.sm}px`,
                bgcolor: pp.color.card, color: pp.color.blue,
                display: "flex", alignItems: "center", justifyContent: "center",
                border: `1px solid ${pp.color.border}`,
                "& svg": { fontSize: 18 }, flexShrink: 0,
              }}>
                <InfoOutlinedIcon />
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography sx={{ fontSize: 13, fontWeight: 800, color: pp.color.text }}>
                  Some fields are managed by the school
                </Typography>
                <Typography sx={{ fontSize: 12.5, color: pp.color.muted, mt: 0.5 }}>
                  To update your legal name, relationship, phone number, or email address, please contact the school office. Your password can be changed anytime in the Security &amp; Preferences tab.
                </Typography>
              </Box>
              <Button
                size="small" variant="outlined"
                onClick={() => setTab("security")}
                startIcon={<LockOutlinedIcon sx={{ fontSize: "16px !important" }} />}
                sx={{
                  textTransform: "none", fontWeight: 800, borderRadius: 2,
                  borderColor: pp.color.blue, color: pp.color.blue,
                  "&:hover": { borderColor: pp.color.blue, bgcolor: alpha(pp.color.blue, 0.06) },
                  flexShrink: 0,
                }}
              >
                Change Password
              </Button>
            </Box>
          </PortalCard>
        </Box>
      )}

      {/* ═══════════ Tab: STUDENT PROFILE */}
      {tab === "student" && (
        !activeChild ? (
          <PortalCard>
            <PortalEmptyState icon={<ChildCareIcon />} title="No student selected" body="Select a student from the Linked Students tab to view their profile." />
          </PortalCard>
        ) : (
          <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 2 }}>
            {/* Compact student identity strip */}
            <PortalCard sx={{ gridColumn: { xs: "1", md: "1 / -1" }, borderTop: `3px solid ${pp.color.blue}` }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
                <Avatar sx={{
                  width: 54, height: 54, fontSize: 20, fontWeight: 800,
                  bgcolor: pp.color.blue, color: "#fff",
                  boxShadow: `0 0 0 3px ${alpha(pp.color.blue, 0.10)}`,
                }}>
                  {(activeChild.studentName || "S").charAt(0).toUpperCase()}
                </Avatar>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography sx={{ fontSize: 10.5, fontWeight: 800, color: pp.color.muted, textTransform: "uppercase", letterSpacing: "0.1em" }}>
                    Currently Viewing
                  </Typography>
                  <Typography sx={{ fontSize: 20, fontWeight: 800, color: pp.color.text, letterSpacing: "-0.01em", lineHeight: 1.15, mt: 0.15 }}>
                    {activeChild.studentName || "Your child"}
                  </Typography>
                  <Stack direction="row" spacing={0.75} sx={{ mt: 0.75, flexWrap: "wrap", rowGap: 0.5 }}>
                    {activeChild.gradeLabel && (
                      <Chip size="small" label={activeChild.gradeLabel} sx={{ height: 22, fontSize: 11, fontWeight: 700, bgcolor: pp.surface.blue, color: pp.color.blue, border: `1px solid ${pp.color.border}` }} />
                    )}
                    <Chip size="small" icon={<CheckCircleOutlineIcon sx={{ fontSize: "13px !important", color: `${pp.color.green} !important` }} />} label="Active" sx={{ height: 22, fontSize: 11, fontWeight: 700, bgcolor: pp.surface.mint, color: pp.color.green, border: `1px solid ${pp.color.border}` }} />
                    {(activeChild as any)?.subjectName && (
                      <Chip size="small" icon={<MenuBookOutlinedIcon sx={{ fontSize: "13px !important", color: `${pp.color.muted} !important` }} />} label={(activeChild as any).subjectName} sx={{ height: 22, fontSize: 11, fontWeight: 700, bgcolor: pp.surface.grey, color: pp.color.text, border: `1px solid ${pp.color.border}` }} />
                    )}
                  </Stack>
                </Box>
              </Box>
            </PortalCard>

            {/* Basic information */}
            <PortalCard>
              <SectionHeader icon={<SchoolOutlinedIcon />} title="Basic Information" />
              {isLoading ? (
                <Box sx={{ py: 2, display: "flex", justifyContent: "center" }}><StepUpSpinner size="small" /></Box>
              ) : (
                <>
                  <AccountRow label="Full Name" value={activeChild.studentName || "—"} />
                  <AccountRow label="Grade" value={activeChild.gradeLabel || "—"} />
                  <AccountRow label="Status" value={<Chip size="small" label="Active" sx={{ height: 20, fontSize: 10.5, fontWeight: 800, bgcolor: pp.surface.mint, color: pp.color.green, border: `1px solid ${pp.color.border}` }} />} />
                  <AccountRow label="Student Reference" value={String(selectedChild ?? "—")} />
                </>
              )}
            </PortalCard>

            {/* Enrolled subjects */}
            <PortalCard>
              <SectionHeader icon={<MenuBookOutlinedIcon />} title="Enrolled Subjects" />
              {isLoading ? (
                <Box sx={{ py: 2, display: "flex", justifyContent: "center" }}><StepUpSpinner size="small" /></Box>
              ) : subjectList.length === 0 ? (
                <PortalEmptyState icon={<MenuBookOutlinedIcon />} title="No enrolled subjects" body="Enrolled subjects will appear here once assigned." compact />
              ) : (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
                  {subjectList.map((s) => (
                    <Chip
                      key={s}
                      label={s}
                      size="small"
                      icon={<MenuBookOutlinedIcon sx={{ fontSize: "14px !important", color: `${pp.color.blue} !important` }} />}
                      sx={{ height: 26, fontSize: 12, fontWeight: 700, bgcolor: pp.surface.blue, color: pp.color.blue, border: `1px solid ${pp.color.border}` }}
                    />
                  ))}
                </Box>
              )}
            </PortalCard>

            {/* Academic quick links — navigate, do not re-render data */}
            <PortalCard sx={{ gridColumn: { xs: "1", md: "1 / -1" } }}>
              <SectionHeader icon={<InsightsOutlinedIcon />} title="Academic Quick Links" hint="Jump into the full section for this student." />
              <Box sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(3, 1fr)", md: "repeat(6, 1fr)" },
                gap: 1,
              }}>
                {[
                  { label: "Time Table",   icon: <EventNoteIcon />,                path: "/parent-portal/classes" },
                  { label: "Attendance",   icon: <FactCheckOutlinedIcon />,        path: "/parent-portal/attendance" },
                  { label: "Assessments",  icon: <AssignmentTurnedInOutlinedIcon />, path: "/parent-portal/assessments" },
                  { label: "Report Cards", icon: <ArticleOutlinedIcon />,          path: "/parent-portal/report-cards" },
                  { label: "Assignments",  icon: <AssignmentOutlinedIcon />,       path: "/parent-portal/assignments" },
                  { label: "Performance",  icon: <InsightsOutlinedIcon />,         path: "/parent-portal/performance" },
                ].map((l) => (
                  <Box
                    key={l.path}
                    role="button" tabIndex={0}
                    onClick={() => navWithChild(l.path)}
                    onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); navWithChild(l.path); } }}
                    sx={{
                      cursor: "pointer",
                      display: "flex", flexDirection: "column", alignItems: "center", gap: 0.75,
                      p: 1.5, borderRadius: `${pp.radius.sm}px`,
                      border: `1px solid ${pp.color.border}`,
                      bgcolor: pp.color.card,
                      transition: pp.transition,
                      "&:hover": { borderColor: pp.color.blue, transform: "translateY(-2px)", boxShadow: pp.shadow.card },
                      "&:focus-visible": { outline: `2px solid ${pp.color.blue}`, outlineOffset: 2 },
                    }}
                  >
                    <Box sx={{
                      width: 32, height: 32, borderRadius: `${pp.radius.sm}px`,
                      bgcolor: pp.surface.blue, color: pp.color.blue,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      "& svg": { fontSize: 18 },
                    }}>{l.icon}</Box>
                    <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: pp.color.text, textAlign: "center" }}>{l.label}</Typography>
                  </Box>
                ))}
              </Box>
            </PortalCard>

            {/* Billing snapshot for this child — only render when real. */}
            {bill && (Number(bill.outstanding) > 0 || bill.last_invoice) && (
              <PortalCard sx={{ gridColumn: { xs: "1", md: "1 / -1" } }}>
                <SectionHeader icon={<PaymentOutlinedIcon />} title="Billing Snapshot" hint="Latest invoice and outstanding balance for this student." />
                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 2 }}>
                  <Box>
                    <Typography sx={{ fontSize: 11, fontWeight: 800, color: pp.color.muted, textTransform: "uppercase", letterSpacing: "0.06em" }}>Outstanding</Typography>
                    <Typography sx={{ fontSize: 24, fontWeight: 800, color: Number(bill.outstanding) > 0 ? pp.color.red : pp.color.green, mt: 0.25 }}>
                      ${Number(bill.outstanding ?? 0).toFixed(2)}
                    </Typography>
                  </Box>
                  {bill.last_invoice && (
                    <Box>
                      <Typography sx={{ fontSize: 11, fontWeight: 800, color: pp.color.muted, textTransform: "uppercase", letterSpacing: "0.06em" }}>Latest Invoice</Typography>
                      <Typography sx={{ fontSize: 14, fontWeight: 700, color: pp.color.text, mt: 0.25 }}>
                        {bill.last_invoice.date ? dayjs(bill.last_invoice.date).format("MMM D, YYYY") : "—"}
                        {bill.last_invoice.amount != null ? ` · $${Number(bill.last_invoice.amount).toFixed(2)}` : ""}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </PortalCard>
            )}
          </Box>
        )
      )}

      {/* ═══════════ Tab: LINKED STUDENTS */}
      {tab === "linked" && (
        children.length === 0 ? (
          <PortalCard>
            <PortalEmptyState icon={<ChildCareIcon />} title="No students linked" body="No students are currently linked to this account. Please contact the school office." />
          </PortalCard>
        ) : (
          <Box sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(3, 1fr)" },
            gap: 2,
          }}>
            {children.map((c: any) => {
              const isCurrent = c.studentId === selectedChild;
              return (
                <PortalCard
                  key={c.studentId}
                  hover
                  onClick={() => setSelectedChild(c.studentId)}
                  sx={isCurrent ? {
                    borderColor: pp.color.blue,
                    boxShadow: `0 0 0 1px ${alpha(pp.color.blue, 0.20)}, ${pp.shadow.card}`,
                  } : {}}
                >
                  <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
                    <Avatar sx={{
                      width: 44, height: 44, fontSize: 15, fontWeight: 800,
                      bgcolor: pp.color.blue, color: "#fff",
                    }}>
                      {(c.studentName || "S").split(/\s+/).filter(Boolean).map((p: string) => p[0]).slice(0, 2).join("").toUpperCase() || "S"}
                    </Avatar>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap" }}>
                        <Typography sx={{ fontSize: 14.5, fontWeight: 800, color: pp.color.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {c.studentName || "Student"}
                        </Typography>
                        {isCurrent && (
                          <Chip
                            size="small"
                            label="Viewing"
                            icon={<CheckCircleOutlineIcon sx={{ fontSize: "12px !important", color: `${pp.color.blue} !important` }} />}
                            sx={{ height: 20, fontSize: 10, fontWeight: 800, bgcolor: pp.surface.blue, color: pp.color.blue, border: `1px solid ${pp.color.border}` }}
                          />
                        )}
                      </Box>
                      <Typography sx={{ fontSize: 12, color: pp.color.muted, mt: 0.25 }}>
                        {[c.gradeLabel || null, "Active"].filter(Boolean).join(" · ")}
                      </Typography>
                      {(c as any)?.subjectName && (
                        <Chip
                          size="small"
                          label={(c as any).subjectName}
                          icon={<MenuBookOutlinedIcon sx={{ fontSize: "12px !important", color: `${pp.color.muted} !important` }} />}
                          sx={{ mt: 1, height: 22, fontSize: 11, fontWeight: 700, bgcolor: pp.surface.grey, color: pp.color.text, border: `1px solid ${pp.color.border}` }}
                        />
                      )}
                    </Box>
                  </Box>
                  <Box sx={{ mt: 1.5, display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      size="small"
                      onClick={(e) => { e.stopPropagation(); setSelectedChild(c.studentId); setTab("student"); }}
                      endIcon={<ArrowForwardIcon sx={{ fontSize: "14px !important" }} />}
                      sx={{ textTransform: "none", fontSize: 12, fontWeight: 800, color: pp.color.blue, borderRadius: 2 }}
                    >
                      {isCurrent ? "View Profile" : "View Student"}
                    </Button>
                  </Box>
                </PortalCard>
              );
            })}
          </Box>
        )
      )}

      {/* ═══════════ Tab: SECURITY & PREFERENCES */}
      {tab === "security" && (
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 2 }}>
          <PortalCard>
            <SectionHeader
              icon={<LockOutlinedIcon />}
              title="Password"
              hint="Change your account password anytime."
            />
            <AccountRow
              icon={<VpnKeyOutlinedIcon />}
              label="Username"
              value={parentUsername || "—"}
              action={<ManagedChip />}
            />
            <AccountRow
              icon={<LockOutlinedIcon />}
              label="Password"
              value={<Typography component="span" sx={{ fontSize: 15, fontWeight: 700, color: pp.color.text, letterSpacing: "0.1em" }}>••••••••</Typography>}
              action={
                <Button
                  size="small" variant="contained"
                  onClick={() => setPwOpen(true)}
                  sx={{
                    textTransform: "none", fontWeight: 800, borderRadius: 2,
                    bgcolor: pp.color.blue, boxShadow: "none",
                    "&:hover": { bgcolor: pp.color.blue, boxShadow: `0 6px 14px ${alpha(pp.color.blue, 0.30)}` },
                  }}
                >
                  Change Password
                </Button>
              }
            />
            <Box sx={{
              mt: 1.5, p: 1.5, borderRadius: `${pp.radius.sm}px`,
              bgcolor: pp.surface.blue, border: `1px solid ${pp.color.border}`,
              display: "flex", alignItems: "flex-start", gap: 1,
            }}>
              <InfoOutlinedIcon sx={{ fontSize: 16, color: pp.color.blue, mt: 0.25 }} />
              <Typography sx={{ fontSize: 12, color: pp.color.text }}>
                Your username was assigned by the school and cannot be changed. If you need help signing in, contact the office.
              </Typography>
            </Box>
          </PortalCard>

          <PortalCard>
            <SectionHeader
              icon={<NotificationsNoneOutlinedIcon />}
              title="Notification Preferences"
              hint="Email, SMS, and payment reminders."
            />
            <AccountRow
              icon={<EmailOutlinedIcon />}
              label="Email Notifications"
              value={<Typography component="span" sx={{ fontSize: 13.5, color: pp.color.muted }}>Set by the school on your account</Typography>}
              action={<ManagedChip />}
            />
            <AccountRow
              icon={<ChatOutlinedIcon />}
              label="SMS Notifications"
              value={<Typography component="span" sx={{ fontSize: 13.5, color: pp.color.muted }}>Set by the school on your account</Typography>}
              action={<ManagedChip />}
            />
            <AccountRow
              icon={<PaymentOutlinedIcon />}
              label="Payment Reminders"
              value={<Typography component="span" sx={{ fontSize: 13.5, color: pp.color.muted }}>Set by the school on your account</Typography>}
              action={<ManagedChip />}
            />
            <Box sx={{
              mt: 1.5, p: 1.5, borderRadius: `${pp.radius.sm}px`,
              bgcolor: pp.surface.grey, border: `1px solid ${pp.color.border}`,
              display: "flex", alignItems: "flex-start", gap: 1,
            }}>
              <InfoOutlinedIcon sx={{ fontSize: 16, color: pp.color.muted, mt: 0.25 }} />
              <Typography sx={{ fontSize: 12, color: pp.color.muted }}>
                Notification channels are currently managed by the school office. Self-service toggles will appear here when they become available.
              </Typography>
            </Box>
          </PortalCard>
        </Box>
      )}

      <ParentChangePasswordDialog open={pwOpen} onClose={() => setPwOpen(false)} />
    </Box>
  );
};

const ParentMessagesPage: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { children, selectedChild, setSelectedChild } = useChild();
  const location = useLocation();
  const navigate = useNavigate();
  const { showMessage, showErrorMessage } = useNotifier();

  const [markRead] = useMarkParentMessageReadMutation();

  // ── Manual-message composer (Aug 2026) ─────────────────────────────
  // Opens either from the "+ New Message" header button or via URL
  // query params (?compose=1&studentId=…&occurrenceId=…&staffUserId=…
  // &subject=…&body=…) so the class-detail page's Message Teacher
  // button can jump straight into a pre-filled composer without a
  // dedicated shared-state bus.
  const [composerOpen, setComposerOpen] = useState(false);
  const [composerStudentId, setComposerStudentId] = useState<number | null>(null);
  const [composerOccurrenceId, setComposerOccurrenceId] = useState<number | null>(null);
  const [composerScheduleId, setComposerScheduleId] = useState<number | null>(null);
  const [composerClassLabel, setComposerClassLabel] = useState<string>("");
  const [composerRecipient, setComposerRecipient] = useState<number | "">("");
  const [composerSubject, setComposerSubject] = useState("");
  const [composerBody, setComposerBody] = useState("");
  const [fetchRecipients, { data: recipientsResp, isFetching: recipientsLoading }] = useLazyGetParentMessageRecipientsQuery();
  const [sendMsg, { isLoading: sending }] = useSendParentMessageMutation();
  const eligibleRecipients: { staff_id: number; user_id: number; name: string; role?: string }[] =
    ((recipientsResp?.data as any) || []) as any;

  const openComposer = React.useCallback((opts?: {
    studentId?: number | null;
    occurrenceId?: number | null;
    scheduleId?: number | null;
    classLabel?: string;
    staffUserId?: number | null;
    subject?: string;
    body?: string;
  }) => {
    const sid = opts?.studentId ?? selectedChild ?? null;
    setComposerStudentId(sid);
    setComposerOccurrenceId(opts?.occurrenceId ?? null);
    setComposerScheduleId(opts?.scheduleId ?? null);
    setComposerClassLabel(opts?.classLabel ?? "");
    setComposerRecipient(opts?.staffUserId ?? "");
    setComposerSubject(opts?.subject ?? "");
    setComposerBody(opts?.body ?? "");
    setComposerOpen(true);
    if (sid) fetchRecipients({ student_id: sid });
  }, [selectedChild, fetchRecipients]);

  const closeComposer = () => {
    setComposerOpen(false);
    setComposerStudentId(null);
    setComposerOccurrenceId(null);
    setComposerScheduleId(null);
    setComposerClassLabel("");
    setComposerRecipient("");
    setComposerSubject("");
    setComposerBody("");
    // Strip ?compose=… params so a page refresh doesn't reopen the dialog.
    if (location.search.includes("compose=")) navigate("/parent-portal/messages", { replace: true });
  };

  // Read URL params on mount / when they change.
  React.useEffect(() => {
    const p = new URLSearchParams(location.search);
    if (p.get("compose") !== "1") return;
    openComposer({
      studentId: p.get("studentId") ? Number(p.get("studentId")) : (selectedChild ?? null),
      occurrenceId: p.get("occurrenceId") ? Number(p.get("occurrenceId")) : null,
      scheduleId: p.get("scheduleId") ? Number(p.get("scheduleId")) : null,
      classLabel: p.get("classLabel") || "",
      staffUserId: p.get("staffUserId") ? Number(p.get("staffUserId")) : null,
      subject: p.get("subject") || "",
      body: p.get("body") || "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const trimmedSubject = composerSubject.trim();
  const trimmedBody = composerBody.trim();
  const canSend =
    !!composerRecipient &&
    !!composerStudentId &&
    trimmedSubject.length >= 3 && trimmedSubject.length <= 150 &&
    trimmedBody.length >= 3 && trimmedBody.length <= 5000 &&
    !sending;

  const handleSend = async () => {
    if (!canSend) return;
    try {
      const r = await sendMsg({
        student_id: composerStudentId,
        recipient_user_id: composerRecipient,
        subject: trimmedSubject,
        body: trimmedBody,
        class_occurrence_id: composerOccurrenceId || undefined,
        class_schedule_id: composerScheduleId || undefined,
      }).unwrap();
      if (r.status) {
        const to = eligibleRecipients.find((x) => x.user_id === composerRecipient)?.name;
        showMessage(to ? `Message sent to ${to}.` : "Message sent.");
        closeComposer();
      } else {
        showErrorMessage(r.message || "Failed to send message.");
      }
    } catch (e: any) {
      showErrorMessage(e?.data?.message || "Failed to send message.");
    }
  };

  const [folder, setFolder] = useState<"all" | "inbox" | "sent" | "unread">("all");
  const [channelFilter, setChannelFilter] = useState<"all" | "email" | "portal" | "sms">("all");
  // Phase-5 polish: default the childFilter to the globally selected
  // child so navigating from Dashboard scopes the inbox too. Family-
  // level messages (student_id IS NULL) remain visible because the
  // backend treats an explicit child_id as "this child OR family-level".
  const [childFilter, setChildFilter] = useState<"all" | number>(selectedChild ?? "all");
  React.useEffect(() => {
    if (selectedChild) setChildFilter(selectedChild);
  }, [selectedChild]);
  const [search, setSearch] = useState("");
  const [selectedId, setSelectedId] = useState<number | null>(null);

  const { data, isLoading, isError } = useGetParentMessagesQuery({
    child_id: childFilter === "all" ? undefined : childFilter,
    folder,
    channel: channelFilter,
    search,
  });

  const messages: MessageItem[] = useMemo(() => {
    const list = Array.isArray(data?.data) ? (data!.data as MessageItem[]) : [];
    return list;
  }, [data]);

  const summary = (data as any)?.summary || { all: 0, unread: 0, sentToMe: 0, sentByMe: 0 };

  const selected = useMemo(
    () => messages.find((m) => m.id === selectedId) || null,
    [messages, selectedId]
  );

  React.useEffect(() => {
    if (!isMobile && !selectedId && messages.length > 0) setSelectedId(messages[0].id);
  }, [messages, isMobile, selectedId]);

  // Mark unread portal messages as read when the parent opens them.
  // Server enforces `receiverId === auth user` so a hostile id can't
  // touch someone else's row.
  React.useEffect(() => {
    if (!selectedId) return;
    const m = messages.find((x) => x.id === selectedId) as any;
    if (m && m.channel === "portal" && m.direction === "inbound_to_parent" && !m.read) {
      markRead({ id: selectedId }).catch(() => { /* silent */ });
    }
  }, [selectedId, messages, markRead]);

  const formatDate = (iso: string | null) =>
    iso ? dayjs(iso).format("MMM D, YYYY [at] h:mm A") : "—";

  return (
    <Box>
      <Box sx={{ mb: 2.5, display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 2, flexWrap: "wrap" }}>
        <Box>
          <Typography sx={{ fontSize: 11, fontWeight: 600, color: "text.disabled", textTransform: "uppercase", letterSpacing: "0.08em", mb: 0.5 }}>
            Parent Portal
          </Typography>
          <Typography sx={{ fontSize: 22, fontWeight: 700, letterSpacing: "-0.02em" }}>Messages</Typography>
          <Typography sx={{ fontSize: 13, color: "text.secondary", mt: 0.5 }}>
            View communications about your children and message authorized staff.
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => openComposer()}
          disabled={!selectedChild}
          sx={{
            textTransform: "none", fontWeight: 700, borderRadius: "10px", px: 2.5, py: 1,
            bgcolor: "#16a34a", boxShadow: "none",
            "&:hover": { bgcolor: "#15803d", boxShadow: "none" },
          }}
        >
          New Message
        </Button>
      </Box>

      <ChildSelectorBar />

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mb: 2 }}>
        <SummaryTile label="All Messages" value={summary.all}      icon={<MailOutlineIcon />}          color="#2563eb"
          active={folder === "all"}    onClick={() => setFolder("all")} />
        <SummaryTile label="Unread"       value={summary.unread}   icon={<CircleIcon />}               color="#f59e0b"
          active={folder === "unread"} onClick={() => setFolder("unread")} />
        <SummaryTile label="Sent to Me"   value={summary.sentToMe} icon={<InboxOutlinedIcon />}        color="#16a34a"
          active={folder === "inbox"}  onClick={() => setFolder("inbox")} />
        <SummaryTile label="Sent by Me"   value={summary.sentByMe} icon={<SendOutlinedIcon />}         color="#6d28d9"
          active={folder === "sent"}   onClick={() => setFolder("sent")} />
      </Box>

      <Box sx={{
        bgcolor: "#fff", borderRadius: "12px",
        border: "1px solid rgba(0,0,0,0.06)", boxShadow: "0 1px 3px rgba(0,0,0,0.03)",
        p: 1.5, mb: 2,
        display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center",
      }}>
        <TextField
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search subject, body, or recipient…"
          sx={{ flex: 1, minWidth: 220, "& .MuiOutlinedInput-root": { borderRadius: "10px", height: 38, fontSize: 13, bgcolor: "#f9fafb" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ fontSize: 18, color: "text.disabled" }} />
              </InputAdornment>
            ),
          }}
        />
        {children.length > 1 && (
          <FormControl size="small" sx={{ minWidth: 160 }}>
            <Select
              value={childFilter === "all" ? "all" : String(childFilter)}
              onChange={(e) => {
                const v = e.target.value;
                setChildFilter(v === "all" ? "all" : Number(v));
                setSelectedId(null);
              }}
              sx={{ fontSize: 13, borderRadius: "10px", height: 38, bgcolor: "#f9fafb" }}
            >
              <MenuItem value="all" sx={{ fontSize: 13 }}>All Children</MenuItem>
              {children.map((c: any) => (
                <MenuItem key={c.studentId} value={String(c.studentId)} sx={{ fontSize: 13 }}>
                  {c.studentName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <Select
            value={channelFilter}
            onChange={(e) => setChannelFilter(e.target.value as any)}
            sx={{ fontSize: 13, borderRadius: "10px", height: 38, bgcolor: "#f9fafb" }}
          >
            <MenuItem value="all" sx={{ fontSize: 13 }}>All Channels</MenuItem>
            <MenuItem value="email" sx={{ fontSize: 13 }}>Email</MenuItem>
            <MenuItem value="portal" sx={{ fontSize: 13 }}>Portal Message</MenuItem>
            <MenuItem value="sms" sx={{ fontSize: 13 }}>SMS</MenuItem>
          </Select>
        </FormControl>
      </Box>

      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <StepUpSpinner size="medium" />
        </Box>
      ) : isError ? (
        <Box sx={{ bgcolor: "#fff", borderRadius: "12px", border: "1px solid rgba(0,0,0,0.06)", p: 4, textAlign: "center" }}>
          <Typography sx={{ fontSize: 14, color: "#b91c1c", fontWeight: 700 }}>Unable to load messages.</Typography>
        </Box>
      ) : messages.length === 0 ? (
        <Box sx={{ bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)", textAlign: "center", py: 6, px: 3 }}>
          <Box sx={{
            width: 60, height: 60, borderRadius: "14px",
            bgcolor: alpha(theme.palette.primary.main, 0.08),
            display: "flex", alignItems: "center", justifyContent: "center",
            mx: "auto", mb: 2, "& svg": { fontSize: 28, color: theme.palette.primary.main },
          }}>
            <MailOutlineIcon />
          </Box>
          <Typography sx={{ fontSize: 15, fontWeight: 700, mb: 0.5 }}>No messages yet</Typography>
          <Typography sx={{ fontSize: 13, color: "text.secondary", maxWidth: 380, mx: "auto", mb: 2 }}>
            Start a conversation with your child's teacher or authorized Step Up staff.
          </Typography>
          <Button
            variant="contained" startIcon={<AddIcon />}
            onClick={() => openComposer()}
            disabled={!selectedChild}
            sx={{ textTransform: "none", fontWeight: 700, borderRadius: "10px", bgcolor: "#16a34a", boxShadow: "none", "&:hover": { bgcolor: "#15803d", boxShadow: "none" } }}
          >
            New Message
          </Button>
        </Box>
      ) : (
        <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start", flexDirection: { xs: "column", md: "row" } }}>
          {(!isMobile || !selectedId) && (
            <Box sx={{
              width: { xs: "100%", md: "35%" }, flexShrink: 0,
              bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)",
              boxShadow: "0 1px 3px rgba(0,0,0,0.03)", overflow: "hidden",
              maxHeight: { md: "calc(100vh - 320px)" }, overflowY: "auto",
            }}>
              {messages.map((m) => {
                const isSelected = selectedId === m.id;
                const initials = (m.sender?.name || "?").split(/\s+/).filter(Boolean).map((p) => p[0]).slice(0, 2).join("").toUpperCase();
                return (
                  <Box
                    key={m.id}
                    onClick={() => setSelectedId(m.id)}
                    sx={{
                      display: "flex", alignItems: "flex-start", gap: 1.25,
                      p: 1.75, cursor: "pointer",
                      borderBottom: "1px solid rgba(0,0,0,0.04)",
                      bgcolor: isSelected ? alpha(theme.palette.primary.main, 0.06) : (m.read ? "transparent" : alpha("#2196f3", 0.03)),
                      borderLeft: `3px solid ${isSelected ? theme.palette.primary.main : (m.read ? "transparent" : "#2196f3")}`,
                      "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.04) },
                    }}
                  >
                    <Avatar sx={{ width: 34, height: 34, fontSize: 12, fontWeight: 700, bgcolor: alpha(theme.palette.primary.main, 0.1), color: theme.palette.primary.main }}>
                      {initials || "?"}
                    </Avatar>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Box sx={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 1 }}>
                        <Typography sx={{ fontSize: 12.5, fontWeight: m.read ? 600 : 800, color: "text.primary", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {m.sender?.name || "Unknown"}
                        </Typography>
                        <Typography sx={{ fontSize: 10.5, color: "text.secondary", flexShrink: 0 }}>
                          {m.sent_at ? dayjs(m.sent_at).format("MMM D") : ""}
                        </Typography>
                      </Box>
                      <Typography sx={{ fontSize: 12.5, fontWeight: m.read ? 500 : 700, color: "text.primary", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", mt: 0.25 }}>
                        {m.subject || "(no subject)"}
                      </Typography>
                      <Typography sx={{ fontSize: 11.5, color: "text.secondary", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", mt: 0.25 }}>
                        Regarding: <b>{m.student?.name || "—"}</b>
                      </Typography>
                      <Box sx={{ display: "flex", gap: 0.5, mt: 0.75, alignItems: "center" }}>
                        {channelBadge(m.channel)}
                        {statusBadge(m.status)}
                      </Box>
                    </Box>
                  </Box>
                );
              })}
            </Box>
          )}

          {(!isMobile || selectedId) && (
            <Box sx={{
              flex: 1, width: { xs: "100%", md: "auto" },
              bgcolor: "#fff", borderRadius: "14px",
              border: "1px solid rgba(0,0,0,0.06)",
              boxShadow: "0 1px 3px rgba(0,0,0,0.03)",
              minWidth: 0,
            }}>
              {selected ? (
                <>
                  <Box sx={{ px: 3, py: 2, borderBottom: "1px solid rgba(0,0,0,0.06)" }}>
                    {isMobile && (
                      <Button
                        onClick={() => setSelectedId(null)}
                        startIcon={<ArrowBackIcon sx={{ fontSize: 18 }} />}
                        sx={{ textTransform: "none", fontSize: 12.5, fontWeight: 700, mb: 1, color: "text.secondary" }}
                      >
                        Back to Messages
                      </Button>
                    )}
                    <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 2, flexWrap: "wrap" }}>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography sx={{ fontSize: 17, fontWeight: 700, color: "text.primary", mb: 0.5, wordBreak: "break-word" }}>
                          {selected.subject || "(no subject)"}
                        </Typography>
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
                          {channelBadge(selected.channel)}
                          {statusBadge(selected.status)}
                        </Box>
                      </Box>
                      <Typography sx={{ fontSize: 12, color: "text.secondary", flexShrink: 0 }}>
                        {formatDate(selected.sent_at)}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ px: 3, py: 2, borderBottom: "1px solid rgba(0,0,0,0.06)", bgcolor: "#f9fafb" }}>
                    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "auto 1fr" }, columnGap: 2, rowGap: 1 }}>
                      <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: "text.secondary", textTransform: "uppercase", letterSpacing: .4 }}>From</Typography>
                      <Typography sx={{ fontSize: 13, color: "text.primary", wordBreak: "break-word" }}>
                        <b>{selected.sender?.name || "System"}</b>
                        {selected.sender?.email ? <Typography component="span" sx={{ color: "text.secondary", fontSize: 12.5, ml: 0.5 }}>&lt;{selected.sender.email}&gt;</Typography> : null}
                      </Typography>

                      <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: "text.secondary", textTransform: "uppercase", letterSpacing: .4 }}>To</Typography>
                      <Typography sx={{ fontSize: 13, color: "text.primary", wordBreak: "break-word" }}>
                        {selected.recipient?.display || selected.recipient?.email || "—"}
                      </Typography>

                      <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: "text.secondary", textTransform: "uppercase", letterSpacing: .4 }}>Regarding</Typography>
                      <Typography sx={{ fontSize: 13, color: "text.primary", fontWeight: 700 }}>
                        {selected.student?.name || "—"}
                      </Typography>

                      <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: "text.secondary", textTransform: "uppercase", letterSpacing: .4 }}>Sent</Typography>
                      <Typography sx={{ fontSize: 13, color: "text.primary" }}>
                        {formatDate(selected.sent_at)}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ px: 3, py: 2.5, maxHeight: { md: "calc(100vh - 480px)" }, overflowY: "auto" }}>
                    <Box
                      sx={{
                        fontSize: 13.5, color: "text.primary", lineHeight: 1.65,
                        "& p": { m: 0, mb: 1 },
                        "& img": { maxWidth: "100%" },
                        wordBreak: "break-word",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: (selected.body || "").replace(/<script[\s\S]*?<\/script>/gi, ""),
                      }}
                    />
                  </Box>
                </>
              ) : (
                <Box sx={{ p: 6, textAlign: "center" }}>
                  <MarkEmailReadOutlinedIcon sx={{ fontSize: 40, color: "text.disabled", mb: 1 }} />
                  <Typography sx={{ fontSize: 14, color: "text.secondary" }}>
                    Select a message on the left to read the full details.
                  </Typography>
                </Box>
              )}
            </Box>
          )}
        </Box>
      )}

      {/* ══════════ Manual Message Composer ══════════
          Recipient list, subject/body validation, and the send call
          all re-check parent→student→staff on the server (see
          ParentPortalController::sendMessage). The dropdown is a
          convenience — the send path never trusts the recipient id
          in isolation. */}
      {/* ══════════ New Message composer — premium redesign ══════════
          Same fields, same validation, same send behavior — richer
          presentation. Shell: 20px radius + layered shadow, tinted
          brand-green header strip with a chat icon tile and close
          button, contextual "Regarding" card with student avatar,
          bigger comfortable inputs with brand focus glow, taller
          message textarea with helper hint, sticky separated footer
          with a stronger primary CTA. */}
      <Dialog
        open={composerOpen}
        onClose={closeComposer}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: { xs: "18px", sm: "22px" },
            overflow: "hidden",
            boxShadow: "0 24px 60px rgba(15,30,51,0.24), 0 8px 20px rgba(15,30,51,0.10)",
          },
        }}
      >
        {(() => {
          const child = children.find((c: any) => c.studentId === composerStudentId);
          const initials = (child?.studentName || "?").split(/\s+/).filter(Boolean).map((p: string) => p[0]).slice(0, 2).join("").toUpperCase() || "?";
          const subjectErr = composerSubject.length > 0 && trimmedSubject.length < 3;
          const bodyErr = composerBody.length > 0 && trimmedBody.length < 3;
          const inputSx = {
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px",
              fontSize: 13.5,
              bgcolor: "#fff",
              transition: "all 180ms",
              "& fieldset": { borderColor: "rgba(15,30,51,0.14)", transition: "all 180ms" },
              "&:hover fieldset": { borderColor: pp.color.deepGreen },
              "&.Mui-focused fieldset": { borderColor: pp.color.deepGreen, borderWidth: "1px" },
              "&.Mui-focused": { boxShadow: `0 0 0 3px ${alpha(pp.color.green, 0.14)}` },
              "&.Mui-error fieldset": { borderColor: "#ef4444" },
              "&.Mui-error.Mui-focused": { boxShadow: "0 0 0 3px rgba(239,68,68,0.14)" },
            },
            "& .MuiFormHelperText-root": { fontSize: 11.5, mt: 0.5, ml: 0.5 },
          } as const;
          const labelSx = {
            fontSize: 11.5, fontWeight: 700,
            color: pp.color.text, mb: 0.75,
            textTransform: "uppercase" as const,
            letterSpacing: "0.06em" as const,
          };

          return (
            <>
              {/* ── Premium header strip ── */}
              <Box sx={{
                position: "relative",
                px: { xs: 2.5, sm: 3 }, py: { xs: 2.25, sm: 2.5 },
                bgcolor: pp.surface.mint,
                borderBottom: `1px solid ${pp.color.border}`,
              }}>
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
                  <Box sx={{
                    width: 44, height: 44, borderRadius: "12px",
                    bgcolor: pp.color.deepGreen, color: "#fff",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    boxShadow: `0 8px 20px ${alpha(pp.color.green, 0.35)}`,
                    flexShrink: 0,
                    "& svg": { fontSize: 22 },
                  }}>
                    <ChatOutlinedIcon />
                  </Box>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography sx={{ fontSize: 18, fontWeight: 800, color: pp.color.text, letterSpacing: "-0.01em", lineHeight: 1.2 }}>
                      New Message
                    </Typography>
                    <Typography sx={{ fontSize: 12.5, color: pp.color.muted, mt: 0.5, lineHeight: 1.4 }}>
                      Send a message to an authorized Step Up staff member regarding your selected child.
                    </Typography>
                  </Box>
                  <IconButton
                    onClick={closeComposer}
                    size="small"
                    aria-label="Close new message"
                    sx={{
                      color: pp.color.muted,
                      "&:hover": { bgcolor: alpha(pp.color.deepGreen, 0.08), color: pp.color.deepGreen },
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>
              </Box>

              {/* ── Form body ── */}
              <DialogContent sx={{ px: { xs: 2.5, sm: 3 }, py: 2.5, bgcolor: "#FAFBFD" }}>
                {/* Regarding — contextual card, not a disabled input */}
                <Box sx={{
                  display: "flex", alignItems: "center", gap: 1.5,
                  p: 1.75, mb: 2.5,
                  borderRadius: "14px",
                  bgcolor: pp.surface.mint,
                  border: `1px solid ${alpha(pp.color.green, 0.20)}`,
                }}>
                  <Avatar sx={{
                    width: 42, height: 42,
                    fontSize: 14, fontWeight: 800,
                    bgcolor: pp.color.deepGreen, color: "#fff",
                    boxShadow: `0 0 0 3px ${pp.color.card}, 0 0 0 4px ${alpha(pp.color.green, 0.25)}`,
                  }}>
                    {initials}
                  </Avatar>
                  <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography sx={{
                      fontSize: 10.5, fontWeight: 700, color: pp.color.muted,
                      textTransform: "uppercase", letterSpacing: "0.1em",
                    }}>
                      Regarding
                    </Typography>
                    <Typography sx={{ fontSize: 15, fontWeight: 800, color: pp.color.text, mt: 0.25, letterSpacing: "-0.01em" }}>
                      {child?.studentName || "Select a child"}
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexWrap: "wrap", mt: 0.5 }}>
                      {child?.gradeLabel && (
                        <Chip label={child.gradeLabel} size="small" sx={{
                          height: 20, fontSize: 10.5, fontWeight: 700,
                          bgcolor: alpha(pp.color.green, 0.10), color: pp.color.deepGreen,
                        }} />
                      )}
                      {composerClassLabel && (
                        <Chip
                          label={composerClassLabel}
                          size="small"
                          sx={{
                            height: 20, fontSize: 10.5, fontWeight: 700,
                            bgcolor: pp.surface.blue, color: pp.color.text,
                            maxWidth: 260,
                            "& .MuiChip-label": { overflow: "hidden", textOverflow: "ellipsis" },
                          }}
                        />
                      )}
                    </Box>
                  </Box>
                </Box>

                {/* Send To */}
                <Box sx={{ mb: 2 }}>
                  <Typography sx={labelSx}>Send To *</Typography>
                  <FormControl fullWidth size="small">
                    <Select
                      value={composerRecipient === "" ? "" : String(composerRecipient)}
                      onChange={(e) => setComposerRecipient(e.target.value ? Number(e.target.value) : "")}
                      displayEmpty
                      disabled={recipientsLoading || eligibleRecipients.length === 0}
                      MenuProps={{ PaperProps: { sx: { mt: 0.5, borderRadius: "12px", boxShadow: "0 12px 32px rgba(15,30,51,0.14)" } } }}
                      sx={{
                        fontSize: 13.5, borderRadius: "12px", bgcolor: "#fff",
                        transition: "all 180ms",
                        "& fieldset": { borderColor: "rgba(15,30,51,0.14)", transition: "all 180ms" },
                        "&:hover fieldset": { borderColor: pp.color.deepGreen },
                        "&.Mui-focused fieldset": { borderColor: pp.color.deepGreen, borderWidth: "1px" },
                        "&.Mui-focused": { boxShadow: `0 0 0 3px ${alpha(pp.color.green, 0.14)}` },
                      }}
                    >
                      <MenuItem value="" sx={{ fontSize: 13, color: pp.color.muted }}>
                        {recipientsLoading ? "Loading eligible staff…" : eligibleRecipients.length === 0 ? "No eligible staff for this child" : "Choose a recipient…"}
                      </MenuItem>
                      {eligibleRecipients.map((r) => (
                        <MenuItem key={r.user_id} value={String(r.user_id)} sx={{ fontSize: 13.5, fontWeight: 600 }}>
                          {r.name}{r.role ? ` · ${r.role}` : ""}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                {/* Subject */}
                <Box sx={{ mb: 2 }}>
                  <Typography sx={labelSx}>Subject *</Typography>
                  <TextField
                    fullWidth size="small"
                    value={composerSubject}
                    onChange={(e) => setComposerSubject(e.target.value)}
                    placeholder="e.g. Question about today's class"
                    inputProps={{ maxLength: 150 }}
                    error={subjectErr}
                    helperText={subjectErr ? "Please enter at least 3 characters." : " "}
                    sx={inputSx}
                  />
                </Box>

                {/* Message */}
                <Box>
                  <Box sx={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", mb: 0.75 }}>
                    <Typography sx={{ ...labelSx, mb: 0 }}>Message *</Typography>
                    <Typography sx={{ fontSize: 11, color: bodyErr ? "#ef4444" : pp.color.muted, fontWeight: 600 }}>
                      {trimmedBody.length}/5000
                    </Typography>
                  </Box>
                  <TextField
                    fullWidth multiline rows={7} size="small"
                    value={composerBody}
                    onChange={(e) => setComposerBody(e.target.value)}
                    placeholder="Type your message here…"
                    inputProps={{ maxLength: 5000 }}
                    error={bodyErr}
                    helperText={bodyErr
                      ? "Please enter at least 3 characters."
                      : "Be clear and specific so staff can respond quickly."}
                    sx={inputSx}
                  />
                </Box>
              </DialogContent>

              {/* ── Footer action bar ── */}
              <DialogActions sx={{
                px: { xs: 2.5, sm: 3 }, py: 2,
                borderTop: `1px solid ${pp.color.border}`,
                bgcolor: pp.color.card,
                gap: 1,
              }}>
                <Button
                  onClick={closeComposer}
                  sx={{
                    textTransform: "none", fontWeight: 700, borderRadius: "12px",
                    color: pp.color.muted, px: 2.25, height: 40,
                    "&:hover": { bgcolor: alpha(pp.color.muted, 0.06), color: pp.color.text },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={handleSend}
                  disabled={!canSend}
                  startIcon={sending
                    ? <CircularProgress size={16} color="inherit" />
                    : <SendIcon sx={{ fontSize: 18 }} />}
                  sx={{
                    textTransform: "none", fontWeight: 800, fontSize: 13.5,
                    borderRadius: "12px", px: 2.75, height: 40,
                    color: "#fff",
                    bgcolor: pp.color.deepGreen,
                    boxShadow: `0 6px 16px ${alpha(pp.color.green, 0.32)}`,
                    transition: "all 180ms",
                    "&:hover": {
                      bgcolor: "#0F725D",
                      transform: "translateY(-1px)",
                      boxShadow: `0 10px 24px ${alpha(pp.color.green, 0.42)}`,
                    },
                    "&:active": { transform: "translateY(0)" },
                    "&.Mui-disabled": {
                      background: "#E5E7EB", color: "#9CA3AF",
                      boxShadow: "none",
                    },
                  }}
                >
                  {sending ? "Sending…" : "Send Message"}
                </Button>
              </DialogActions>
            </>
          );
        })()}
      </Dialog>
    </Box>
  );
};

export default ParentPortalLayout;
